(function () {
  var ROOT_SELECTOR = "[data-brut-configurator]";
  var FORM_SELECTOR = "[data-brut-configurator-form]";
  var SUMMARY_SELECTOR = "[data-brut-summary-list]";

  function initConfigurator(root) {
    if (!root || root.dataset.brutReady === "true") {
      return;
    }

    var form = root.querySelector(FORM_SELECTOR);
    var summaryList = root.querySelector(SUMMARY_SELECTOR);
    var formMessage = root.querySelector("[data-brut-form-message]");
    var variantSelect = root.querySelector("[data-brut-variant-select]");
    var selectedPrice = root.querySelector("[data-brut-selected-price]");
    var selectedTotalPrice = root.querySelector("[data-brut-total-price]");
    var totalPriceLabel = root.querySelector("[data-brut-total-label]");
    var mobileTotalPrice = root.querySelector("[data-brut-mobile-total-price]");
    var mobileTotalPriceLabel = root.querySelector("[data-brut-mobile-total-label]");
    var mobilePriceStatus = root.querySelector("[data-brut-mobile-price-status]");
    var priceBreakdown = root.querySelector("[data-brut-price-breakdown]");
    var priceEngineStatus = root.querySelector("[data-brut-price-engine-status]");
    var submitButton = form ? form.querySelector("[data-brut-submit]") : null;
    var woodSelect = form ? form.querySelector('[name="properties[Choix du bois]"]') : null;
    var customMaterialField = root.querySelector("[data-brut-custom-material-field]");
    var customMaterialInput = form ? form.querySelector("[data-brut-custom-material]") : null;
    var finishSelect = form ? form.querySelector("[data-brut-finish-select]") : null;
    var customFinishField = root.querySelector("[data-brut-custom-finish-field]");
    var customFinishInput = form ? form.querySelector("[data-brut-custom-finish]") : null;
    var standardPriceElements = Array.prototype.slice.call(root.querySelectorAll("[data-brut-standard-price]"));
    var summaryQuote = root.querySelector("[data-brut-summary-quote]");
    var quoteOnlyMessage = root.querySelector("[data-brut-quote-only-message]");
    var customQuoteButton = root.querySelector('[data-brut-open-quote="custom"]');
    var validationQuoteButton = root.querySelector('[data-brut-open-quote="validation"]');
    var sampleQuoteButtons = Array.prototype.slice.call(root.querySelectorAll('[data-brut-open-quote="sample"]'));
    var quoteModal = root.querySelector("[data-brut-quote-modal]");
    var quoteForm = quoteModal ? quoteModal.querySelector("form") : null;
    var quoteTitle = root.querySelector("[data-brut-quote-title]");
    var quoteSummary = root.querySelector("[data-brut-quote-summary]");
    var quoteSummaryDetails = root.querySelector("[data-brut-quote-summary-details]");
    var quotePrice = root.querySelector("[data-brut-quote-price]");
    var quoteModeInput = root.querySelector("[data-brut-quote-mode-input]");
    var quoteConfigurationInput = root.querySelector("[data-brut-quote-configuration]");
    var quotePriceInput = root.querySelector("[data-brut-quote-price-input]");
    var quotePlanInput = root.querySelector("[data-brut-quote-plan-input]");
    var quoteAttachmentInput = root.querySelector("[data-brut-quote-attachment-input]");
    var quoteAttachmentUrlInput = root.querySelector("[data-brut-quote-attachment-url]");
    var quoteBodyInput = root.querySelector("[data-brut-quote-body]");
    var quoteExtraComment = root.querySelector("[data-brut-quote-extra-comment]");
    var quoteFileInput = root.querySelector("[data-brut-quote-file]");
    var quoteFileSelected = root.querySelector("[data-brut-quote-file-selected]");
    var quoteFileName = root.querySelector("[data-brut-quote-file-name]");
    var quoteRemoveFile = root.querySelector("[data-brut-remove-quote-file]");
    var quoteError = root.querySelector("[data-brut-quote-error]");
    var quoteSendButton = root.querySelector("[data-brut-quote-send]");
    var quoteFormFields = root.querySelector("[data-brut-quote-form-fields]");
    var quoteConfirmation = root.querySelector("[data-brut-quote-confirmation]");
    var quoteConfirmationTitle = root.querySelector("[data-brut-confirmation-title]");
    var quoteConfirmationText = root.querySelector("[data-brut-confirmation-text]");
    var quoteDraftNote = root.querySelector("[data-brut-quote-draft-note]");
    var quoteNameInput = root.querySelector("[data-brut-quote-name]");
    var quoteNameRequirement = root.querySelector("[data-brut-name-requirement]");
    var sampleFields = Array.prototype.slice.call(root.querySelectorAll("[data-brut-sample-field]"));
    var nonSampleFields = Array.prototype.slice.call(root.querySelectorAll("[data-brut-nonsample-field]"));
    var sampleAddressInput = root.querySelector("[data-brut-sample-address]");
    var sampleProjectInput = root.querySelector("[data-brut-sample-project]");
    var quoteOpenTrigger = null;
    var activeQuoteMode = "custom";
    var quoteAttachmentUrl = "";
    var quoteShopifySubmissionReady = false;
    var priceConfigScript = root.querySelector("[data-brut-price-config]");
    var liveBoard = root.querySelector("[data-brut-live-board]");
    var liveSize = root.querySelector("[data-brut-live-size]");
    var liveDetails = root.querySelector("[data-brut-live-details]");
    var liveLengthLabel = root.querySelector("[data-brut-live-length]");
    var liveWidthLabel = root.querySelector("[data-brut-live-width]");
    var liveThicknessLabel = root.querySelector("[data-brut-live-thickness]");
    var cornerMode = form ? form.querySelector("[data-brut-corner-mode]") : null;
    var cornerRadius = form ? form.querySelector("[data-brut-corner-radius]") : null;
    var cornerOutput = form ? form.querySelector("[data-brut-corner-output]") : null;
    var cornerRadiusOutput = form ? form.querySelector("[data-brut-corner-radius-output]") : null;
    var cornerModeOutput = form ? form.querySelector("[data-brut-corner-mode-output]") : null;
    var cornerPriceOutput = form ? form.querySelector("[data-brut-corner-price-output]") : null;
    var cornerPriceRawOutput = form ? form.querySelector("[data-brut-corner-price-raw-output]") : null;
    var cornerStatus = root.querySelector("[data-brut-corner-status]");
    var cornerHelp = root.querySelector("[data-brut-corner-help]");
    var cornerFee = root.querySelector("[data-brut-corner-fee]");
    var radiusField = root.querySelector("[data-brut-radius-field]");
    var cornerButtons = Array.prototype.slice.call(root.querySelectorAll("[data-brut-corner]"));
    var liveCorners = Array.prototype.slice.call(root.querySelectorAll("[data-brut-live-corner]"));
    var editorTabs = Array.prototype.slice.call(root.querySelectorAll("[data-brut-editor-tab]"));
    var editorPanels = Array.prototype.slice.call(root.querySelectorAll("[data-brut-editor-panel]"));
    var planCanvas = root.querySelector("[data-brut-plan-canvas]");
    var planSvg = root.querySelector(".brut-configurator__plan-svg");
    var planPath = root.querySelector("[data-brut-plan-path]");
    var planGrainPath = root.querySelector("[data-brut-plan-grain-path]");
    var planOutline = root.querySelector("[data-brut-plan-outline]");
    var planSpecialEdge = root.querySelector("[data-brut-plan-special-edge]");
    var planEdgeHighlights = Array.prototype.slice.call(root.querySelectorAll("[data-brut-plan-edge-highlight]"));
    var planEdgeLegend = root.querySelector("[data-brut-plan-edge-legend]");
    var planEdgeLegendText = root.querySelector("[data-brut-plan-edge-legend-text]");
    var planOrientationLabels = Array.prototype.slice.call(root.querySelectorAll("[data-brut-plan-orientation]"));
    var planDescription = root.querySelector("[data-brut-plan-description]");
    var planCaption = root.querySelector("[data-brut-plan-caption]");
    var planSize = root.querySelector("[data-brut-plan-size]");
    var planRadius = root.querySelector("[data-brut-plan-radius]");
    var planLength = root.querySelector("[data-brut-plan-length]");
    var planWidth = root.querySelector("[data-brut-plan-width]");
    var planThickness = root.querySelector("[data-brut-plan-thickness]");
    var borderStatus = root.querySelector("[data-brut-border-status]");
    var planSignatureOutput = form ? form.querySelector("[data-brut-plan-signature-output]") : null;
    var cutoutOutput = form ? form.querySelector("[data-brut-cutout-output]") : null;
    var cutoutTypeOutput = form ? form.querySelector("[data-brut-cutout-type-output]") : null;
    var cutoutPriceOutput = form ? form.querySelector("[data-brut-cutout-price-output]") : null;
    var cutoutPriceRawOutput = form ? form.querySelector("[data-brut-cutout-price-raw-output]") : null;
    var cutoutConfirmationWrap = root.querySelector("[data-brut-cutout-confirmation-wrap]");
    var cutoutConfirmation = form ? form.querySelector("[data-brut-cutout-confirmation]") : null;
    var oversizePercentOutput = form ? form.querySelector("[data-brut-oversize-percent-output]") : null;
    var cutoutItems = Array.prototype.slice.call(root.querySelectorAll("[data-brut-cutout-item]")).map(function (container, index) {
      var cutoutIndex = container.dataset.cutoutIndex || String(index + 1);
      var drawingSelector = '[data-cutout-index="' + cutoutIndex + '"]';
      var guides = root.querySelector("[data-brut-cutout-guides]" + drawingSelector);
      var labelSelector = '[data-brut-cutout-label-button][data-cutout-index="' + cutoutIndex + '"]';
      var legendSelector = '[data-brut-cutout-legend-button][data-cutout-index="' + cutoutIndex + '"]';

      return {
        index: index + 1,
        container: container,
        enabled: container.querySelector("[data-brut-cutout-enabled]"),
        fields: container.querySelector("[data-brut-cutout-fields]"),
        type: container.querySelector("[data-brut-cutout-type]"),
        edge: container.querySelector("[data-brut-cutout-edge]"),
        edgeField: container.querySelector("[data-brut-cutout-edge-field]"),
        xField: container.querySelector("[data-brut-cutout-x-field]"),
        yField: container.querySelector("[data-brut-cutout-y-field]"),
        opening: container.querySelector("[data-brut-cutout-width]"),
        depth: container.querySelector("[data-brut-cutout-depth]"),
        x: container.querySelector("[data-brut-cutout-x]"),
        y: container.querySelector("[data-brut-cutout-y]"),
        fee: container.querySelector("[data-brut-cutout-fee]"),
        error: container.querySelector("[data-brut-cutout-error]"),
        mask: root.querySelector("[data-brut-cutout-mask]" + drawingSelector),
        outline: root.querySelector("[data-brut-cutout-outline]" + drawingSelector),
        guides: guides,
        guideX: guides ? guides.querySelector("[data-brut-cutout-guide-x]") : null,
        guideY: guides ? guides.querySelector("[data-brut-cutout-guide-y]") : null,
        guideOpening: guides ? guides.querySelector("[data-brut-cutout-guide-opening]") : null,
        guideDepth: guides ? guides.querySelector("[data-brut-cutout-guide-depth]") : null,
        measureHits: {
          x: guides ? guides.querySelector('[data-brut-cutout-measure-hit="x"]') : null,
          y: guides ? guides.querySelector('[data-brut-cutout-measure-hit="y"]') : null,
          opening: guides ? guides.querySelector('[data-brut-cutout-measure-hit="opening"]') : null,
          depth: guides ? guides.querySelector('[data-brut-cutout-measure-hit="depth"]') : null
        },
        mobileLegend: root.querySelector('[data-brut-cutout-mobile-legend]' + drawingSelector),
        legendButtons: {
          x: root.querySelector(legendSelector + '[data-cutout-field="x"]'),
          y: root.querySelector(legendSelector + '[data-cutout-field="y"]'),
          opening: root.querySelector(legendSelector + '[data-cutout-field="opening"]'),
          depth: root.querySelector(legendSelector + '[data-cutout-field="depth"]')
        },
        labelX: guides ? guides.querySelector("[data-brut-cutout-label-x]") : null,
        labelY: guides ? guides.querySelector("[data-brut-cutout-label-y]") : null,
        labelOpening: guides ? guides.querySelector("[data-brut-cutout-label-opening]") : null,
        labelDepth: guides ? guides.querySelector("[data-brut-cutout-label-depth]") : null,
        buttonX: root.querySelector(labelSelector + '[data-cutout-field="x"]'),
        buttonY: root.querySelector(labelSelector + '[data-cutout-field="y"]'),
        buttonOpening: root.querySelector(labelSelector + '[data-cutout-field="opening"]'),
        buttonDepth: root.querySelector(labelSelector + '[data-cutout-field="depth"]')
      };
    });
    var edgeVarnishAdvice = root.querySelector("[data-brut-edge-varnish-advice]");
    var edgeVarnishAdviceAction = root.querySelector("[data-brut-open-broken-edges]");
    var reinforcementAdvice = root.querySelector("[data-brut-reinforcement-advice]");
    var reinforcementAdviceAction = root.querySelector("[data-brut-open-reinforcements]");
    var widthPrecisionAdvice = root.querySelector("[data-brut-width-precision-advice]");
    var flexAdvice = root.querySelector("[data-brut-flex-advice]");
    var oversizeQuoteAdvice = root.querySelector("[data-brut-oversize-quote-advice]");
    var quoteShortcutButtons = Array.prototype.slice.call(root.querySelectorAll("[data-brut-scroll-to-quote]"));
    var summaryQuoteButton = root.querySelector("[data-brut-summary-quote-button]");
    var summaryPriceProblem = root.querySelector("[data-brut-price-verification-problem]");
    var summaryPriceProblemButton = root.querySelector("[data-brut-price-verification-button]");
    var shareButton = root.querySelector("[data-brut-share-configuration]");
    var resetButton = root.querySelector("[data-brut-reset-configuration]");
    var shareStatus = root.querySelector("[data-brut-share-status]");
    var shareLinkInput = root.querySelector("[data-brut-share-link]");
    var loadingMessage = root.querySelector("[data-brut-loading-message]");
    var loadingMessageTitle = loadingMessage ? loadingMessage.querySelector("[data-brut-loading-title]") : null;
    var loadingMessageCopy = loadingMessage ? loadingMessage.querySelector("[data-brut-loading-copy]") : null;
    var loadingMessageNote = loadingMessage ? loadingMessage.querySelector("[data-brut-loading-note]") : null;
    var loadingMessageHome = loadingMessage ? {
      parent: loadingMessage.parentNode,
      nextSibling: loadingMessage.nextSibling
    } : null;
    var quoteLoadingMessage = root.querySelector("[data-brut-quote-loading-message]");
    var reinforcementPriceDisplay = root.querySelector("[data-brut-reinforcement-price]");
    var advancedSettings = root.querySelector("[data-brut-corner-settings]");
    var cpcForm = null;
    var cpcPriceElement = null;
    var cpcPriceObserver = null;
    var cpcDiscoveryAttempts = 0;
    var cpcSyncTimer = null;
    var cpcPriceTimer = null;
    var cpcPricePending = false;
    var cpcSubmissionPending = false;
    var cpcSubmissionTimeout = null;
    var lastCpcMismatchSignature = "";
    var planSnapshotCache = {
      signature: "",
      file: null
    };
    var privatePlanLinkCache = { signature: "", url: "" };
    var loadingTimer = null;
    var loadingInterval = null;
    var loadingIndex = 0;
    var loadingMessages = [
      "Nous préparons votre configuration…",
      "Nous vérifions les finitions du bois…",
      "Nous contrôlons la cohérence des dimensions…",
      "Nous préparons votre aperçu 2D…",
      "Nous vérifions les options de fabrication…",
      "Presque terminé, nous finalisons votre demande…"
    ];
    var lastPriceEstimate = null;
    var lastCpcPrice = null;
    var lastCpcSyncState = {
      cutoutReady: true,
      optionPricingReady: true,
      missingOptionLabels: []
    };
    var draftStorageKey = "brut-configurator-draft:" + window.location.pathname;
    var draftSaveTimer = null;
    var refreshFrame = null;
    var shareStatusTimer = null;
    var shareHashKey = "brut-config";

    if (!form || !summaryList) {
      return;
    }

    root.dataset.brutReady = "true";

    var emptySummary = summaryList.textContent.trim() || "Vos choix apparaîtront ici.";
    var priceConfig = parsePriceConfig(priceConfigScript);

    function appendAriaReference(control, attribute, id) {
      if (!control || !id) {
        return;
      }
      var references = String(control.getAttribute(attribute) || "").split(/\s+/).filter(Boolean);
      if (references.indexOf(id) === -1) references.push(id);
      control.setAttribute(attribute, references.join(" "));
    }

    function ensureAccessibleFieldReferences() {
      var fieldIndex = 0;
      root.querySelectorAll(".brut-configurator__field").forEach(function (field) {
        fieldIndex += 1;
        var label = field.querySelector(".brut-configurator__label");
        var controls = Array.prototype.slice.call(field.querySelectorAll("input, select, textarea"));
        if (label && controls.length) {
          if (!label.id) label.id = (root.id || "BrutConfigurator") + "-FieldLabel-" + fieldIndex;
          controls.forEach(function (control) {
            if (!control.hasAttribute("aria-label") && !control.hasAttribute("aria-labelledby")) {
              control.setAttribute("aria-labelledby", label.id);
            }
          });
        }

        var descriptions = Array.prototype.slice.call(field.querySelectorAll("[data-error-for], .brut-configurator__field-advice, .brut-configurator__field-note"));
        descriptions.forEach(function (description, descriptionIndex) {
          if (!description.id) description.id = (root.id || "BrutConfigurator") + "-FieldDescription-" + fieldIndex + "-" + (descriptionIndex + 1);
          controls.forEach(function (control) {
            appendAriaReference(control, "aria-describedby", description.id);
          });
        });
      });
    }

    function getScrollBehavior() {
      return window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches ? "auto" : "smooth";
    }

    ensureAccessibleFieldReferences();

    function enhanceDelayOptionLabels() {
      root.querySelectorAll('select[data-summary-label="Délai"]').forEach(function (select) {
        Array.prototype.slice.call(select.options).forEach(function (option) {
          if (normalizeValue(option.value).indexOf("delais habituels") !== -1) {
            return;
          }

          var adjustment = lookupRate(priceConfig.delayAdjustmentMap, option.value, 0);
          if (!adjustment || /[+-]\s*\d+(?:[,.]\d+)?\s*%/.test(option.textContent)) {
            return;
          }
          var percent = Math.round(adjustment * 1000) / 10;
          var originalValue = option.value;
          option.textContent += " · prix " + (percent > 0 ? "+" : "") + String(percent).replace(".", ",") + " %";
          option.value = originalValue;
        });
      });
    }

    enhanceDelayOptionLabels();

    function syncStickyOffset() {
      var stickyHeader = document.querySelector(".shopify-section-header-sticky, sticky-header, .header-wrapper");
      var headerHeight = stickyHeader ? Math.ceil(stickyHeader.getBoundingClientRect().height) : 0;
      root.style.setProperty("--brut-sticky-offset", Math.max(24, headerHeight + 16) + "px");
    }

    function parsePriceConfig(script) {
      var defaults = {
        enabled: false,
        currency: "EUR",
        locale: "fr-FR",
        minimum: 0,
        fallbackMaterialPrice: 1780,
        materialPrices: "",
        thicknessCoefficients: "",
        finishMargins: "",
        borderMultipliers: "",
        delayAdjustments: "",
        normalDelayAdjustmentPercent: 3,
        reinforcementCounts: "",
        extraRules: "",
        lengthAllowance: 20,
        widthMultiplier: 1.1,
        wasteRate: 0.2,
        taxMultiplier: 1.2,
        defaultMargin: 63.2,
        lengthSurchargeThreshold: 250,
        lengthSurchargeExtraThreshold: 300,
        lengthSurchargeExtraPercent: 5,
        widthSurchargeThreshold: 100,
        oversizeSurchargePercent: 5,
        reinforcementPricePerCm: 0.5,
        reinforcementMarginPercent: 65,
        varnishMaterialCostPerM2Ht: 15,
        cutoutBaseFeeHt: 20,
        cutoutAreaRateHt: 40,
        cornerPricePerRadiusCmHt: 0.5,
        checkoutBackend: "shopify",
        cpcFormSelector: "form.cpc-calculator-form",
        cpcPriceSelector: "#calculator-final-value",
        cpcPriceToleranceCents: 100,
        cpcPriceTolerancePercent: 2,
        hideCpcForm: true,
        cpcAttachPlanFile: false,
        roundProduct: true,
        fallbackRate: 0,
        thicknessRates: "",
        optionRules: ""
      };

      if (!script || !script.textContent.trim()) {
        return buildPriceConfig(defaults);
      }

      try {
        return buildPriceConfig(Object.assign(defaults, JSON.parse(script.textContent)));
      } catch (error) {
        return buildPriceConfig(defaults);
      }
    }

    function buildPriceConfig(config) {
      var checkoutBackend = String(config.checkoutBackend || "").toLowerCase();
      if (checkoutBackend === "cpc" || checkoutBackend === "apippa" || checkoutBackend === "apippa_cpc") {
        config.enabled = true;
      }
      config.minimum = toNumber(config.minimum);
      config.fallbackMaterialPrice = toNumber(config.fallbackMaterialPrice || config.fallbackRate);
      config.lengthAllowance = toNumber(config.lengthAllowance);
      config.widthMultiplier = toNumber(config.widthMultiplier) || 1;
      config.wasteRate = toNumber(config.wasteRate);
      config.taxMultiplier = toNumber(config.taxMultiplier) || 1.2;
      config.defaultMargin = toNumber(config.defaultMargin);
      config.lengthSurchargeThreshold = toNumber(config.lengthSurchargeThreshold);
      config.lengthSurchargeExtraThreshold = toNumber(config.lengthSurchargeExtraThreshold);
      config.lengthSurchargeExtraPercent = toNumber(config.lengthSurchargeExtraPercent);
      config.widthSurchargeThreshold = toNumber(config.widthSurchargeThreshold);
      config.oversizeSurchargePercent = toNumber(config.oversizeSurchargePercent);
      config.normalDelayAdjustmentPercent = toNumber(config.normalDelayAdjustmentPercent);
      config.reinforcementPricePerCm = toNumber(config.reinforcementPricePerCm);
      config.reinforcementMarginPercent = toNumber(config.reinforcementMarginPercent);
      config.varnishMaterialCostPerM2Ht = toNumber(config.varnishMaterialCostPerM2Ht);
      config.cutoutBaseFeeHt = toNumber(config.cutoutBaseFeeHt) || 20;
      config.cutoutAreaRateHt = toNumber(config.cutoutAreaRateHt) || 40;
      config.cornerPricePerRadiusCmHt = toNumber(config.cornerPricePerRadiusCmHt) || 0.5;
      config.cpcPriceToleranceCents = Math.max(0, Math.round(toNumber(config.cpcPriceToleranceCents)));
      config.cpcPriceTolerancePercent = Math.max(0, toNumber(config.cpcPriceTolerancePercent));
      config.cpcAttachPlanFile = config.cpcAttachPlanFile === true;
      config.roundProduct = config.roundProduct !== false;
      config.materialPriceMap = parseRateMap(config.materialPrices);
      config.thicknessCoefficientMap = parseRateMap(config.thicknessCoefficients || config.thicknessRates);
      config.finishMarginMap = parsePairRateMap(config.finishMargins);
      config.borderMultiplierMap = parseRateMap(config.borderMultipliers);
      config.delayAdjustmentMap = parseAdjustmentMap(config.delayAdjustments);
      config.reinforcementCountMap = parseRateMap(config.reinforcementCounts);
      config.extraRuleList = parseOptionRules(config.extraRules);
      return config;
    }

    function normalizeValue(value) {
      return String(value || "")
        .normalize("NFD")
        .replace(/[\u0300-\u036f]/g, "")
        .replace(/\s+/g, " ")
        .trim()
        .toLowerCase();
    }

    function toNumber(value) {
      if (typeof value === "number") {
        return Number.isFinite(value) ? value : 0;
      }

      var normalized = String(value || "")
        .replace(/\s/g, "")
        .replace(",", ".")
        .replace(/[^\d.-]/g, "");
      var number = Number(normalized);

      return Number.isFinite(number) ? number : 0;
    }

    function parseUserNumber(value) {
      if (typeof value === "number") {
        return Number.isFinite(value) ? value : NaN;
      }

      var normalized = String(value || "")
        .trim()
        .replace(/\s/g, "")
        .replace(",", ".");

      if (!/^-?\d+(\.\d+)?$/.test(normalized)) {
        return NaN;
      }

      var number = Number(normalized);
      return Number.isFinite(number) ? number : NaN;
    }

    function parseRateMap(rawRules) {
      var map = {};

      String(rawRules || "").split(/\r?\n/).forEach(function (line) {
        var parts = line.split("=");
        if (parts.length < 2) {
          return;
        }

        var key = normalizeValue(parts.shift());
        var value = toNumber(parts.join("="));

        if (key) {
          map[key] = value;
        }
      });

      return map;
    }

    function parseOptionRules(rawRules) {
      var rules = [];

      String(rawRules || "").split(/\r?\n/).forEach(function (line) {
        var parts = line.split("=");
        if (parts.length < 2) {
          return;
        }

        var selector = parts.shift();
        var amountText = parts.join("=").trim();
        var selectorParts = selector.split("|");

        if (selectorParts.length < 2) {
          return;
        }

        rules.push({
          group: normalizeValue(selectorParts[0]),
          value: normalizeValue(selectorParts.slice(1).join("|")),
          amount: toNumber(amountText),
          percent: amountText.indexOf("%") !== -1
        });
      });

      return rules;
    }

    function parsePairRateMap(rawRules) {
      var map = {};

      String(rawRules || "").split(/\r?\n/).forEach(function (line) {
        var parts = line.split("=");

        if (parts.length < 2) {
          return;
        }

        var selector = parts.shift();
        var selectorParts = selector.split("|");
        var key = selectorParts.map(function (part) {
          return normalizeValue(part);
        }).join("|");

        if (key) {
          map[key] = toNumber(parts.join("="));
        }
      });

      return map;
    }

    function parseAdjustmentMap(rawRules) {
      var map = {};

      String(rawRules || "").split(/\r?\n/).forEach(function (line) {
        var parts = line.split("=");

        if (parts.length < 2) {
          return;
        }

        var key = normalizeValue(parts.shift());
        var amountText = parts.join("=").trim();
        var amount = toNumber(amountText);

        if (key) {
          map[key] = amountText.indexOf("%") !== -1 ? amount / 100 : amount;
        }
      });

      return map;
    }

    function lookupRate(map, value, fallback) {
      var key = normalizeValue(value);

      if (Object.prototype.hasOwnProperty.call(map, key)) {
        return map[key];
      }

      return fallback;
    }

    function lookupPairRate(map, firstValue, secondValue, fallback) {
      var firstKey = normalizeValue(firstValue);
      var secondKey = normalizeValue(secondValue);
      var pairKey = firstKey + "|" + secondKey;

      if (Object.prototype.hasOwnProperty.call(map, pairKey)) {
        return map[pairKey];
      }

      if (Object.prototype.hasOwnProperty.call(map, firstKey)) {
        return map[firstKey];
      }

      return fallback;
    }

    function roundUp(value, precision) {
      var factor = precision ? 1 / precision : 1;

      return Math.ceil(value * factor) / factor;
    }

    function formatDimension(value) {
      var rounded = Math.round(value * 10) / 10;

      return String(Math.abs(rounded - Math.round(rounded)) < 0.000001 ? Math.round(rounded) : rounded).replace(".", ",");
    }

    function formatBoardSize(length, width, thickness) {
      var thicknessValue = toNumber(thickness);
      var parts = [
        formatDimension(length),
        formatDimension(width)
      ];

      if (thicknessValue > 0) {
        parts.push(formatDimension(thicknessValue));
      }

      return parts.join(" × ") + " cm";
    }

    function clampNumber(value, minimum, maximum) {
      return Math.min(Math.max(value, minimum), maximum);
    }

    function clearFormMessage() {
      if (formMessage) {
        formMessage.textContent = "";
      }
    }

    function syncVariantPrice() {
      if (!variantSelect || !selectedPrice) {
        return;
      }

      var option = variantSelect.options[variantSelect.selectedIndex];
      if (option && option.dataset.price) {
        selectedPrice.textContent = option.dataset.price;
        syncDisplayedTotal(toNumber(option.dataset.price));
      }
    }

    function getQuantity() {
      var quantityInput = form.querySelector('input[name="quantity"]');
      return Math.max(1, Math.round(toNumber(quantityInput ? quantityInput.value : 1) || 1));
    }

    function syncDisplayedTotal(unitAmount) {
      if (!selectedTotalPrice && !mobileTotalPrice) {
        return;
      }

      var quantity = getQuantity();
      var totalText = unitAmount > 0 ? formatMoney(unitAmount * quantity) : "À calculer";
      var labelText = "Total TTC (" + quantity + " " + (quantity > 1 ? "pièces" : "pièce") + ")";

      if (selectedTotalPrice) {
        selectedTotalPrice.textContent = totalText;
      }
      if (mobileTotalPrice) {
        mobileTotalPrice.textContent = totalText;
      }

      if (totalPriceLabel) {
        totalPriceLabel.textContent = labelText;
      }
      if (mobileTotalPriceLabel) {
        mobileTotalPriceLabel.textContent = labelText;
      }
    }

    function syncMobilePriceStatus() {
      if (!mobilePriceStatus) {
        return;
      }

      var text = priceEngineStatus ? priceEngineStatus.textContent.trim() : "";
      mobilePriceStatus.textContent = text || "Prix final vérifié avant l’ajout au panier.";
      mobilePriceStatus.classList.toggle("is-error", Boolean(priceEngineStatus && priceEngineStatus.classList.contains("is-error")));
    }

    function isCustomWoodMode() {
      if (!woodSelect) {
        return false;
      }

      var option = woodSelect.options[woodSelect.selectedIndex];
      return Boolean(option && option.dataset.brutQuoteOnly === "true");
    }

    function isCustomFinishMode() {
      if (!finishSelect) {
        return false;
      }

      var option = finishSelect.options[finishSelect.selectedIndex];
      return Boolean(option && option.dataset.brutQuoteOnlyFinish === "true");
    }

    function isQuoteOnlyMode() {
      return isCustomWoodMode() || isCustomFinishMode() || isOversizeQuoteMode();
    }

    function isOversizeQuoteMode() {
      var length = getNumberBySummaryLabel("Longueur");
      var width = getNumberBySummaryLabel("Largeur");

      return length > 400 || width >= 150;
    }

    function isOversizeQuoteFieldValue(input, value) {
      var label = normalizeValue(input && input.dataset ? input.dataset.summaryLabel : "");

      if (label === "longueur") {
        return value > 400;
      }

      if (label === "largeur") {
        return value >= 150;
      }

      return false;
    }

    function syncPurchasePath() {
      var quoteOnly = isQuoteOnlyMode();
      var customWood = isCustomWoodMode();
      var customFinish = isCustomFinishMode();
      var oversizeQuote = isOversizeQuoteMode();

      root.classList.toggle("is-quote-only", quoteOnly);

      if (woodSelect) {
        woodSelect.classList.toggle("is-quote-only", customWood);
      }

      if (customMaterialField) {
        customMaterialField.hidden = !customWood;
      }

      if (customMaterialInput) {
        customMaterialInput.disabled = !customWood;
        customMaterialInput.required = customWood;
        if (!customWood) {
          setFieldState(customMaterialInput, "");
        }
      }

      if (finishSelect) {
        finishSelect.classList.toggle("is-quote-only", customFinish);
      }

      if (customFinishField) {
        customFinishField.hidden = !customFinish;
      }

      if (customFinishInput) {
        customFinishInput.disabled = !customFinish;
        customFinishInput.required = customFinish;
        if (!customFinish) {
          setFieldState(customFinishInput, "");
        }
      }

      standardPriceElements.forEach(function (element) {
        element.hidden = quoteOnly;
      });

      if (summaryQuote) {
        summaryQuote.hidden = !quoteOnly;
        var summaryQuoteText = summaryQuote.querySelector("p");
        if (summaryQuoteText && quoteOnly) {
          summaryQuoteText.textContent = oversizeQuote
            ? "Prix sur devis : les dimensions sélectionnées nécessitent une validation préalable de l’atelier."
            : customFinish
            ? "Prix sur devis selon la teinte, la finition et les contraintes de fabrication."
            : "Prix sur devis selon l’essence, les dimensions et les contraintes de fabrication.";
        }
      }
      if (quoteOnlyMessage) {
        quoteOnlyMessage.hidden = !quoteOnly;
        if (oversizeQuote) {
          quoteOnlyMessage.textContent = "Les dimensions sélectionnées nécessitent une validation préalable de l’atelier. Les très grands formats demandent une étude spécifique concernant le choix du bois, le transport, la manutention, la stabilité et les fixations. Nous vous invitons à nous transmettre votre demande afin de vous proposer une solution adaptée.";
        } else if (customWood && customFinish) {
          quoteOnlyMessage.textContent = "Vous avez sélectionné une essence et une finition hors standard. Cette configuration nécessite une validation par l’atelier et un devis sur mesure.";
        } else if (customFinish) {
          quoteOnlyMessage.textContent = "Vous avez sélectionné une teinte ou une finition hors standard. Le prix et la compatibilité doivent être validés par l’atelier avant toute commande.";
        } else {
          quoteOnlyMessage.textContent = "Vous avez sélectionné une essence ou un projet hors standard. Cette configuration nécessite une validation par l’atelier. Vous pouvez demander un devis sur mesure.";
        }
      }
      if (customQuoteButton) customQuoteButton.hidden = !quoteOnly;
      if (validationQuoteButton) validationQuoteButton.hidden = quoteOnly;

      if (submitButton) {
        if (quoteOnly) {
          submitButton.disabled = true;
          submitButton.setAttribute("aria-disabled", "true");
        } else if (usesCpcEngine()) {
          updateCpcSubmitState();
        } else {
          var variantAvailable = submitButton.dataset.variantAvailable !== "false";
          submitButton.disabled = !variantAvailable;
          submitButton.setAttribute("aria-disabled", variantAvailable ? "false" : "true");
        }
      }
    }

    function saveConfigurationDraft() {
      if (!window.localStorage) {
        return;
      }

      var fields = [];
      Array.prototype.slice.call(form.elements).forEach(function (field) {
        if (!field.name || field.disabled || field.type === "file" || field.name === "id" || field.name === "form_type" || field.name.indexOf("properties[_brut_") === 0) {
          return;
        }

        if (field.type === "radio" && !field.checked) {
          return;
        }

        fields.push({
          name: field.name,
          value: field.value,
          type: field.type,
          checked: field.type === "checkbox" ? Boolean(field.checked) : undefined
        });
      });

      try {
        window.localStorage.setItem(draftStorageKey, JSON.stringify({
          version: 2,
          savedAt: Date.now(),
          fields: fields,
          designer: getShareableDesignerState()
        }));
      } catch (error) {
        return;
      }
    }

    function scheduleDraftSave() {
      window.clearTimeout(draftSaveTimer);
      draftSaveTimer = window.setTimeout(saveConfigurationDraft, 220);
    }

    function restoreConfigurationDraft() {
      if (!window.localStorage) {
        return false;
      }

      var draft = null;
      try {
        draft = JSON.parse(window.localStorage.getItem(draftStorageKey) || "null");
      } catch (error) {
        return false;
      }

      if (!draft || !Array.isArray(draft.fields) || !draft.savedAt || Date.now() - draft.savedAt > 30 * 24 * 60 * 60 * 1000) {
        return false;
      }

      Array.prototype.slice.call(form.elements).forEach(function (field) {
        if (field.name && field.type === "checkbox") {
          field.checked = false;
        }
      });

      draft.fields.forEach(function (entry) {
        var selectorName = String(entry.name || "").replace(/\\/g, "\\\\").replace(/"/g, '\\"');
        var candidates = selectorName ? Array.prototype.slice.call(form.querySelectorAll('[name="' + selectorName + '"]')) : [];

        if (!candidates.length && normalizePropertyName(entry.name).indexOf("vernis") === 0 && finishSelect) {
          candidates = [finishSelect];
        }

        if (!candidates.length) {
          return;
        }

        if (entry.type === "radio") {
          var radio = candidates.find(function (candidate) { return candidate.value === entry.value; });
          if (radio) radio.checked = true;
          return;
        }

        if (entry.type === "checkbox") {
          var checkbox = candidates.find(function (candidate) { return candidate.value === entry.value; }) || candidates[0];
          if (checkbox) checkbox.checked = entry.checked !== false;
          return;
        }

        var target = candidates[0];
        if (target.tagName === "SELECT") {
          var optionExists = Array.prototype.slice.call(target.options).some(function (option) { return option.value === entry.value; });
          if (!optionExists) return;
        }
        target.value = entry.value;
      });

      if (draft.designer) {
        applySharedDesignerState(draft.designer);
      }

      return true;
    }

    function encodeSharePayload(payload) {
      var text = JSON.stringify(payload);
      var binary = "";

      if (typeof TextEncoder !== "undefined") {
        var bytes = new TextEncoder().encode(text);
        for (var index = 0; index < bytes.length; index += 1) {
          binary += String.fromCharCode(bytes[index]);
        }
      } else {
        binary = unescape(encodeURIComponent(text));
      }

      return window.btoa(binary)
        .replace(/\+/g, "-")
        .replace(/\//g, "_")
        .replace(/=+$/g, "");
    }

    function decodeSharePayload(value) {
      var normalized = String(value || "").replace(/-/g, "+").replace(/_/g, "/");
      while (normalized.length % 4) normalized += "=";
      var binary = window.atob(normalized);

      if (typeof TextDecoder !== "undefined") {
        var bytes = new Uint8Array(binary.length);
        for (var index = 0; index < binary.length; index += 1) {
          bytes[index] = binary.charCodeAt(index);
        }
        return JSON.parse(new TextDecoder().decode(bytes));
      }

      return JSON.parse(decodeURIComponent(escape(binary)));
    }

    function getShareableFieldEntries() {
      var entries = [];

      Array.prototype.slice.call(form.elements).forEach(function (field) {
        var excludedType = field.type === "file" ||
          field.type === "hidden" ||
          field.type === "submit" ||
          field.type === "button" ||
          field.type === "reset";

        if (!field.name ||
            field.disabled ||
            excludedType ||
            field.name === "id" ||
            field.name === "form_type" ||
            field.hasAttribute("data-brut-customer-comment") ||
            field.name.indexOf("properties[_brut_") === 0) {
          return;
        }

        if ((field.type === "radio" || field.type === "checkbox") && !field.checked) {
          return;
        }

        entries.push({
          n: field.name,
          v: field.value,
          t: field.type
        });
      });

      return entries;
    }

    function getShareableDesignerState() {
      return {
        m: cornerMode ? cornerMode.value : "none",
        r: cornerRadius ? cornerRadius.value : "",
        c: getSelectedCornerKeys(),
        u: cutoutItems.map(function (item) {
          return {
            e: Boolean(item.enabled && item.enabled.checked),
            t: item.type ? item.type.value : "inside",
            g: item.edge ? item.edge.value : "front",
            o: item.opening ? item.opening.value : "",
            d: item.depth ? item.depth.value : "",
            x: item.x ? item.x.value : "",
            y: item.y ? item.y.value : ""
          };
        })
      };
    }

    function createShareLink() {
      var payload = {
        v: 1,
        f: getShareableFieldEntries(),
        d: getShareableDesignerState()
      };
      var url = new URL(window.location.href);
      url.hash = shareHashKey + "=" + encodeSharePayload(payload);
      return url.toString();
    }

    function applySharedFieldEntries(entries) {
      if (!Array.isArray(entries)) {
        return;
      }

      Array.prototype.slice.call(form.elements).forEach(function (field) {
        if (field.name && field.type === "checkbox") {
          field.checked = false;
        }
      });

      entries.slice(0, 100).forEach(function (entry) {
        var name = String(entry && entry.n || "").slice(0, 300);
        var value = String(entry && entry.v || "").slice(0, 2000);
        var type = String(entry && entry.t || "");
        var selectorName = name.replace(/\\/g, "\\\\").replace(/"/g, '\\"');
        var candidates = selectorName ? Array.prototype.slice.call(form.querySelectorAll('[name="' + selectorName + '"]')) : [];

        if (!candidates.length && normalizePropertyName(name).indexOf("vernis") === 0 && finishSelect) {
          candidates = [finishSelect];
        }

        if (!candidates.length) {
          return;
        }

        if (type === "radio") {
          var radio = candidates.find(function (candidate) { return candidate.value === value; });
          if (radio) radio.checked = true;
          return;
        }

        if (type === "checkbox") {
          var checkbox = candidates.find(function (candidate) { return candidate.value === value; }) || candidates[0];
          if (checkbox) checkbox.checked = true;
          return;
        }

        var target = candidates[0];
        if (target.tagName === "SELECT") {
          var optionExists = Array.prototype.slice.call(target.options).some(function (option) { return option.value === value; });
          if (!optionExists) return;
        }
        target.value = value;
      });
    }

    function applySharedDesignerState(designer) {
      if (!designer || typeof designer !== "object") {
        return;
      }

      if (cornerMode) {
        var mode = String(designer.m || "none");
        var modeExists = Array.prototype.slice.call(cornerMode.options).some(function (option) {
          return option.value === mode;
        });
        if (modeExists) cornerMode.value = mode;
      }

      if (cornerRadius && designer.r) {
        var radius = String(designer.r);
        var radiusExists = Array.prototype.slice.call(cornerRadius.options).some(function (option) {
          return option.value === radius;
        });
        if (radiusExists) cornerRadius.value = radius;
      }

      var selectedCorners = Array.isArray(designer.c) ? designer.c : [];
      cornerButtons.forEach(function (button) {
        button.setAttribute("aria-pressed", selectedCorners.indexOf(button.dataset.brutCorner) !== -1 ? "true" : "false");
      });

      var cutouts = Array.isArray(designer.u) ? designer.u.slice(0, cutoutItems.length) : [];
      cutoutItems.forEach(function (item, index) {
        var state = cutouts[index];
        if (!state) return;
        if (item.enabled) item.enabled.checked = Boolean(state.e);
        if (item.type && (state.t === "inside" || state.t === "outside")) item.type.value = state.t;
        if (item.edge && ["front", "back", "left", "right"].indexOf(state.g) !== -1) item.edge.value = state.g;
        if (item.opening) item.opening.value = String(state.o || "").slice(0, 20);
        if (item.depth) item.depth.value = String(state.d || "").slice(0, 20);
        if (item.x) item.x.value = String(state.x || "").slice(0, 20);
        if (item.y) item.y.value = String(state.y || "").slice(0, 20);
      });
    }

    function restoreSharedConfiguration() {
      var hash = String(window.location.hash || "").replace(/^#/, "");
      var prefix = shareHashKey + "=";

      if (hash.indexOf(prefix) !== 0) {
        return false;
      }

      var encoded = hash.slice(prefix.length);
      if (!encoded || encoded.length > 30000) {
        return false;
      }

      try {
        var payload = decodeSharePayload(encoded);
        if (!payload || payload.v !== 1 || !Array.isArray(payload.f)) {
          return false;
        }
        applySharedFieldEntries(payload.f);
        applySharedDesignerState(payload.d);
        return true;
      } catch (error) {
        return false;
      }
    }

    function setShareStatus(message, isError, persistent) {
      if (!shareStatus) {
        return;
      }

      window.clearTimeout(shareStatusTimer);
      shareStatus.textContent = message || "";
      shareStatus.classList.toggle("is-error", Boolean(isError));

      if (message && !persistent) {
        shareStatusTimer = window.setTimeout(function () {
          shareStatus.textContent = "";
          shareStatus.classList.remove("is-error");
        }, 6500);
      }
    }

    async function copyShareLink(value) {
      if (navigator.clipboard && window.isSecureContext) {
        await navigator.clipboard.writeText(value);
        return true;
      }

      var temporaryInput = document.createElement("textarea");
      temporaryInput.value = value;
      temporaryInput.setAttribute("readonly", "");
      temporaryInput.style.position = "fixed";
      temporaryInput.style.opacity = "0";
      document.body.appendChild(temporaryInput);
      temporaryInput.select();
      var copied = document.execCommand && document.execCommand("copy");
      temporaryInput.remove();
      return Boolean(copied);
    }

    async function shareCurrentConfiguration() {
      if (!shareButton) {
        return;
      }

      var link = createShareLink();
      shareButton.disabled = true;
      shareButton.setAttribute("aria-busy", "true");
      if (shareLinkInput) {
        shareLinkInput.value = link;
        shareLinkInput.hidden = true;
      }

      try {
        var copied = await copyShareLink(link);
        if (!copied) throw new Error("copy_failed");
        setShareStatus("Lien copié ! Vous pouvez maintenant partager cette configuration.", false, false);
      } catch (error) {
        if (shareLinkInput) {
          shareLinkInput.hidden = false;
          shareLinkInput.focus();
          shareLinkInput.select();
        }
        setShareStatus("La copie automatique n’a pas fonctionné. Sélectionnez le lien ci-dessous pour le copier.", true, true);
      } finally {
        shareButton.disabled = false;
        shareButton.removeAttribute("aria-busy");
      }
    }

    function resetCurrentConfiguration() {
      try {
        if (window.localStorage) window.localStorage.removeItem(draftStorageKey);
      } catch (error) {
        // La réinitialisation visuelle reste possible si le stockage est indisponible.
      }

      if (String(window.location.hash || "").indexOf("#" + shareHashKey + "=") === 0 && window.history && window.history.replaceState) {
        window.history.replaceState(null, "", window.location.pathname + window.location.search);
      }

      form.reset();
      cornerButtons.forEach(function (button) {
        button.setAttribute("aria-pressed", "false");
      });
      clearFormMessage();
      runDynamicRefresh();
      setShareStatus("Configuration réinitialisée avec les valeurs par défaut.", false, false);
    }

    function isUnavailable(input) {
      var hiddenContainer = input.closest("[hidden]");
      return input.disabled || Boolean(hiddenContainer && !hiddenContainer.matches("[data-brut-editor-panel]"));
    }

    function selectedValueByName(name) {
      var fields = form.querySelectorAll('[name="' + name.replace(/"/g, '\\"') + '"]');
      var value = "";

      fields.forEach(function (field) {
        if (isUnavailable(field)) {
          return;
        }

        if ((field.type === "radio" || field.type === "checkbox") && !field.checked) {
          return;
        }

        value = field.value;
      });

      return value;
    }

    function updateConditionalFields() {
      root.querySelectorAll("[data-brut-show-when-name]").forEach(function (container) {
        var sourceName = container.dataset.brutShowWhenName;
        var expectedValue = container.dataset.brutShowWhenValue;
        var shouldShow = selectedValueByName(sourceName) === expectedValue;

        container.hidden = !shouldShow;
        container.querySelectorAll("input, select, textarea").forEach(function (field) {
          field.disabled = !shouldShow;
        });
      });
    }

    function syncDynamicNames() {
      form.querySelectorAll("[data-brut-dynamic-name-template]").forEach(function (field) {
        var sourceKey = field.dataset.brutDynamicNameSource;
        var source = sourceKey ? form.querySelector('[data-brut-field-key="' + sourceKey.replace(/"/g, '\\"') + '"]') : null;

        if (!source) {
          return;
        }

        field.name = field.dataset.brutDynamicNameTemplate.replace("{value}", fieldValue(source));
      });
    }

    function selectedValueBySummaryLabel(label) {
      var normalizedLabel = normalizeValue(label);
      var value = "";

      form.querySelectorAll("[data-summary-label]").forEach(function (field) {
        if (isUnavailable(field) || normalizeValue(field.dataset.summaryLabel) !== normalizedLabel) {
          return;
        }

        if ((field.type === "radio" || field.type === "checkbox") && !field.checked) {
          return;
        }

        value = field.tagName === "SELECT" ? field.value : fieldValue(field);
      });

      return value;
    }

    function getNumberBySummaryLabel(label) {
      var normalizedLabel = normalizeValue(label);
      var input = null;

      form.querySelectorAll("[data-summary-label]").forEach(function (field) {
        if (!input && normalizeValue(field.dataset.summaryLabel) === normalizedLabel) {
          input = field;
        }
      });

      return input ? toNumber(input.value) : 0;
    }

    function formatMoney(amount) {
      try {
        return new Intl.NumberFormat(priceConfig.locale || "fr-FR", {
          style: "currency",
          currency: priceConfig.currency || "EUR"
        }).format(amount);
      } catch (error) {
        return amount.toFixed(2).replace(".", ",") + " €";
      }
    }

    function formatWeight(weight) {
      var rounded = Math.abs(weight - Math.round(weight)) < 0.000001 ? Math.round(weight) : weight.toFixed(1);

      return String(rounded).replace(".", ",") + " kg";
    }

    function formatWeightSummary(weightValue) {
      var unitWeight = toNumber(weightValue);

      if (!(unitWeight > 0)) {
        return "";
      }

      var quantity = getQuantity();
      var unitLabel = formatWeight(unitWeight) + "/pièce";

      return quantity > 1
        ? unitLabel + " (total ≈ " + formatWeight(unitWeight * quantity) + ")"
        : unitLabel;
    }

    function setControlVisibility(container, visible) {
      if (!container) {
        return;
      }

      container.hidden = !visible;
      container.querySelectorAll("input, select, textarea, button").forEach(function (field) {
        field.disabled = !visible;
      });
    }

    function usesCpcEngine() {
      return priceConfig.checkoutBackend === "apippa_cpc";
    }

    function normalizePropertyName(name) {
      return normalizeValue(String(name || "")
        .replace(/^properties\[/i, "")
        .replace(/\]$/, "")
        .replace(/[()'’]/g, " "));
    }

    function isAttachmentPropertyName(name) {
      return normalizePropertyName(name) === "piece jointe";
    }

    function getCpcFieldSearchText(field) {
      var chunks = [
        field.name,
        field.id,
        field.getAttribute("aria-label"),
        field.getAttribute("placeholder"),
        field.getAttribute("data-label"),
        field.getAttribute("data-name"),
        field.getAttribute("data-title")
      ];

      if (field.id && window.CSS && typeof window.CSS.escape === "function") {
        var label = document.querySelector('label[for="' + window.CSS.escape(field.id) + '"]');
        if (label) chunks.push(label.textContent);
      }

      var parent = field.parentElement;
      var depth = 0;

      while (parent && parent !== cpcForm && depth < 4) {
        var text = parent.textContent || "";
        if (text && text.length <= 260) {
          chunks.push(text);
        }
        parent = parent.parentElement;
        depth += 1;
      }

      return normalizePropertyName(chunks.filter(Boolean).join(" "));
    }

    function getCpcFieldsFor(localField) {
      if (!cpcForm || !localField || !localField.name) {
        return [];
      }

      var localKey = normalizePropertyName(localField.name);

      if (localField.hasAttribute && localField.hasAttribute("data-brut-cutout-type-output")) {
        localKey = "type de decoupe";
      } else if (localField.hasAttribute && localField.hasAttribute("data-brut-oversize-percent-output")) {
        localKey = "majoration grand format";
      } else if (localField.hasAttribute && localField.hasAttribute("data-brut-corner-price-raw-output")) {
        localKey = "supplement coins ht";
      } else if (localField.hasAttribute && localField.hasAttribute("data-brut-cutout-price-raw-output")) {
        localKey = "supplement decoupes ht";
      }
      var fields = Array.prototype.slice.call(cpcForm.querySelectorAll("input[name], select[name], textarea[name]")).filter(function (field) {
        return field.dataset.brutCpcProperty !== "true" && field.dataset.brutCpcCleanProperty !== "true";
      });
      var exact = fields.filter(function (field) {
        return normalizePropertyName(field.name) === localKey || getCpcFieldSearchText(field) === localKey;
      });

      if (exact.length) {
        return exact;
      }

      if (localKey === "majoration grand format") {
        return fields.filter(function (field) {
          var key = getCpcFieldSearchText(field);
          return key.indexOf("majoration") !== -1 && key.indexOf("grand format") !== -1;
        });
      }

      if (localKey === "supplement coins ht") {
        return fields.filter(function (field) {
          var key = getCpcFieldSearchText(field);
          return key.indexOf("coin") !== -1 && (key.indexOf("supplement") !== -1 || key.indexOf("suppl") !== -1 || key.indexOf("ht") !== -1);
        });
      }

      if (localKey === "supplement decoupes ht") {
        return fields.filter(function (field) {
          var key = getCpcFieldSearchText(field);
          return key.indexOf("decoupe") !== -1 && (key.indexOf("supplement") !== -1 || key.indexOf("suppl") !== -1 || key.indexOf("ht") !== -1);
        });
      }

      if (localKey === "type de decoupe") {
        return fields.filter(function (field) {
          var key = getCpcFieldSearchText(field);
          return key.indexOf("type") !== -1 && key.indexOf("decoupe") !== -1;
        });
      }

      if (localKey === "raidisseurs metalliques") {
        return fields.filter(function (field) {
          return normalizePropertyName(field.name).indexOf(localKey) === 0;
        });
      }

      var aliases = {
        "epaisseur": "epaisseur planche/panneau",
        "usage": "usage planche/panneau"
      };

      if (aliases[localKey]) {
        return fields.filter(function (field) {
          return normalizePropertyName(field.name).indexOf(aliases[localKey]) === 0;
        });
      }

      return [];
    }

    function dispatchCpcChange(field) {
      field.dispatchEvent(new Event("input", { bubbles: true }));
      field.dispatchEvent(new Event("change", { bubbles: true }));
      field.dispatchEvent(new KeyboardEvent("keyup", { bubbles: true }));
      field.dispatchEvent(new Event("blur", { bubbles: true }));
    }

    function setCpcFieldValue(field, value) {
      var prototype = field.tagName === "SELECT"
        ? window.HTMLSelectElement.prototype
        : field.tagName === "TEXTAREA"
        ? window.HTMLTextAreaElement.prototype
        : window.HTMLInputElement.prototype;
      var descriptor = Object.getOwnPropertyDescriptor(prototype, "value");

      if (descriptor && typeof descriptor.set === "function") {
        descriptor.set.call(field, value);
      } else {
        field.value = value;
      }
    }

    function cpcFieldValue(field) {
      if (field.type === "checkbox" || field.type === "radio") {
        return field.checked ? field.value : "";
      }

      return field.value == null ? "" : String(field.value);
    }

    function cpcCompatibleValue(target, value) {
      if (!target || target.tagName !== "INPUT" || target.type !== "number") {
        return value;
      }

      var number = parseUserNumber(value);
      return Number.isFinite(number) ? String(number) : value;
    }

    function syncValueToCpc(localField, cpcFields) {
      var value = cpcFieldValue(localField);

      if (localField.type === "radio" && !localField.checked) {
        return true;
      }

      if (localField.type === "checkbox" && !localField.checked) {
        return true;
      }

      if (!cpcFields.length) {
        return false;
      }

      if (cpcFields[0].type === "radio") {
        var matchedRadio = false;

        cpcFields.forEach(function (field) {
          var checked = normalizeValue(field.value) === normalizeValue(value);
          matchedRadio = matchedRadio || checked;

          if (field.checked !== checked) {
            field.checked = checked;
            dispatchCpcChange(field);
          }
        });

        return matchedRadio;
      }

      var target = cpcFields[0];
      var targetValue = cpcCompatibleValue(target, value);

      if (target.tagName === "SELECT") {
        var matchingOption = Array.prototype.slice.call(target.options).find(function (option) {
          return normalizeValue(option.value) === normalizeValue(value) || normalizeValue(option.textContent) === normalizeValue(value);
        });

        if (!matchingOption) {
          return false;
        }

        if (target.value !== matchingOption.value) {
          setCpcFieldValue(target, matchingOption.value);
          dispatchCpcChange(target);
        }

        return true;
      }

      if (target.value !== targetValue) {
        setCpcFieldValue(target, targetValue);
        dispatchCpcChange(target);
      }

      return true;
    }

    function appendCpcProperty(name, value) {
      if (!cpcForm || !name || !value) {
        return;
      }

      var input = document.createElement("input");
      input.type = "hidden";
      input.name = name;
      input.value = value;
      input.dataset.brutCpcProperty = "true";
      cpcForm.appendChild(input);
    }

    function syncCpcQuantity(value) {
      if (!cpcForm) {
        return false;
      }

      var quantity = String(Math.max(1, Math.round(toNumber(value) || 1)));
      var target = cpcForm.querySelector("[data-brut-cpc-quantity]");

      if (!target) {
        target = document.createElement("input");
        target.type = "hidden";
        target.name = "quantity";
        target.dataset.brutCpcQuantity = "true";
        cpcForm.appendChild(target);
      }

      target.setAttribute("data-cpc_isquantity", "true");
      target.value = quantity;
      return true;
    }

    function isolateCpcQuantityForSubmission() {
      if (!cpcForm) {
        return function () {};
      }

      syncCpcQuantity(getQuantity());
      var target = cpcForm.querySelector("[data-brut-cpc-quantity]");
      var collisions = Array.prototype.slice.call(cpcForm.querySelectorAll('[name="quantity"]')).filter(function (field) {
        return field !== target;
      });

      collisions.forEach(function (field) {
        field.dataset.brutCpcOriginalQuantityName = field.getAttribute("name") || "quantity";
        field.removeAttribute("name");
      });

      // Apippa cleans "Use as quantity" properties after the formdata event.
      // Only our dedicated piece-count input should have that role at checkout.
      // Preserve field names/values for GetVariantProperties and its price API.
      // Update Apippa's own jQuery cache as well as the DOM attribute.
      var cpcJQuery = window.cpc && window.cpc.$ ? window.cpc.$ : window.jQuery;
      var quantityProperties = Array.prototype.slice.call(cpcForm.querySelectorAll('[data-cpc_isquantity="true"]')).filter(function (field) {
        return field.name && field.name.indexOf("properties[") === 0;
      }).map(function (field) {
        var originalAttribute = field.getAttribute("data-cpc_isquantity");
        var originalData = typeof cpcJQuery === "function" ? cpcJQuery(field).data("cpc_isquantity") : undefined;
        field.setAttribute("data-cpc_isquantity", "false");
        if (typeof cpcJQuery === "function") cpcJQuery(field).data("cpc_isquantity", false);
        return { field: field, originalAttribute: originalAttribute, originalData: originalData };
      });

      if (target) {
        cpcForm.appendChild(target);
      }

      return function () {
        quantityProperties.forEach(function (entry) {
          entry.field.setAttribute("data-cpc_isquantity", entry.originalAttribute);
          if (typeof cpcJQuery === "function") {
            if (entry.originalData === undefined) cpcJQuery(entry.field).removeData("cpc_isquantity");
            else cpcJQuery(entry.field).data("cpc_isquantity", entry.originalData);
          }
        });
        collisions.forEach(function (field) {
          if (field.dataset.brutCpcOriginalQuantityName) {
            field.setAttribute("name", field.dataset.brutCpcOriginalQuantityName);
            delete field.dataset.brutCpcOriginalQuantityName;
          }
        });
      };
    }

    function isConfidentialCartPropertyName(name) {
      var propertyName = String(name || "").toLowerCase();
      return propertyName.indexOf("properties[_brut_cost_") === 0 ||
        propertyName.indexOf("properties[_brut_cout_") === 0 ||
        propertyName.indexOf("properties[_brut_pricing_trace") === 0 ||
        propertyName.indexOf("properties[_brut_price_trace") === 0 ||
        propertyName.indexOf("properties[_brut_price_components") === 0;
    }

    function blockCpcTechnicalCartProperties(formData) {
      if (!formData || typeof formData.set !== "function" || typeof formData.delete !== "function") {
        return false;
      }

      var blockedPublicProperties = {
        "properties[Majoration grand format]": true,
        "properties[Supplément coins HT]": true,
        "properties[Supplément découpes HT]": true
      };
      var originalSet = formData.set;

      Object.keys(blockedPublicProperties).forEach(function (name) {
        formData.delete(name);
      });

      try {
        Object.defineProperty(formData, "set", {
          configurable: true,
          enumerable: false,
          value: function (name) {
            if (blockedPublicProperties[name] || isConfidentialCartPropertyName(name)) {
              formData.delete(name);
              return;
            }
            return originalSet.apply(formData, arguments);
          }
        });
      } catch (error) {
        return false;
      }

      return true;
    }

    function isolateCpcTechnicalPropertiesForSubmission() {
      if (!cpcForm) {
        return function () {};
      }

      // In the legacy variant flow, Apippa's price/variant request has already
      // read these inputs. Removing their names until SubmitFormData finishes
      // prevents its later numeric-input pass from republishing them.
      // Cart Transform signs the calculator properties later, so leave that
      // newer flow untouched until it is enabled and tested on this store.
      var priceToken = cpcForm.querySelector("#cpcPriceToken");
      if (priceToken && priceToken.value && priceToken.value !== "none") {
        return function () {};
      }

      var technicalNames = {
        "majoration grand format": true,
        "supplement coins ht": true,
        "supplement decoupes ht": true
      };
      var isolatedFields = Array.prototype.slice.call(cpcForm.querySelectorAll("input[name], select[name], textarea[name]")).map(function (field) {
        if (!technicalNames[normalizePropertyName(field.name)]) return null;

        var originalName = field.name;
        field.removeAttribute("name");
        return { field: field, originalName: originalName };
      }).filter(Boolean);

      return function () {
        isolatedFields.forEach(function (entry) {
          entry.field.setAttribute("name", entry.originalName);
        });
      };
    }

    function syncCpcForm() {
      if (!usesCpcEngine() || !cpcForm) {
        lastCpcSyncState = {
          cutoutReady: true,
          optionPricingReady: true,
          missingOptionLabels: []
        };
        return lastCpcSyncState;
      }

      cpcForm.querySelectorAll("[data-brut-cpc-property]").forEach(function (field) {
        field.remove();
      });

      var cutoutReady = true;
      var optionPricingReady = true;
      var missingOptionLabels = [];
      var seenRadioNames = {};

      function flagMissingPricing(label) {
        if (missingOptionLabels.indexOf(label) === -1) {
          missingOptionLabels.push(label);
        }

        optionPricingReady = false;
      }

      Array.prototype.slice.call(form.elements).forEach(function (localField) {
        if (!localField.name || localField.disabled) {
          return;
        }

        if (localField.name !== "quantity" && localField.name.indexOf("properties[") !== 0) {
          return;
        }

        if (localField.type === "radio") {
          if (seenRadioNames[localField.name]) {
            return;
          }

          seenRadioNames[localField.name] = true;
          localField = form.querySelector('input[type="radio"][name="' + localField.name.replace(/"/g, '\\"') + '"]:checked');

          if (!localField) {
            return;
          }
        }

        if (localField.type === "checkbox" && !localField.checked) {
          return;
        }

        var value = cpcFieldValue(localField);

        if (!value && localField.name !== "quantity") {
          return;
        }

        if (localField.name === "quantity") {
          syncCpcQuantity(value);
          return;
        }

        var cpcFields = getCpcFieldsFor(localField);
        var synced = syncValueToCpc(localField, cpcFields);

        if (normalizePropertyName(localField.name) === "type de decoupe" || (localField.hasAttribute && localField.hasAttribute("data-brut-cutout-type-output"))) {
          cutoutReady = value === "Aucune" || synced;

          if (value !== "Aucune" && !synced) {
            flagMissingPricing("type de découpe Apippa");
          }
        } else if (localField.hasAttribute && localField.hasAttribute("data-brut-oversize-percent-output")) {
          if (toNumber(value) > 0 && !synced) {
            flagMissingPricing("majoration grand format");
          }
        } else if (localField.hasAttribute && localField.hasAttribute("data-brut-corner-price-raw-output")) {
          if (toNumber(value) > 0 && !synced) {
            flagMissingPricing("supplément coins");
          }
        } else if (localField.hasAttribute && localField.hasAttribute("data-brut-cutout-price-raw-output")) {
          if (toNumber(value) > 0 && !synced) {
            flagMissingPricing("supplément découpes");
          }
        }

        appendCpcProperty(localField.name, value);
      });

      lastCpcSyncState = {
        cutoutReady: cutoutReady,
        optionPricingReady: optionPricingReady,
        missingOptionLabels: missingOptionLabels
      };

      return lastCpcSyncState;
    }

    function getCpcPaidOptionPricingMessage(syncState) {
      var state = syncState || lastCpcSyncState;

      if (!state || (state.cutoutReady !== false && state.optionPricingReady !== false)) {
        return "";
      }

      var labels = state.missingOptionLabels && state.missingOptionLabels.length
        ? " (" + state.missingOptionLabels.join(", ") + ")"
        : "";

      return "Certaines options payantes de cette configuration ne sont pas encore tarifées dans Apippa" + labels + ". Pour éviter un panier au mauvais prix, envoyez cette configuration à l’atelier pour devis.";
    }

    function showCpcPricingFallback(syncState) {
      var message = getCpcPaidOptionPricingMessage(syncState);

      if (formMessage && message) {
        formMessage.textContent = message;
      }

      if (submitButton) {
        submitButton.disabled = true;
        submitButton.setAttribute("aria-disabled", "true");
      }

      if (customQuoteButton) {
        customQuoteButton.hidden = false;
        pulseButton(customQuoteButton);
      }

      if (validationQuoteButton) {
        validationQuoteButton.hidden = true;
      }

      saveConfigurationDraft();
    }

    function syncCpcPrice() {
      cpcPricePending = false;

      if (!cpcPriceElement) {
        lastCpcPrice = null;
        updateCpcSubmitState();
        return;
      }

      var amount = toNumber(cpcPriceElement.textContent);

      if (amount <= 0) {
        lastCpcPrice = null;
        var pendingPricingFallback = getCpcPaidOptionPricingMessage(lastCpcSyncState);

        if (pendingPricingFallback && lastPriceEstimate) {
          if (selectedPrice) {
            selectedPrice.textContent = lastPriceEstimate.formatted;
          }

          syncDisplayedTotal(lastPriceEstimate.amount);
        }

        if (priceEngineStatus && pendingPricingFallback) {
          priceEngineStatus.classList.remove("is-ready");
          priceEngineStatus.classList.add("is-error");
          priceEngineStatus.textContent = pendingPricingFallback;
        }

        syncMobilePriceStatus();
        updateCpcSubmitState();
        return;
      }

      var formatted = formatMoney(amount);
      var appliedPrice = form.querySelector("[data-brut-cpc-price-output]");
      lastCpcPrice = {
        amount: amount,
        cents: Math.round(amount * 100),
        formatted: formatted
      };

      var pricingFallbackMessage = getCpcPaidOptionPricingMessage(lastCpcSyncState);
      var displayedPrice = pricingFallbackMessage && lastPriceEstimate ? lastPriceEstimate.formatted : formatted;
      var displayedAmount = pricingFallbackMessage && lastPriceEstimate ? lastPriceEstimate.amount : amount;

      if (selectedPrice) {
        selectedPrice.textContent = displayedPrice;
      }
      syncDisplayedTotal(displayedAmount);

      if (appliedPrice) {
        appliedPrice.value = displayedPrice;
      }

      if (priceEngineStatus) {
        var guardMessage = pricingFallbackMessage || getCpcPriceGuardMessage();
        priceEngineStatus.classList.toggle("is-ready", !guardMessage);
        priceEngineStatus.classList.toggle("is-error", Boolean(guardMessage));
        priceEngineStatus.textContent = guardMessage
          ? getVisibleCpcGuardMessage(guardMessage)
          : "Prix final vérifié pour le panier, options comprises.";
      }

      syncMobilePriceStatus();
      updateCpcSubmitState();
    }

    function scheduleCpcPriceSync(delay) {
      if (!usesCpcEngine()) {
        return;
      }

      cpcPricePending = true;
      window.clearTimeout(cpcPriceTimer);
      updateCpcSubmitState();
      cpcPriceTimer = window.setTimeout(syncCpcPrice, typeof delay === "number" ? delay : 650);
    }

    function syncPriceVerificationProblem() {
      if (!summaryPriceProblem) {
        return;
      }

      var hasProblem = false;

      if (usesCpcEngine() && !isQuoteOnlyMode()) {
        var guardMessage = getCpcPriceGuardMessage();
        hasProblem = Boolean(
          getCpcPaidOptionPricingMessage(lastCpcSyncState) ||
          (guardMessage && !cpcPricePending && (lastCpcPrice || !lastPriceEstimate))
        );
      }

      summaryPriceProblem.hidden = !hasProblem;
    }

    function getDisplayedPriceQuantumCents(text) {
      var compact = String(text || "").replace(/\s+/g, "");
      var decimalMatch = compact.match(/[.,](\d{1,2})(?:[^\d]*)$/);

      if (!decimalMatch) {
        return 100;
      }

      return decimalMatch[1].length === 1 ? 10 : 1;
    }

    function getCpcComparisonReference() {
      var originalCents = lastPriceEstimate ? lastPriceEstimate.cents : 0;
      var quantumCents = getDisplayedPriceQuantumCents(cpcPriceElement ? cpcPriceElement.textContent : "");
      var normalizedCents = quantumCents > 1
        ? Math.floor(originalCents / quantumCents) * quantumCents
        : originalCents;

      return {
        originalCents: originalCents,
        normalizedCents: normalizedCents,
        quantumCents: quantumCents
      };
    }

    function getCpcPriceGuardMessage() {
      if (cpcPricePending) {
        return "Le prix final est en cours de vérification. L’ajout au panier sera disponible dans un instant.";
      }

      if (!lastPriceEstimate) {
        return "L’estimation locale n’est pas disponible. L’ajout au panier reste bloqué.";
      }

      if (!lastCpcPrice || lastCpcPrice.cents <= 0) {
        return "Le prix final est en cours de vérification. L’ajout au panier sera disponible dans un instant.";
      }

      var comparisonReference = getCpcComparisonReference();
      var shortfallCents = comparisonReference.normalizedCents - lastCpcPrice.cents;

      if (shortfallCents <= 0) {
        lastCpcMismatchSignature = "";
        return "";
      }

      var toleranceCents = Math.max(
        priceConfig.cpcPriceToleranceCents || 0,
        Math.round(comparisonReference.normalizedCents * (priceConfig.cpcPriceTolerancePercent || 0) / 100)
      );

      if (shortfallCents > toleranceCents) {
        var mismatchSignature = lastCpcPrice.cents + ":" + comparisonReference.normalizedCents + ":" + toleranceCents;
        if (mismatchSignature !== lastCpcMismatchSignature && window.console && typeof window.console.warn === "function") {
          lastCpcMismatchSignature = mismatchSignature;
          window.console.warn("Brut configurator: Apippa price mismatch", {
            apippa: lastCpcPrice.formatted,
            configurator: lastPriceEstimate.formatted,
            comparisonReferenceCents: comparisonReference.normalizedCents,
            displayQuantumCents: comparisonReference.quantumCents,
            shortfallCents: shortfallCents,
            toleranceCents: toleranceCents
          });
        }

        return "Le prix Apippa ne correspond pas encore au calcul du configurateur. Par sécurité, l’ajout au panier reste bloqué : réessayez ou faites valider le projet par l’atelier.";
      }

      lastCpcMismatchSignature = "";
      return "";
    }

    function getVisibleCpcGuardMessage(message) {
      return message || "";
    }

    function updateCpcSubmitState() {
      syncPriceVerificationProblem();

      if (!usesCpcEngine() || !submitButton) {
        return;
      }

      var variantAvailable = submitButton.dataset.variantAvailable !== "false";
      var pricingFallbackMessage = getCpcPaidOptionPricingMessage(lastCpcSyncState);
      var ready = Boolean(cpcForm && variantAvailable && !cpcSubmissionPending && !isQuoteOnlyMode() && !pricingFallbackMessage && !getCpcPriceGuardMessage());
      submitButton.disabled = !ready;
      submitButton.setAttribute("aria-disabled", ready ? "false" : "true");

      if (priceEngineStatus && cpcPricePending) {
        priceEngineStatus.classList.remove("is-ready", "is-error");
        priceEngineStatus.textContent = "Prix final en cours de vérification…";
      }
      syncMobilePriceStatus();

      if (!isQuoteOnlyMode()) {
        if (customQuoteButton) {
          customQuoteButton.hidden = !pricingFallbackMessage;
        }

        if (validationQuoteButton) {
          validationQuoteButton.hidden = Boolean(pricingFallbackMessage);
        }
      }
    }

    function scheduleCpcSync() {
      if (!usesCpcEngine() || !cpcForm) {
        return;
      }

      window.clearTimeout(cpcSyncTimer);
      cpcSyncTimer = window.setTimeout(function () {
        syncCpcForm();
        scheduleCpcPriceSync(650);
      }, 180);
    }

    function connectCpcEngine() {
      if (!usesCpcEngine() || cpcForm) {
        return;
      }

      cpcForm = document.querySelector(priceConfig.cpcFormSelector || "form.cpc-calculator-form");

      if (!cpcForm || cpcForm === form) {
        cpcForm = null;
        cpcDiscoveryAttempts += 1;

        if (cpcDiscoveryAttempts < 120) {
          window.setTimeout(connectCpcEngine, 250);
        } else if (priceEngineStatus) {
          priceEngineStatus.textContent = "Moteur de prix Apippa introuvable. L’ajout au panier est désactivé.";
          priceEngineStatus.classList.add("is-error");
          updateCpcSubmitState();
        }

        return;
      }

      if (priceConfig.hideCpcForm !== false) {
        cpcForm.classList.add("brut-cpc-engine-hidden");
      }

      if (cpcForm.dataset.brutQuantityGuard !== "true") {
        cpcForm.dataset.brutQuantityGuard = "true";
        cpcForm.addEventListener("formdata", function (event) {
          event.formData.set("quantity", String(getQuantity()));
          cleanCpcFormDataForSubmission(event.formData);
          if (!blockCpcTechnicalCartProperties(event.formData)) {
            throw new Error("Brut configurator: unable to protect technical cart properties");
          }
          var restoreTechnicalProperties = isolateCpcTechnicalPropertiesForSubmission();
          window.setTimeout(restoreTechnicalProperties, 0);
        });
      }

      var cpcPriceSelector = priceConfig.cpcPriceSelector || "#calculator-final-value";
      cpcPriceElement = cpcForm.querySelector(cpcPriceSelector) || document.querySelector(cpcPriceSelector);

      if (typeof MutationObserver !== "undefined") {
        var observeCpcPriceScope = function () {
          if (!cpcPriceObserver) return;
          cpcPriceObserver.disconnect();
          var scope = cpcPriceElement && cpcPriceElement.parentNode ? cpcPriceElement.parentNode : document.body;
          if (scope) cpcPriceObserver.observe(scope, { childList: true, characterData: true, subtree: true });
        };
        cpcPriceObserver = new MutationObserver(function (mutations) {
          var nextPriceElement = cpcForm.querySelector(cpcPriceSelector) || document.querySelector(cpcPriceSelector);
          var priceElementChanged = nextPriceElement !== cpcPriceElement;
          var priceContentChanged = Boolean(cpcPriceElement && mutations.some(function (mutation) {
            return mutation.target === cpcPriceElement || cpcPriceElement.contains(mutation.target);
          }));

          if (priceElementChanged) {
            cpcPriceElement = nextPriceElement;
            observeCpcPriceScope();
          }

          if (priceElementChanged || priceContentChanged) {
            scheduleCpcPriceSync(650);
          }
        });
        observeCpcPriceScope();
      }

      syncCpcForm();
      syncCpcPrice();
      updateCpcSubmitState();
    }

    async function submitThroughCpc() {
      if (cpcSubmissionPending) {
        return;
      }

      if (isQuoteOnlyMode()) {
        if (formMessage) {
          formMessage.textContent = "Cette configuration nécessite une demande de devis et ne peut pas être ajoutée au panier.";
        }
        return;
      }

      connectCpcEngine();

      if (!cpcForm) {
        if (formMessage) {
          formMessage.textContent = "Le moteur de prix Apippa n’est pas disponible. Le produit n’a pas été ajouté au panier.";
        }
        return;
      }

      var syncState = syncCpcForm();
      var pricingFallbackMessage = getCpcPaidOptionPricingMessage(syncState);

      if (pricingFallbackMessage) {
        showCpcPricingFallback(syncState);
        return;
      }

      syncCpcPrice();
      var priceGuardMessage = getCpcPriceGuardMessage();

      if (priceGuardMessage) {
        if (formMessage) {
          formMessage.textContent = getVisibleCpcGuardMessage(priceGuardMessage);
        }
        return;
      }

      var cpcSubmit = cpcForm.querySelector('button[type="submit"], input[type="submit"], button[name="add"]');

      if (!cpcSubmit) {
        if (formMessage) {
          formMessage.textContent = "Le bouton panier Apippa est introuvable. Le produit n’a pas été ajouté.";
        }
        return;
      }

      var stopLoading = startLoadingMessage("cart");
      cpcSubmissionPending = true;
      submitButton.disabled = true;
      submitButton.setAttribute("aria-disabled", "true");

      try {
        await attachPrivatePlanLink(cpcForm);
      } catch (error) {
        stopLoading();
        cpcSubmissionPending = false;
        if (formMessage) {
          formMessage.textContent = "Le plan de votre configuration n’a pas pu être enregistré. Aucun article n’a été ajouté. Réessayez ou contactez l’atelier.";
        }
        updateCpcSubmitState();
        return;
      }

      if (formMessage) {
        formMessage.textContent = "";
      }

      syncCpcPrice();

      var delayedPriceGuardMessage = getCpcPriceGuardMessage();

      if (delayedPriceGuardMessage) {
        if (formMessage) {
          formMessage.textContent = getVisibleCpcGuardMessage(delayedPriceGuardMessage);
        }
        stopLoading();
        cpcSubmissionPending = false;
        updateCpcSubmitState();
        return;
      }

      var restoreQuantityFields = isolateCpcQuantityForSubmission();
      var pageHideHandler = function () {
        window.clearTimeout(cpcSubmissionTimeout);
        restoreQuantityFields();
        stopLoading();
        cpcSubmissionPending = false;
      };
      window.addEventListener("pagehide", pageHideHandler, { once: true });

      try {
        cpcSubmit.click();
      } catch (error) {
        window.removeEventListener("pagehide", pageHideHandler);
        restoreQuantityFields();
        stopLoading();
        cpcSubmissionPending = false;
        if (formMessage) {
          formMessage.textContent = "L’ajout au panier n’a pas pu démarrer. Réessayez ou faites valider la configuration par l’atelier.";
        }
        updateCpcSubmitState();
        return;
      }

      window.clearTimeout(cpcSubmissionTimeout);
      cpcSubmissionTimeout = window.setTimeout(function () {
        window.removeEventListener("pagehide", pageHideHandler);
        restoreQuantityFields();
        stopLoading();
        cpcSubmissionPending = false;
        if (formMessage) {
          formMessage.textContent = "L’ajout n’a pas abouti après 45 secondes. Vérifiez votre panier avant de réessayer afin d’éviter un doublon.";
        }
        updateCpcSubmitState();
      }, 45000);
    }

    function getCornerMode() {
      return cornerMode ? cornerMode.value : "none";
    }

    function getCornerModeLabel(mode) {
      var labels = {
        radius: "Rayon classique",
        round: "Rond",
        half: "Demi-rond",
        oval: "Ovale"
      };

      return labels[mode] || "";
    }

    function getCornerModeOptionText(mode) {
      var width = getNumberBySummaryLabel("Largeur");

      if (mode === "round") {
        return width > 0 ? "Rond (R = " + formatDimension(width) + " cm)" : "Rond";
      }

      if (mode === "half") {
        return width > 0 ? "Demi-rond (R = " + formatDimension(width / 2) + " cm)" : "Demi-rond";
      }

      return "";
    }

    function syncCornerModeOptionLabels() {
      if (!cornerMode) {
        return;
      }

      ["round", "half"].forEach(function (mode) {
        var option = cornerMode.querySelector('option[value="' + mode + '"]');
        var label = getCornerModeOptionText(mode);

        if (option && label) {
          option.textContent = label;
        }
      });
    }

    function getCornerRadiusValue() {
      var mode = getCornerMode();
      var width = getNumberBySummaryLabel("Largeur");

      if (mode === "round") {
        return Math.max(0, width * 10);
      }

      if (mode === "half") {
        return Math.max(0, width * 5);
      }

      if (mode === "oval") {
        return Math.max(0, width * 5);
      }

      return mode === "radius" && cornerRadius ? toNumber(cornerRadius.value) : 0;
    }

    function getCornerRadiusLabel(radius) {
      var mode = getCornerMode();

      if (mode === "round") {
        return "Rayon " + formatDimension(radius / 10) + " cm (largeur complète)";
      }

      if (mode === "half") {
        return "Rayon " + formatDimension(radius / 10) + " cm (moitié de la largeur)";
      }

      if (mode === "oval") {
        return "Ovale complet";
      }

      return mode === "radius" && cornerRadius ? fieldValue(cornerRadius) : "";
    }

    function getCornerFeeHt() {
      if (getCornerValidationMessage()) return 0;
      var radiusCm = getCornerRadiusValue() / 10;
      var selectedCount = getSelectedCornerKeys().length;
      return radiusCm > 0 && selectedCount > 0 ? radiusCm * priceConfig.cornerPricePerRadiusCmHt * selectedCount : 0;
    }

    function getSelectedCorners() {
      return cornerButtons.filter(function (button) {
        return button.getAttribute("aria-pressed") === "true";
      });
    }

    function getSelectedCornerKeys() {
      return getSelectedCorners().map(function (button) {
        return button.dataset.brutCorner;
      });
    }

    function getCornerEnd(key) {
      return key === "tl" || key === "bl" ? "left" : "right";
    }

    function getEndKeys(end) {
      return end === "left" ? ["tl", "bl"] : ["tr", "br"];
    }

    function getCornerButton(key) {
      return cornerButtons.find(function (button) {
        return button.dataset.brutCorner === key;
      });
    }

    function setCornerPressed(key, pressed) {
      var button = getCornerButton(key);

      if (button) {
        button.setAttribute("aria-pressed", pressed ? "true" : "false");
      }
    }

    function normalizeCornerSelection() {
      var mode = getCornerMode();

      if (mode === "none") {
        cornerButtons.forEach(function (button) {
          button.setAttribute("aria-pressed", "false");
        });
        return;
      }

      if (mode === "oval") {
        var hasSelection = cornerButtons.some(function (button) {
          return button.getAttribute("aria-pressed") === "true";
        });

        cornerButtons.forEach(function (button) {
          button.setAttribute("aria-pressed", hasSelection ? "true" : "false");
        });
        return;
      }

      ["left", "right"].forEach(function (end) {
        var keys = getEndKeys(end);
        var selected = keys.filter(function (key) {
          var button = getCornerButton(key);
          return button && button.getAttribute("aria-pressed") === "true";
        });

        if (mode === "round" && selected.length > 1) {
          setCornerPressed(selected[1], false);
        }

        if (mode === "half" && selected.length) {
          keys.forEach(function (key) {
            setCornerPressed(key, true);
          });
        }
      });
    }

    function getCornerValidationMessage() {
      var mode = getCornerMode();
      var selectedKeys = getSelectedCornerKeys();
      var length = getNumberBySummaryLabel("Longueur");
      var width = getNumberBySummaryLabel("Largeur");
      var selectedEnds = ["left", "right"].filter(function (end) {
        return getEndKeys(end).some(function (key) {
          return selectedKeys.indexOf(key) !== -1;
        });
      }).length;

      if (mode === "none") {
        return "";
      }

      if (!selectedKeys.length) {
        return "Sélectionnez au moins un coin sur le plan.";
      }

      if (mode === "oval") {
        if (length < width) {
          return "La longueur doit être supérieure ou égale à la largeur pour une forme ovale.";
        }

        return "";
      }

      if (mode === "radius" && getCornerRadiusValue() / 10 > Math.min(length, width) / 2) {
        return "Le rayon choisi est trop grand pour ces dimensions.";
      }

      if (mode === "round" && selectedEnds * width > length) {
        return "La longueur doit permettre le rayon complet de " + formatDimension(width) + " cm" + (selectedEnds > 1 ? " à chaque bout." : ".");
      }

      if (mode === "half" && selectedEnds * (width / 2) > length) {
        return "La longueur est insuffisante pour ce demi-rond.";
      }

      return "";
    }

    function syncCornerSettings() {
      syncCornerModeOptionLabels();

      var mode = getCornerMode();
      var radius = getCornerRadiusValue();
      var radiusText = getCornerRadiusLabel(radius);
      var lockedMessage = "Choisissez d’abord une forme dans « Forme, découpes et renforts ».";

      normalizeCornerSelection();
      setControlVisibility(radiusField, mode === "radius");

      if (planCanvas) {
        planCanvas.classList.toggle("is-corner-selection-locked", mode === "none");
        planCanvas.dataset.cornerLockedMessage = lockedMessage;
      }

      var selectedButtons = getSelectedCorners();
      var selectedKeys = getSelectedCornerKeys();
      var labels = selectedButtons.map(function (button) {
        return button.dataset.cornerLabel || button.getAttribute("aria-label") || "Coin";
      });
      var selectionLabels = labels;

      if (mode === "half") {
        selectionLabels = ["left", "right"].filter(function (end) {
          return getEndKeys(end).some(function (key) {
            return selectedKeys.indexOf(key) !== -1;
          });
        }).map(function (end) {
          return end === "left" ? "Extrémité gauche" : "Extrémité droite";
        });
      } else if (mode === "oval" && selectedKeys.length) {
        selectionLabels = ["Plateau ovale complet"];
      }

      cornerButtons.forEach(function (button) {
        var key = button.dataset.brutCorner;
        var endKeys = getEndKeys(getCornerEnd(key));
        var selectedOnEnd = endKeys.find(function (endKey) {
          return selectedKeys.indexOf(endKey) !== -1;
        });
        var isSelected = selectedKeys.indexOf(key) !== -1;

        button.disabled = mode === "round" && Boolean(selectedOnEnd) && !isSelected;
        button.title = mode === "none" ? lockedMessage : (button.dataset.cornerLabel || "Sélectionner ce coin");
        button.classList.toggle("is-selected", isSelected);
        button.classList.toggle("is-linked", mode === "half" && isSelected);
      });

      if (cornerOutput) {
        cornerOutput.value = selectionLabels.length ? selectionLabels.join(", ") : "";
      }

      if (cornerRadiusOutput) {
        cornerRadiusOutput.value = labels.length ? radiusText : "";
      }

      if (cornerModeOutput) {
        cornerModeOutput.value = labels.length ? getCornerModeLabel(mode) : "";
      }

      var cornerFeeHt = getCornerFeeHt();
      var cornerFeeTtc = cornerFeeHt * priceConfig.taxMultiplier;
      if (cornerPriceOutput) {
        cornerPriceOutput.value = cornerFeeHt ? formatMoney(cornerFeeTtc) + " TTC" : "";
      }
      if (cornerPriceRawOutput) {
        cornerPriceRawOutput.value = cornerFeeHt.toFixed(2);
      }
      if (cornerFee) {
        cornerFee.textContent = cornerFeeHt
          ? "Prix des coins sélectionnés : " + formatMoney(cornerFeeTtc) + " TTC"
          : "Tarif : " + formatMoney(priceConfig.cornerPricePerRadiusCmHt * priceConfig.taxMultiplier) + " TTC par centimètre de rayon et par coin.";
      }

      if (cornerHelp) {
        if (mode === "round") {
          cornerHelp.textContent = "Rond : rayon " + formatDimension(radius / 10) + " cm. Le coin opposé du même bout est bloqué.";
        } else if (mode === "half") {
          cornerHelp.textContent = "Demi-rond : rayon " + formatDimension(radius / 10) + " cm. Cliquez à gauche, à droite, ou sur les deux extrémités indépendamment.";
        } else if (mode === "radius") {
          cornerHelp.textContent = "Rayon classique : vous pouvez sélectionner un ou plusieurs coins indépendamment.";
        } else {
          cornerHelp.textContent = "Sélectionnez une forme, puis cliquez sur le ou les coins du plateau.";
        }
      }

      if (cornerStatus) {
        var validationMessage = getCornerValidationMessage();
        cornerStatus.textContent = validationMessage && selectionLabels.length ? validationMessage : (selectionLabels.length ? selectionLabels.join(", ") + " · " + radiusText : (mode === "none" ? "Aucun coin sélectionné." : validationMessage));
        cornerStatus.classList.toggle("is-invalid", Boolean(validationMessage) && labels.length > 0);
      }

      liveCorners.forEach(function (corner) {
        corner.classList.remove("is-active");
      });
    }

    function formatPathNumber(value) {
      return String(Math.round(value * 10) / 10);
    }

    function syncPlanOrientationLabels(geometry) {
      if (!planOrientationLabels.length) {
        return;
      }

      var centerX = formatPathNumber((geometry.left + geometry.right) / 2);
      var positions = {
        back: Math.max(18, geometry.top - 9),
        front: Math.min(406, geometry.bottom + 18)
      };

      planOrientationLabels.forEach(function (label) {
        var side = label.dataset.brutPlanOrientation;
        var y = positions[side];

        if (!y) {
          return;
        }

        label.setAttribute("x", centerX);
        label.setAttribute("y", formatPathNumber(y));
        label.setAttribute("text-anchor", "middle");
      });
    }

    function appendHorizontalEdge(x1, x2, y, irregular, amplitude) {
      if (!irregular) {
        return " L " + formatPathNumber(x2) + " " + formatPathNumber(y);
      }

      var offsets = [-0.55, 0.34, -0.82, 0.48, -0.28, 0.76, -0.44, 0.24];
      var segments = offsets.length;
      var step = (x2 - x1) / segments;
      var path = "";

      offsets.forEach(function (offset, index) {
        var segmentStart = x1 + step * index;
        var segmentEnd = x1 + step * (index + 1);
        var control = segmentStart + step / 2;
        path += " Q " + formatPathNumber(control) + " " + formatPathNumber(y + amplitude * offset) + " " + formatPathNumber(segmentEnd) + " " + formatPathNumber(y);
      });

      return path;
    }

    function prettifyEdgeMachiningLabel(value) {
      var text = String(value || "")
        .replace(/\s*\(dessus\/dessous\)\s*/gi, "")
        .replace(/\s+/g, " ")
        .trim();

      text = text
        .replace(/^Toutes arêtes/i, "toutes les arêtes")
        .replace(/^Toutes aretes/i, "toutes les arêtes")
        .replace(/^1 longueur/i, "une longueur")
        .replace(/^2 longueurs/i, "deux longueurs")
        .replace(/ et largeur gauche/i, " et une largeur gauche")
        .replace(/ et largeur droite/i, " et une largeur droite")
        .replace(/ et 1 largeur/i, " et une largeur")
        .replace(/ et 2 largeurs/i, " et deux largeurs");

      return text ? text.charAt(0).toLowerCase() + text.slice(1) : "";
    }

    function removeEdgeTypeFromLabel(label, type) {
      var text = String(label || "");

      if (type === "cassées") {
        return text.replace(/\s+cassées?\b/gi, "").trim();
      }

      if (type === "arrondies") {
        return text.replace(/\s+arrondies?\b/gi, "").trim();
      }

      return text;
    }

    function getEdgeMachiningSelection() {
      var edge = selectedValueBySummaryLabel("Aretes") || selectedValueBySummaryLabel("Types d'aretes");
      var normalizedEdge = normalizeValue(edge);
      var isBroken = normalizedEdge.indexOf("cassee") !== -1;
      var isRounded = normalizedEdge.indexOf("arrondie") !== -1;

      if (!isBroken && !isRounded) {
        return null;
      }

      var detail = isBroken
        ? selectedValueBySummaryLabel("Details aretes cassees") || selectedValueBySummaryLabel("Choix des aretes cassees")
        : selectedValueBySummaryLabel("Details aretes arrondies") || selectedValueBySummaryLabel("Choix des aretes arrondies");
      var normalizedDetail = normalizeValue(detail || edge);
      var sides = [];

      if (normalizedDetail.indexOf("toutes") !== -1) {
        sides = ["front", "back", "left", "right"];
      } else {
        if (normalizedDetail.indexOf("2 longueurs") !== -1) {
          sides.push("front", "back");
        } else if (normalizedDetail.indexOf("longueur") !== -1) {
          sides.push("front");
        }

        if (normalizedDetail.indexOf("2 largeurs") !== -1) {
          sides.push("left", "right");
        } else if (normalizedDetail.indexOf("largeur gauche") !== -1) {
          sides.push("left");
        } else if (normalizedDetail.indexOf("largeur droite") !== -1 || normalizedDetail.indexOf("1 largeur") !== -1) {
          sides.push("right");
        }
      }

      if (!sides.length) {
        sides = ["front", "back", "left", "right"];
      }

      sides = sides.filter(function (side, index, list) {
        return list.indexOf(side) === index;
      });

      var edgeType = isBroken ? "cassées" : "arrondies";
      var label = removeEdgeTypeFromLabel(prettifyEdgeMachiningLabel(detail || edge), edgeType);

      return {
        detail: detail || edge,
        sides: sides,
        legend: label ? "Usinage des arêtes : " + edgeType + " · " + label + "." : "",
        legendPrefix: "Usinage des arêtes :",
        legendType: edgeType,
        legendValue: label ? label + "." : ""
      };
    }

    function buildPlanEdgeHighlightPath(geometry, side) {
      var offset = 26;
      var inset = Math.max(10, Math.min(18, Math.min(geometry.drawWidth, geometry.drawHeight) * 0.06));
      var x1 = geometry.left + inset;
      var x2 = geometry.right - inset;
      var y1 = geometry.top + inset;
      var y2 = geometry.bottom - inset;

      if (side === "front") {
        return "M " + formatPathNumber(x1) + " " + formatPathNumber(geometry.bottom + offset) + " H " + formatPathNumber(x2);
      }

      if (side === "back") {
        return "M " + formatPathNumber(x1) + " " + formatPathNumber(geometry.top - offset) + " H " + formatPathNumber(x2);
      }

      if (side === "left") {
        return "M " + formatPathNumber(geometry.left - offset) + " " + formatPathNumber(y1) + " V " + formatPathNumber(y2);
      }

      if (side === "right") {
        return "M " + formatPathNumber(geometry.right + offset) + " " + formatPathNumber(y1) + " V " + formatPathNumber(y2);
      }

      return "";
    }

    function syncPlanEdgeHighlights(geometry, selection) {
      var activeSides = selection ? selection.sides : [];

      planEdgeHighlights.forEach(function (path) {
        var side = path.dataset.brutPlanEdgeHighlight;
        var shouldShow = activeSides.indexOf(side) !== -1;
        path.setAttribute("d", shouldShow ? buildPlanEdgeHighlightPath(geometry, side) : "");
        path.toggleAttribute("hidden", !shouldShow);
      });

      if (planEdgeLegend) {
        planEdgeLegend.toggleAttribute("hidden", !selection || !selection.legend);
      }

      if (planEdgeLegendText) {
        while (planEdgeLegendText.firstChild) {
          planEdgeLegendText.removeChild(planEdgeLegendText.firstChild);
        }
        if (selection && selection.legendValue) {
          var prefix = document.createElement("span");
          var type = document.createElement("strong");
          var value = document.createElement("span");
          prefix.textContent = selection.legendPrefix + " ";
          type.textContent = selection.legendType;
          value.textContent = " · " + selection.legendValue;
          planEdgeLegendText.appendChild(prefix);
          planEdgeLegendText.appendChild(type);
          planEdgeLegendText.appendChild(value);
        }
      }
    }

    function getPlanGeometry() {
      var length = Math.max(0.1, getNumberBySummaryLabel("Longueur") || 120);
      var width = Math.max(0.1, getNumberBySummaryLabel("Largeur") || 60);
      var availableWidth = 620;
      var availableHeight = 244;
      var scale = Math.min(availableWidth / length, availableHeight / width);
      var drawWidth = length * scale;
      var drawHeight = width * scale;
      var adjusted = false;

      if (drawWidth < 100) {
        drawWidth = 100;
        adjusted = true;
      }

      if (drawHeight < 52) {
        drawHeight = 52;
        adjusted = true;
      }

      var left = (760 - drawWidth) / 2;
      var top = (420 - drawHeight) / 2;

      return {
        length: length,
        width: width,
        left: left,
        right: left + drawWidth,
        top: top,
        bottom: top + drawHeight,
        drawWidth: drawWidth,
        drawHeight: drawHeight,
        scaleX: drawWidth / length,
        scaleY: drawHeight / width,
        adjusted: adjusted
      };
    }

    function buildBoardShape(geometry) {
      var mode = getCornerMode();
      var selected = getSelectedCornerKeys();
      var border = normalizeValue(selectedValueBySummaryLabel("Bords"));
      var topIrregular = border.indexOf("2 bords irreguliers") !== -1;
      var bottomIrregular = topIrregular || border.indexOf("1 bord irregulier") !== -1;
      var xL = geometry.left;
      var xR = geometry.right;
      var yT = geometry.top;
      var yB = geometry.bottom;
      var boardHeight = geometry.drawHeight;

      if (mode === "oval" && selected.length) {
        var cx = (xL + xR) / 2;
        var cy = (yT + yB) / 2;
        var rx = geometry.drawWidth / 2;
        var ry = geometry.drawHeight / 2;
        var kappa = 0.5522847498;
        var ovalPath = "M " + formatPathNumber(cx) + " " + formatPathNumber(yT);
        ovalPath += " C " + formatPathNumber(cx + rx * kappa) + " " + formatPathNumber(yT) + " " + formatPathNumber(xR) + " " + formatPathNumber(cy - ry * kappa) + " " + formatPathNumber(xR) + " " + formatPathNumber(cy);
        ovalPath += " C " + formatPathNumber(xR) + " " + formatPathNumber(cy + ry * kappa) + " " + formatPathNumber(cx + rx * kappa) + " " + formatPathNumber(yB) + " " + formatPathNumber(cx) + " " + formatPathNumber(yB);
        ovalPath += " C " + formatPathNumber(cx - rx * kappa) + " " + formatPathNumber(yB) + " " + formatPathNumber(xL) + " " + formatPathNumber(cy + ry * kappa) + " " + formatPathNumber(xL) + " " + formatPathNumber(cy);
        ovalPath += " C " + formatPathNumber(xL) + " " + formatPathNumber(cy - ry * kappa) + " " + formatPathNumber(cx - rx * kappa) + " " + formatPathNumber(yT) + " " + formatPathNumber(cx) + " " + formatPathNumber(yT) + " Z";

        return {
          path: ovalPath,
          specialPath: "",
          bottomIrregular: false,
          topIrregular: false
        };
      }

      var standardRadius = mode === "radius" ? Math.min(getCornerRadiusValue() / 10 * Math.min(geometry.scaleX, geometry.scaleY), boardHeight / 2, geometry.drawWidth / 2) : 0;
      var rtl = selected.indexOf("tl") !== -1 ? standardRadius : 0;
      var rtr = selected.indexOf("tr") !== -1 ? standardRadius : 0;
      var rbl = selected.indexOf("bl") !== -1 ? standardRadius : 0;
      var rbr = selected.indexOf("br") !== -1 ? standardRadius : 0;
      var topStart = xL + rtl;
      var topEnd = xR - rtr;
      var bottomStart = xR - rbr;
      var bottomEnd = xL + rbl;
      var rightPath = "";
      var leftPath = "";

      if (mode === "round" && selected.indexOf("tr") !== -1) {
        topEnd = xR - boardHeight;
        bottomStart = xR;
        rightPath = " A " + formatPathNumber(boardHeight) + " " + formatPathNumber(boardHeight) + " 0 0 1 " + formatPathNumber(xR) + " " + formatPathNumber(yB);
      } else if (mode === "round" && selected.indexOf("br") !== -1) {
        topEnd = xR;
        bottomStart = xR - boardHeight;
        rightPath = " A " + formatPathNumber(boardHeight) + " " + formatPathNumber(boardHeight) + " 0 0 1 " + formatPathNumber(xR - boardHeight) + " " + formatPathNumber(yB);
      } else if (mode === "half" && selected.indexOf("tr") !== -1) {
        var rightHalfRadius = boardHeight / 2;
        topEnd = xR - rightHalfRadius;
        bottomStart = xR - rightHalfRadius;
        rightPath = " A " + formatPathNumber(rightHalfRadius) + " " + formatPathNumber(rightHalfRadius) + " 0 0 1 " + formatPathNumber(xR - rightHalfRadius) + " " + formatPathNumber(yB);
      } else {
        rightPath = " Q " + formatPathNumber(xR) + " " + formatPathNumber(yT) + " " + formatPathNumber(xR) + " " + formatPathNumber(yT + rtr);
        rightPath += " L " + formatPathNumber(xR) + " " + formatPathNumber(yB - rbr);
        rightPath += " Q " + formatPathNumber(xR) + " " + formatPathNumber(yB) + " " + formatPathNumber(bottomStart) + " " + formatPathNumber(yB);
      }

      if (mode === "round" && selected.indexOf("tl") !== -1) {
        topStart = xL + boardHeight;
        bottomEnd = xL;
        leftPath = " A " + formatPathNumber(boardHeight) + " " + formatPathNumber(boardHeight) + " 0 0 1 " + formatPathNumber(xL + boardHeight) + " " + formatPathNumber(yT);
      } else if (mode === "round" && selected.indexOf("bl") !== -1) {
        topStart = xL;
        bottomEnd = xL + boardHeight;
        leftPath = " A " + formatPathNumber(boardHeight) + " " + formatPathNumber(boardHeight) + " 0 0 1 " + formatPathNumber(xL) + " " + formatPathNumber(yT);
      } else if (mode === "half" && selected.indexOf("tl") !== -1) {
        var leftHalfRadius = boardHeight / 2;
        topStart = xL + leftHalfRadius;
        bottomEnd = xL + leftHalfRadius;
        leftPath = " A " + formatPathNumber(leftHalfRadius) + " " + formatPathNumber(leftHalfRadius) + " 0 0 1 " + formatPathNumber(xL + leftHalfRadius) + " " + formatPathNumber(yT);
      } else {
        leftPath = " Q " + formatPathNumber(xL) + " " + formatPathNumber(yB) + " " + formatPathNumber(xL) + " " + formatPathNumber(yB - rbl);
        leftPath += " L " + formatPathNumber(xL) + " " + formatPathNumber(yT + rtl);
        leftPath += " Q " + formatPathNumber(xL) + " " + formatPathNumber(yT) + " " + formatPathNumber(topStart) + " " + formatPathNumber(yT);
      }

      var amplitude = Math.max(3, Math.min(10, boardHeight * 0.045));
      var path = "M " + formatPathNumber(topStart) + " " + formatPathNumber(yT);
      path += appendHorizontalEdge(topStart, topEnd, yT, topIrregular, amplitude);
      path += rightPath;
      path += appendHorizontalEdge(bottomStart, bottomEnd, yB, bottomIrregular, amplitude);
      path += leftPath + " Z";
      var specialPath = "";

      if (bottomIrregular) {
        specialPath = "M " + formatPathNumber(bottomStart) + " " + formatPathNumber(yB) + appendHorizontalEdge(bottomStart, bottomEnd, yB, true, amplitude);
      }

      if (topIrregular) {
        specialPath += " M " + formatPathNumber(topStart) + " " + formatPathNumber(yT) + appendHorizontalEdge(topStart, topEnd, yT, true, amplitude);
      }

      return {
        path: path,
        specialPath: specialPath,
        bottomIrregular: bottomIrregular,
        topIrregular: topIrregular
      };
    }

    function getCutoutState(item, geometry) {
      return {
        item: item,
        index: item ? item.index : 1,
        enabled: Boolean(item && item.enabled && item.enabled.checked),
        type: item && item.type ? item.type.value : "inside",
        edge: item && item.edge ? item.edge.value : "front",
        opening: item && item.opening ? parseUserNumber(item.opening.value) : 0,
        depth: item && item.depth ? parseUserNumber(item.depth.value) : 0,
        x: item && item.x ? parseUserNumber(item.x.value) : 0,
        y: item && item.y ? parseUserNumber(item.y.value) : 0,
        geometry: geometry
      };
    }

    function getCutoutStates(geometry) {
      return cutoutItems.map(function (item) {
        return getCutoutState(item, geometry);
      });
    }

    function isPointInsideConfiguredBoard(x, y, geometry) {
      var mode = getCornerMode();
      var selected = getSelectedCornerKeys();

      if (x < -0.000001 || x > geometry.length + 0.000001 || y < -0.000001 || y > geometry.width + 0.000001) {
        return false;
      }

      if (!selected.length || mode === "none") {
        return true;
      }

      // The area/weight calculation already uses these exact shape bounds.
      // Convert the customer's Y (from the front) to that calculation's Y (from the back).
      var bounds = getBoardHorizontalBounds(geometry.width - y, geometry.length, geometry.width, {
        mode: mode,
        selected: selected,
        radius: Math.min(getCornerRadiusValue() / 10, geometry.length / 2, geometry.width / 2)
      });
      return x >= bounds.left - 0.000001 && x <= bounds.right + 0.000001;
    }

    function getCutoutCornersCm(state) {
      var left;
      var right;
      var front;
      var back;

      if (state.type === "inside") {
        left = state.x;
        right = state.x + state.opening;
        front = state.y;
        back = state.y + state.depth;
      } else if (state.edge === "front" || state.edge === "back") {
        left = state.x;
        right = state.x + state.opening;
        front = state.edge === "front" ? 0 : state.geometry.width - state.depth;
        back = state.edge === "front" ? state.depth : state.geometry.width;
      } else {
        left = state.edge === "left" ? 0 : state.geometry.length - state.depth;
        right = state.edge === "left" ? state.depth : state.geometry.length;
        front = state.y;
        back = state.y + state.opening;
      }

      return [[left, front], [right, front], [left, back], [right, back]];
    }

    function getIrregularEdgeSafetyCm(geometry) {
      // The Bézier waves can intrude into the nominal board by half their
      // control-point offset. Use the largest configured offset as a safe envelope.
      var amplitude = Math.max(3, Math.min(10, geometry.drawHeight * 0.045));
      return amplitude * 0.82 / 2 / geometry.scaleY;
    }

    function getCutoutValidationMessage(state) {
      if (!state.enabled) {
        return "";
      }

      if (!Number.isFinite(state.opening) || !Number.isFinite(state.depth) || !Number.isFinite(state.x) || !Number.isFinite(state.y)) {
        return "Utilisez uniquement des nombres, avec une virgule ou un point pour les décimales.";
      }

      if (state.opening <= 0 || state.depth <= 0) {
        return "L’ouverture et la profondeur doivent être supérieures à 0 cm.";
      }

      if (state.x < 0 || state.y < 0) {
        return "Les distances X et Y ne peuvent pas être négatives.";
      }

      if (getSelectedCornerKeys().length && getCornerValidationMessage()) {
        return "Corrigez d’abord la forme du plateau avant de valider la découpe.";
      }

      if (state.type === "inside") {
        if (state.x <= 0 || state.y <= 0 || state.x + state.opening >= state.geometry.length || state.y + state.depth >= state.geometry.width) {
          return "Une découpe intérieure doit conserver de la matière sur chacun des quatre côtés.";
        }

        var border = normalizeValue(selectedValueBySummaryLabel("Bords"));
        var backIrregular = border.indexOf("2 bords irreguliers") !== -1;
        var frontIrregular = backIrregular || border.indexOf("1 bord irregulier") !== -1;
        var irregularSafety = getIrregularEdgeSafetyCm(state.geometry);
        if ((frontIrregular && state.y < irregularSafety) ||
            (backIrregular && state.geometry.width - state.y - state.depth < irregularSafety)) {
          return "La découpe est trop proche du bord irrégulier réel. Éloignez-la du bord ou faites valider ce cas par l’atelier.";
        }

      } else if (state.edge === "front" || state.edge === "back") {
        if (state.x + state.opening > state.geometry.length) {
          return "La découpe dépasse le bord choisi.";
        }

        if (state.depth > state.geometry.width) {
          return "La profondeur dépasse la largeur du plateau.";
        }
      } else {
        if (state.y + state.opening > state.geometry.width) {
          return "La découpe dépasse le bord choisi.";
        }

        if (state.depth > state.geometry.length) {
          return "La profondeur dépasse la longueur du plateau.";
        }
      }

      if (getCutoutCornersCm(state).some(function (point) {
        return !isPointInsideConfiguredBoard(point[0], point[1], state.geometry);
      })) {
        return state.type === "inside"
          ? "La découpe sort de la forme réelle du plateau. Ajustez les cotes ou faites valider ce cas par l’atelier."
          : "La découpe extérieure empiète sur la partie arrondie du plateau. Déplacez-la sur une portion droite ou faites valider ce cas par l’atelier.";
      }

      return "";
    }

    function getCutoutFeeHt(state) {
      if (!state.enabled || getCutoutValidationMessage(state)) {
        return 0;
      }

      var area = state.opening * state.depth / 10000;
      return priceConfig.cutoutBaseFeeHt + area * priceConfig.cutoutAreaRateHt;
    }

    function getCutoutRectangle(state) {
      var geometry = state.geometry;
      var rect = { x: 0, y: 0, width: 0, height: 0 };

      if (state.type === "inside") {
        rect.x = geometry.left + state.x * geometry.scaleX;
        rect.y = geometry.bottom - (state.y + state.depth) * geometry.scaleY;
        rect.width = state.opening * geometry.scaleX;
        rect.height = state.depth * geometry.scaleY;
      } else if (state.edge === "front" || state.edge === "back") {
        rect.x = geometry.left + state.x * geometry.scaleX;
        rect.y = state.edge === "front" ? geometry.bottom - state.depth * geometry.scaleY : geometry.top;
        rect.width = state.opening * geometry.scaleX;
        rect.height = state.depth * geometry.scaleY;
      } else {
        rect.x = state.edge === "left" ? geometry.left : geometry.right - state.depth * geometry.scaleX;
        rect.y = geometry.bottom - (state.y + state.opening) * geometry.scaleY;
        rect.width = state.depth * geometry.scaleX;
        rect.height = state.opening * geometry.scaleY;
      }

      return rect;
    }

    function getCutoutAreaRectangleCm(state, length, width) {
      if (!state.enabled || getCutoutValidationMessage(state)) {
        return null;
      }

      var rectangle;

      if (state.type === "inside") {
        rectangle = {
          left: state.x,
          right: state.x + state.opening,
          top: width - state.y - state.depth,
          bottom: width - state.y
        };
      } else if (state.edge === "front" || state.edge === "back") {
        rectangle = {
          left: state.x,
          right: state.x + state.opening,
          top: state.edge === "front" ? width - state.depth : 0,
          bottom: state.edge === "front" ? width : state.depth
        };
      } else {
        rectangle = {
          left: state.edge === "left" ? 0 : length - state.depth,
          right: state.edge === "left" ? state.depth : length,
          top: width - state.y - state.opening,
          bottom: width - state.y
        };
      }

      rectangle.left = clampNumber(rectangle.left, 0, length);
      rectangle.right = clampNumber(rectangle.right, 0, length);
      rectangle.top = clampNumber(rectangle.top, 0, width);
      rectangle.bottom = clampNumber(rectangle.bottom, 0, width);

      return rectangle.right > rectangle.left && rectangle.bottom > rectangle.top ? rectangle : null;
    }

    function getBoardHorizontalBounds(y, length, width, shape) {
      var left = 0;
      var right = length;
      var mode = shape.mode;
      var selected = shape.selected;

      if (!selected.length) {
        return { left: left, right: right };
      }

      if (mode === "oval") {
        var ovalY = (y - width / 2) / (width / 2);
        var ovalFactor = Math.sqrt(Math.max(0, 1 - ovalY * ovalY));
        var ovalHalfWidth = length / 2 * ovalFactor;
        return {
          left: length / 2 - ovalHalfWidth,
          right: length / 2 + ovalHalfWidth
        };
      }

      if (mode === "radius") {
        var radius = shape.radius;
        var topInset = y < radius
          ? radius - Math.sqrt(Math.max(0, radius * radius - Math.pow(y - radius, 2)))
          : 0;
        var bottomInset = y > width - radius
          ? radius - Math.sqrt(Math.max(0, radius * radius - Math.pow(y - (width - radius), 2)))
          : 0;

        if (selected.indexOf("tl") !== -1) left = Math.max(left, topInset);
        if (selected.indexOf("bl") !== -1) left = Math.max(left, bottomInset);
        if (selected.indexOf("tr") !== -1) right = Math.min(right, length - topInset);
        if (selected.indexOf("br") !== -1) right = Math.min(right, length - bottomInset);
      } else if (mode === "round") {
        var fullRadius = width;
        var topRound = fullRadius - Math.sqrt(Math.max(0, fullRadius * fullRadius - Math.pow(y - width, 2)));
        var bottomRound = fullRadius - Math.sqrt(Math.max(0, fullRadius * fullRadius - y * y));

        if (selected.indexOf("tl") !== -1) left = Math.max(left, topRound);
        if (selected.indexOf("bl") !== -1) left = Math.max(left, bottomRound);
        if (selected.indexOf("tr") !== -1) right = Math.min(right, length - topRound);
        if (selected.indexOf("br") !== -1) right = Math.min(right, length - bottomRound);
      } else if (mode === "half") {
        var halfRadius = width / 2;
        var halfInset = halfRadius - Math.sqrt(Math.max(0, halfRadius * halfRadius - Math.pow(y - halfRadius, 2)));
        var leftEndSelected = selected.indexOf("tl") !== -1 || selected.indexOf("bl") !== -1;
        var rightEndSelected = selected.indexOf("tr") !== -1 || selected.indexOf("br") !== -1;

        if (leftEndSelected) left = Math.max(left, halfInset);
        if (rightEndSelected) right = Math.min(right, length - halfInset);
      }

      return {
        left: clampNumber(left, 0, length),
        right: clampNumber(Math.max(left, right), 0, length)
      };
    }

    function getBoardWidthAfterCutouts(y, length, width, shape, cutoutRectangles) {
      var bounds = getBoardHorizontalBounds(y, length, width, shape);
      var intervals = cutoutRectangles.map(function (rectangle) {
        return {
          left: Math.max(bounds.left, rectangle.left),
          right: Math.min(bounds.right, rectangle.right)
        };
      }).filter(function (interval) {
        return interval.right > interval.left;
      }).sort(function (a, b) {
        return a.left - b.left;
      });
      var removedWidth = 0;
      var current = null;

      intervals.forEach(function (interval) {
        if (!current || interval.left > current.right) {
          if (current) removedWidth += current.right - current.left;
          current = { left: interval.left, right: interval.right };
        } else {
          current.right = Math.max(current.right, interval.right);
        }
      });

      if (current) removedWidth += current.right - current.left;
      return Math.max(0, bounds.right - bounds.left - removedWidth);
    }

    function integrateBoardAreaSegment(top, bottom, length, width, shape, cutoutRectangles) {
      var height = bottom - top;

      if (height <= 0) {
        return 0;
      }

      var steps = Math.max(20, Math.ceil(height / width * 800));
      if (steps % 2 !== 0) steps += 1;
      var step = height / steps;
      var sum = getBoardWidthAfterCutouts(top, length, width, shape, cutoutRectangles) +
        getBoardWidthAfterCutouts(bottom, length, width, shape, cutoutRectangles);

      for (var index = 1; index < steps; index += 1) {
        sum += (index % 2 === 0 ? 2 : 4) *
          getBoardWidthAfterCutouts(top + index * step, length, width, shape, cutoutRectangles);
      }

      return sum * step / 3;
    }

    function getNetBoardAreaCm2(length, width, cutoutStates) {
      if (!(length > 0 && width > 0)) {
        return 0;
      }

      var rectangles = cutoutStates.map(function (state) {
        return getCutoutAreaRectangleCm(state, length, width);
      }).filter(Boolean);
      var breakpoints = [0, width];
      var shape = {
        mode: getCornerMode(),
        selected: getCornerValidationMessage() ? [] : getSelectedCornerKeys(),
        radius: Math.min(getCornerRadiusValue() / 10, length / 2, width / 2)
      };

      rectangles.forEach(function (rectangle) {
        breakpoints.push(rectangle.top, rectangle.bottom);
      });

      if (shape.mode === "radius" && shape.selected.length) {
        breakpoints.push(shape.radius, width - shape.radius);
      }

      breakpoints = breakpoints.filter(function (value) {
        return value >= 0 && value <= width;
      }).sort(function (a, b) {
        return a - b;
      }).filter(function (value, index, values) {
        return index === 0 || Math.abs(value - values[index - 1]) > 0.000001;
      });

      var area = 0;

      for (var index = 0; index < breakpoints.length - 1; index += 1) {
        var top = breakpoints[index];
        var bottom = breakpoints[index + 1];
        var middle = (top + bottom) / 2;
        var activeRectangles = rectangles.filter(function (rectangle) {
          return middle > rectangle.top && middle < rectangle.bottom;
        });
        area += integrateBoardAreaSegment(top, bottom, length, width, shape, activeRectangles);
      }

      return clampNumber(area, 0, length * width);
    }

    function getCutoutOutputText(state) {
      if (!state.enabled || getCutoutValidationMessage(state)) {
        return "";
      }

      var opening = formatDimension(state.opening);
      var depth = formatDimension(state.depth);
      var x = formatDimension(state.x);
      var y = formatDimension(state.y);

      if (state.type === "inside") {
        return "Découpe " + state.index + " : intérieure rectangle " + opening + " × " + depth + " cm · X " + x + " cm depuis la gauche · Y " + y + " cm depuis l’avant";
      }

      var edgeLabels = { front: "avant", back: "arrière", left: "gauche", right: "droit" };
      var position = state.edge === "front" || state.edge === "back" ? "X " + x + " cm depuis la gauche" : "Y " + y + " cm depuis l’avant";
      return "Découpe " + state.index + " : extérieure, bord " + edgeLabels[state.edge] + " · ouverture " + opening + " cm · profondeur " + depth + " cm · " + position;
    }

    function syncCutoutSettings(geometry) {
      var states = getCutoutStates(geometry || getPlanGeometry());
      var validStates = [];
      var totalFeeHt = 0;

      states.forEach(function (state) {
        var item = state.item;
        var enabled = state.enabled;
        var isOutside = state.type === "outside";
        var side = state.edge;
        var message = getCutoutValidationMessage(state);
        var feeHt = getCutoutFeeHt(state);

        setControlVisibility(item.fields, enabled);
        setControlVisibility(item.edgeField, enabled && isOutside);
        setControlVisibility(item.xField, enabled && (!isOutside || side === "front" || side === "back"));
        setControlVisibility(item.yField, enabled && (!isOutside || side === "left" || side === "right"));

        if (item.x) item.x.min = "0";
        if (item.y) item.y.min = "0";
        if (item.error) item.error.textContent = message;
        [item.opening, item.depth, item.x, item.y].forEach(function (control) {
          if (control) control.setAttribute("aria-invalid", message ? "true" : "false");
        });
        if (item.fee) {
          var feeTtc = feeHt * priceConfig.taxMultiplier;
          item.fee.textContent = enabled && !message
            ? "Prix de cette découpe : " + formatMoney(feeTtc) + " TTC (" + formatMoney(priceConfig.cutoutBaseFeeHt * priceConfig.taxMultiplier) + " + " + formatMoney(priceConfig.cutoutAreaRateHt * priceConfig.taxMultiplier) + "/m²)"
            : "Forfait minimal " + formatMoney(priceConfig.cutoutBaseFeeHt * priceConfig.taxMultiplier) + " TTC + " + formatMoney(priceConfig.cutoutAreaRateHt * priceConfig.taxMultiplier) + " TTC/m² découpé";
        }

        if (enabled && !message) {
          validStates.push(state);
          totalFeeHt += feeHt;
        }
      });

      var hasEnabledCutout = states.some(function (state) { return state.enabled; });
      if (cutoutConfirmationWrap) {
        cutoutConfirmationWrap.hidden = !hasEnabledCutout;
      }
      if (cutoutConfirmation) {
        cutoutConfirmation.disabled = !hasEnabledCutout;
        cutoutConfirmation.required = hasEnabledCutout;
        if (!hasEnabledCutout) cutoutConfirmation.checked = false;
      }

      if (cutoutOutput) {
        cutoutOutput.value = validStates.map(getCutoutOutputText).join(" | ");
      }

      if (cutoutTypeOutput) {
        cutoutTypeOutput.value = validStates.length === 0
          ? "Aucune"
          : (validStates.length === 1 ? (validStates[0].type === "outside" ? "Découpe extérieure" : "Découpe intérieure") : "Deux découpes");
      }

      if (cutoutPriceOutput) {
        cutoutPriceOutput.value = validStates.length ? formatMoney(totalFeeHt * priceConfig.taxMultiplier) + " TTC" : "";
      }
      if (cutoutPriceRawOutput) {
        cutoutPriceRawOutput.value = totalFeeHt.toFixed(2);
      }
    }

    function setSvgRectangle(element, rect) {
      if (!element) {
        return;
      }

      element.setAttribute("x", formatPathNumber(rect.x));
      element.setAttribute("y", formatPathNumber(rect.y));
      element.setAttribute("width", formatPathNumber(rect.width));
      element.setAttribute("height", formatPathNumber(rect.height));
    }

    function setSvgTextLabel(element, text, x, y, anchor) {
      if (!element) {
        return;
      }

      element.textContent = text || "";
      element.setAttribute("x", formatPathNumber(x));
      element.setAttribute("y", formatPathNumber(y));
      element.setAttribute("text-anchor", anchor || "middle");
    }

    function setCutoutButtonLabel(button, visible, text, x, y, fieldLabel) {
      if (!button) {
        return;
      }

      button.hidden = !visible;
      button.textContent = visible ? text : "";
      button.setAttribute("aria-label", visible ? "Modifier " + fieldLabel : "");
      button.style.setProperty("--brut-cutout-label-x", clampNumber(x / 760 * 100, 3, 97) + "%");
      button.style.setProperty("--brut-cutout-label-y", clampNumber(y / 420 * 100, 4, 96) + "%");
    }

    function setCutoutMeasurementLabels(item, labels) {
      var labelMap = {
        x: "la distance X de la découpe " + item.index,
        y: "la distance Y de la découpe " + item.index,
        opening: "l’ouverture de la découpe " + item.index,
        depth: "la profondeur de la découpe " + item.index
      };

      Object.keys(labels).forEach(function (key) {
        var label = labels[key];
        setCutoutButtonLabel(label.button, label.visible, label.text, label.x, label.y, labelMap[key]);
        var legendButton = item.legendButtons[key];
        if (legendButton) {
          legendButton.hidden = !label.visible;
          legendButton.textContent = label.visible ? label.text : "";
          legendButton.setAttribute("aria-label", label.visible ? "Modifier " + labelMap[key] : "");
        }
      });
    }

    function clearCutoutMeasurementLabels(item) {
      setSvgTextLabel(item.labelX, "", 0, 0);
      setSvgTextLabel(item.labelY, "", 0, 0);
      setSvgTextLabel(item.labelOpening, "", 0, 0);
      setSvgTextLabel(item.labelDepth, "", 0, 0);
      setCutoutMeasurementLabels(item, {
        x: { button: item.buttonX, visible: false, text: "", x: 0, y: 0 },
        y: { button: item.buttonY, visible: false, text: "", x: 0, y: 0 },
        opening: { button: item.buttonOpening, visible: false, text: "", x: 0, y: 0 },
        depth: { button: item.buttonDepth, visible: false, text: "", x: 0, y: 0 }
      });
    }

    function syncCutoutDrawing(geometry) {
      getCutoutStates(geometry).forEach(function (state) {
        var item = state.item;
        var message = getCutoutValidationMessage(state);
        var canDraw = state.enabled && [state.opening, state.depth, state.x, state.y].every(Number.isFinite) &&
          state.opening > 0 && state.depth > 0;
        var isValid = canDraw && !message;

        if (item.mask) item.mask.toggleAttribute("hidden", !isValid);
        if (item.outline) {
          item.outline.toggleAttribute("hidden", !canDraw);
          item.outline.classList.toggle("is-invalid", canDraw && !isValid);
        }
        if (item.guides) item.guides.toggleAttribute("hidden", !canDraw);
        if (item.mobileLegend) {
          item.mobileLegend.hidden = !canDraw;
          item.mobileLegend.classList.toggle("is-invalid", canDraw && !isValid);
          var legendTitle = item.mobileLegend.querySelector("strong");
          if (legendTitle) legendTitle.textContent = "Découpe " + state.index + (isValid
            ? " · Touchez une cote pour la modifier"
            : " · Cotes à corriger avant commande");
        }

        if (!canDraw) {
          clearCutoutMeasurementLabels(item);
          return;
        }

        var rect = getCutoutRectangle(state);
        setSvgRectangle(item.mask, rect);
        setSvgRectangle(item.outline, rect);

        var cornerX = rect.x;
        var cornerY = rect.y + rect.height;
        var xGuideOffset = state.index > 1
          ? (cornerY + 20 < geometry.bottom - 4 ? 20 : -20)
          : 0;
        var xGuideY = cornerY + xGuideOffset;
        var xGuideBendX = Math.max(geometry.left, cornerX - 10);
        var showX = state.type === "inside" || state.edge === "front" || state.edge === "back";
        var showY = state.type === "inside" || state.edge === "left" || state.edge === "right";
        var labelGap = clampNumber(rect.height * 0.18, 11, 18);
        var centerX = rect.x + rect.width / 2;
        var centerY = rect.y + rect.height / 2;
        var openingText = "O" + state.index + " · ouverture " + formatDimension(state.opening) + " cm";
        var depthText = "P" + state.index + " · profondeur " + formatDimension(state.depth) + " cm";
        var xText = "D" + state.index + " · X " + formatDimension(state.x) + " cm";
        var yText = "D" + state.index + " · Y " + formatDimension(state.y) + " cm";
        var xLabelX = (geometry.left + cornerX) / 2;
        var xLabelY = xGuideY + (xGuideOffset < 0 ? -14 : 14);
        var yLabelX = cornerX - 10;
        var yLabelY = (geometry.bottom + cornerY) / 2;
        var openingLabelY = centerY - labelGap;
        var depthLabelY = centerY + labelGap;
        var openingGuideY = rect.y + Math.min(12, rect.height * 0.25);
        var depthGuideX = rect.x + rect.width - Math.min(12, rect.width * 0.25);
        var paths = {
          x: showX ? (xGuideOffset
            ? "M " + formatPathNumber(geometry.left) + " " + formatPathNumber(xGuideY) + " H " + formatPathNumber(xGuideBendX) + " V " + formatPathNumber(cornerY) + " H " + formatPathNumber(cornerX)
            : "M " + formatPathNumber(geometry.left) + " " + formatPathNumber(cornerY) + " H " + formatPathNumber(cornerX)) : "",
          y: showY ? "M " + formatPathNumber(cornerX) + " " + formatPathNumber(geometry.bottom) + " V " + formatPathNumber(cornerY) : "",
          opening: "M " + formatPathNumber(rect.x) + " " + formatPathNumber(openingGuideY) + " H " + formatPathNumber(rect.x + rect.width),
          depth: "M " + formatPathNumber(depthGuideX) + " " + formatPathNumber(rect.y) + " V " + formatPathNumber(rect.y + rect.height)
        };

        if (item.guideX) item.guideX.setAttribute("d", paths.x);
        if (item.guideY) item.guideY.setAttribute("d", paths.y);
        if (item.guideOpening) item.guideOpening.setAttribute("d", paths.opening);
        if (item.guideDepth) item.guideDepth.setAttribute("d", paths.depth);
        Object.keys(item.measureHits).forEach(function (key) {
          if (item.measureHits[key]) {
            item.measureHits[key].setAttribute("d", paths[key]);
            item.measureHits[key].tabIndex = paths[key] ? 0 : -1;
          }
        });
        setSvgTextLabel(item.labelX, showX ? xText : "", xLabelX - 24, xLabelY, "middle");
        setSvgTextLabel(item.labelY, showY ? yText : "", yLabelX, yLabelY, "end");
        setSvgTextLabel(item.labelOpening, openingText, centerX, openingLabelY, "middle");
        setSvgTextLabel(item.labelDepth, depthText, centerX, depthLabelY, "middle");
        setCutoutMeasurementLabels(item, {
          x: { button: item.buttonX, visible: showX, text: xText, x: xLabelX, y: xLabelY },
          y: { button: item.buttonY, visible: showY, text: yText, x: yLabelX, y: yLabelY },
          opening: { button: item.buttonOpening, visible: true, text: openingText, x: centerX, y: openingLabelY },
          depth: { button: item.buttonDepth, visible: true, text: depthText, x: centerX, y: depthLabelY }
        });
      });
    }

    function syncPlanPreview() {
      if (!planPath || !planCanvas) {
        return;
      }

      var geometry = getPlanGeometry();
      var shape = buildBoardShape(geometry);
      var mode = getCornerMode();
      var selectedButtons = getSelectedCorners();
      var border = selectedValueBySummaryLabel("Bords");
      var thickness = selectedValueBySummaryLabel("Épaisseur") || selectedValueBySummaryLabel("Epaisseur");
      var validCutouts = getCutoutStates(geometry).filter(function (state) {
        return state.enabled && !getCutoutValidationMessage(state);
      });
      var invalidCutoutCount = getCutoutStates(geometry).filter(function (state) {
        return state.enabled && Boolean(getCutoutValidationMessage(state));
      }).length;

      syncPlanOrientationLabels(geometry);

      planPath.setAttribute("d", shape.path);
      planGrainPath.setAttribute("d", shape.path);
      planOutline.setAttribute("d", shape.path);

      if (planSpecialEdge) {
        planSpecialEdge.setAttribute("d", shape.specialPath);
        planSpecialEdge.toggleAttribute("hidden", !shape.specialPath);
      }

      var edgeMachining = getEdgeMachiningSelection();
      syncPlanEdgeHighlights(geometry, edgeMachining);

      cornerButtons.forEach(function (button) {
        var key = button.dataset.brutCorner;
        var controlOffset = 20;
        var x = key === "tl" || key === "bl" ? geometry.left - controlOffset : geometry.right + controlOffset;
        var y = key === "tl" || key === "tr" ? geometry.top - controlOffset : geometry.bottom + controlOffset;
        button.style.setProperty("--brut-plan-x", x / 760 * 100 + "%");
        button.style.setProperty("--brut-plan-y", y / 420 * 100 + "%");
      });

      if (planSize) {
        planSize.textContent = formatBoardSize(geometry.length, geometry.width, thickness);
      }

      if (planLength) {
        planLength.textContent = formatDimension(geometry.length) + " cm";
      }

      if (planWidth) {
        planWidth.textContent = formatDimension(geometry.width) + " cm";
      }

      if (planThickness) {
        planThickness.textContent = thickness || "Non renseignée";
      }

      if (planRadius) {
        planRadius.hidden = mode === "none" || !selectedButtons.length;
        planRadius.textContent = getCornerRadiusLabel(getCornerRadiusValue());
      }

      var normalizedBorder = normalizeValue(border);
      if (borderStatus) {
        if (normalizedBorder.indexOf("2 bords irreguliers") !== -1) {
          borderStatus.textContent = "Les faces avant et arrière sont irrégulières, toujours dans le sens du fil du bois.";
        } else if (normalizedBorder.indexOf("1 bord irregulier") !== -1) {
          borderStatus.textContent = "Le premier bord irrégulier est appliqué sur la face avant, en bas du plan.";
        } else {
          borderStatus.textContent = "Les faces avant et arrière restent droites.";
        }
      }

      var descriptions = [];
      if (selectedButtons.length) {
        descriptions.push(getCornerModeLabel(mode) + " : " + selectedButtons.map(function (button) { return button.dataset.cornerLabel; }).join(", "));
      }
      if (shape.bottomIrregular) {
        descriptions.push(shape.topIrregular ? "deux bords irréguliers" : "bord avant irrégulier");
      }
      if (validCutouts.length) {
        descriptions.push(validCutouts.length + " découpe" + (validCutouts.length > 1 ? "s" : ""));
      }
      if (invalidCutoutCount) {
        descriptions.push(invalidCutoutCount + " découpe" + (invalidCutoutCount > 1 ? "s" : "") + " à corriger");
      }
      if (selectedButtons.length && getCornerValidationMessage()) {
        descriptions.push("forme à corriger");
      }

      if (planCaption) {
        planCaption.textContent = descriptions.length ? descriptions.join(" · ") : "Cliquez sur un coin pour l’appliquer au plateau.";
        if (geometry.adjusted) {
          planCaption.textContent += " · Vue ajustée pour garder les commandes accessibles.";
        }
      }

      if (planDescription) {
        var accessibleDescriptions = descriptions.slice();
        if (edgeMachining && edgeMachining.legend) {
          accessibleDescriptions.push(edgeMachining.legend.replace(/\.$/, ""));
        }
        planDescription.textContent = accessibleDescriptions.length ? "Plateau configuré avec " + accessibleDescriptions.join(", ") + "." : "Plateau rectangulaire sans modification des coins.";
      }

      syncCutoutDrawing(geometry);
    }

    function syncDesignSettings() {
      var geometry = getPlanGeometry();
      syncCornerSettings();
      syncCutoutSettings(geometry);
      syncPlanPreview();
      syncPlanSignature();
      syncDimensionWarnings();
      syncProductAdvice();
    }

    function syncPlanSignature() {
      if (!planSignatureOutput) {
        return;
      }

      var edgeMachining = getEdgeMachiningSelection();
      var parts = [
        "L" + formatDimension(getNumberBySummaryLabel("Longueur")),
        "l" + formatDimension(getNumberBySummaryLabel("Largeur")),
        "ep" + (selectedValueBySummaryLabel("Épaisseur") || selectedValueBySummaryLabel("Epaisseur") || "-") ,
        "bords=" + (selectedValueBySummaryLabel("Bords") || "-"),
        "aretes=" + (selectedValueBySummaryLabel("Arêtes") || selectedValueBySummaryLabel("Aretes") || "-"),
        "usinage=" + (edgeMachining ? edgeMachining.detail : "-")
      ];

      if (cornerModeOutput && cornerModeOutput.value) parts.push("coins=" + cornerModeOutput.value + ":" + cornerOutput.value + ":" + cornerRadiusOutput.value);
      if (cutoutOutput && cutoutOutput.value) parts.push("decoupes=" + cutoutOutput.value);
      planSignatureOutput.value = parts.join(" | ");
    }

    function getPlanSnapshotSignature() {
      return planSignatureOutput && planSignatureOutput.value ? planSignatureOutput.value : "";
    }

    function createPlanSnapshotFile() {
      return new Promise(function (resolve) {
        if (!planSvg || typeof XMLSerializer === "undefined" || typeof File === "undefined") {
          resolve(null);
          return;
        }

        var clone = planSvg.cloneNode(true);
        clone.setAttribute("xmlns", "http://www.w3.org/2000/svg");
        clone.setAttribute("width", "760");
        clone.setAttribute("height", "420");
        var style = document.createElementNS("http://www.w3.org/2000/svg", "style");
        style.textContent = "text{font-family:Arial,sans-serif;fill:#2d2925;font-size:14px;font-weight:700}[data-brut-plan-outline]{stroke:#8f562c;stroke-width:4;fill:none}[data-brut-plan-special-edge]{stroke:#3f5948;stroke-width:4;fill:none}[data-brut-plan-edge-highlight]{stroke:#ff1f17;stroke-width:7;stroke-linecap:square;fill:none}[data-brut-plan-edge-legend] line{stroke:#ff1f17;stroke-width:6;stroke-linecap:square}[data-brut-plan-edge-legend] text{fill:#2d2925;font-size:13px;font-weight:700}[data-brut-cutout-outline]{fill:#fffdf9;stroke:#3f5948;stroke-width:3;stroke-dasharray:9 7}[data-cutout-index='2'][data-brut-cutout-outline]{stroke:#a87447;stroke-dasharray:4 5}[data-brut-cutout-guides] path{fill:none;stroke:#3f5948;stroke-width:2;stroke-dasharray:5 5}[data-brut-cutout-guides] text{fill:#2f4336;font-size:13px;font-weight:700}[hidden]{display:none}";
        clone.insertBefore(style, clone.firstChild);
        var background = document.createElementNS("http://www.w3.org/2000/svg", "rect");
        background.setAttribute("width", "760");
        background.setAttribute("height", "420");
        background.setAttribute("fill", "#fffdf9");
        clone.insertBefore(background, style.nextSibling);

        var source = new XMLSerializer().serializeToString(clone);
        var url = URL.createObjectURL(new Blob([source], { type: "image/svg+xml;charset=utf-8" }));
        var image = new Image();

        image.onload = function () {
          var canvas = document.createElement("canvas");
          canvas.width = 760;
          canvas.height = 420;
          var context = canvas.getContext("2d");
          context.drawImage(image, 0, 0, canvas.width, canvas.height);
          URL.revokeObjectURL(url);
          canvas.toBlob(function (blob) {
            resolve(blob ? new File([blob], "apercu-2d.png", { type: "image/png" }) : null);
          }, "image/png", 0.92);
        };
        image.onerror = function () {
          URL.revokeObjectURL(url);
          resolve(null);
        };
        image.src = url;
      });
    }

    async function getPlanSnapshotFile() {
      var signature = getPlanSnapshotSignature();

      if (planSnapshotCache.file && planSnapshotCache.signature === signature) {
        return planSnapshotCache.file;
      }

      var file = await createPlanSnapshotFile();
      planSnapshotCache = {
        signature: signature,
        file: file
      };
      return file;
    }

    function startLoadingMessage(kind) {
      var target = kind === "quote" && quoteLoadingMessage ? quoteLoadingMessage : loadingMessage;

      if (!target) {
        return function () {};
      }

      var messages = loadingMessages.slice();
      if (kind === "cart") {
        messages = [
          {
            after: 0,
            title: "Configuration validée",
            copy: "Création de votre produit sur mesure…"
          },
          {
            after: 5000,
            title: "Création du produit sur mesure…",
            copy: "Le prix et les options sont enregistrés de façon sécurisée."
          },
          {
            after: 12000,
            title: "Préparation de votre panier…",
            copy: "Shopify reçoit votre configuration personnalisée."
          },
          {
            after: 22000,
            title: "Cela prend un peu plus de temps que prévu…",
            copy: "L’ajout continue. Ne relancez pas la demande et ne fermez pas cette page."
          }
        ];
      }

      window.clearTimeout(loadingTimer);
      window.clearInterval(loadingInterval);
      loadingIndex = 0;
      target.hidden = true;
      target.classList.toggle("is-cart", kind === "cart");
      var stopped = false;
      var startedAt = Date.now();
      var submitLabel = submitButton ? submitButton.querySelector("span") : null;
      var originalSubmitLabel = submitLabel ? submitLabel.textContent : "";
      var rootWasInert = root.hasAttribute("inert");

      if (kind === "cart" && target === loadingMessage && document.body && target.parentNode !== document.body) {
        document.body.appendChild(target);
      }

      if (kind === "cart") {
        if (document.body) document.body.classList.add("brut-cart-pending");
        root.setAttribute("inert", "");
        if (submitButton) submitButton.setAttribute("aria-busy", "true");
        if (submitLabel) submitLabel.textContent = "Ajout en cours…";
        if (loadingMessageNote) loadingMessageNote.textContent = "Cette étape prend généralement 10 à 20 secondes. Ne fermez pas cette page.";
      }

      function renderMessage(message) {
        if (kind === "cart" && target === loadingMessage && loadingMessageTitle && loadingMessageCopy) {
          loadingMessageTitle.textContent = message.title;
          loadingMessageCopy.textContent = message.copy;
        } else {
          target.textContent = typeof message === "string" ? message : message.title + " " + message.copy;
        }
      }

      var showMessage = function () {
        renderMessage(messages[loadingIndex]);
        target.hidden = false;
        if (kind === "cart" && typeof target.focus === "function") target.focus({ preventScroll: true });
        if (kind === "cart" && messages.length > 1) {
          loadingInterval = window.setInterval(function () {
            var elapsed = Date.now() - startedAt;
            var nextIndex = loadingIndex;
            messages.forEach(function (message, index) {
              if (elapsed >= message.after) nextIndex = index;
            });
            if (nextIndex !== loadingIndex) {
              loadingIndex = nextIndex;
              renderMessage(messages[loadingIndex]);
            }
          }, 500);
        } else if (messages.length > 1) {
          loadingInterval = window.setInterval(function () {
            loadingIndex = (loadingIndex + 1) % messages.length;
            renderMessage(messages[loadingIndex]);
          }, 2800);
        }
      };

      if (kind === "cart") {
        showMessage();
      } else {
        loadingTimer = window.setTimeout(showMessage, 350);
      }

      return function () {
        if (stopped) return;
        stopped = true;
        window.clearTimeout(loadingTimer);
        window.clearInterval(loadingInterval);
        target.hidden = true;
        target.classList.remove("is-cart");
        if (document.body) document.body.classList.remove("brut-cart-pending");
        if (kind === "cart" && !rootWasInert) root.removeAttribute("inert");
        if (submitButton) submitButton.removeAttribute("aria-busy");
        if (submitLabel) submitLabel.textContent = originalSubmitLabel;
        if (kind === "cart" && submitButton && document.visibilityState !== "hidden") submitButton.focus({ preventScroll: true });
        if (target !== loadingMessage || !loadingMessageTitle || !loadingMessageCopy) {
          target.textContent = "";
        }
        if (target === loadingMessage && loadingMessageHome && loadingMessageHome.parent && target.parentNode !== loadingMessageHome.parent) {
          if (loadingMessageHome.nextSibling && loadingMessageHome.nextSibling.parentNode === loadingMessageHome.parent) {
            loadingMessageHome.parent.insertBefore(target, loadingMessageHome.nextSibling);
          } else {
            loadingMessageHome.parent.appendChild(target);
          }
        }
      };
    }

    function isValidPrivatePlanUrl(value) {
      try {
        var parsed = new URL(String(value || ""));
        return parsed.protocol === "https:" &&
          parsed.hostname === "cdn-assets.custompricecalculator.com" &&
          !parsed.username && !parsed.password && !parsed.port &&
          /^\/storefront\/uploads\/\d{4}\/\d{2}\/\d{2}\/[a-zA-Z0-9_-]+\.png$/.test(parsed.pathname) &&
          !parsed.search && !parsed.hash;
      } catch (error) {
        return false;
      }
    }

    function getPrivatePlanUrlInput(targetForm) {
      var input = targetForm.querySelector("[data-brut-private-plan-url]");
      if (!input) {
        input = document.createElement("input");
        input.type = "hidden";
        input.name = "properties[_brut_apercu_2d]";
        input.setAttribute("data-brut-private-plan-url", "true");
        targetForm.appendChild(input);
      }
      return input;
    }

    async function uploadPrivatePlanFile(file) {
      var calculator = document.querySelector("#calculator[data-calcid]");
      var calculatorId = calculator ? String(calculator.getAttribute("data-calcid") || "") : "";
      if (!/^[a-zA-Z0-9_-]{1,100}$/.test(calculatorId) || typeof AbortController === "undefined") {
        throw new Error("private_plan_calculator_unavailable");
      }
      // Same endpoint and payload as Apippa's storefront uploader.
      // Independent request: never replace the customer's Pièce jointe field.
      var controller = new AbortController();
      var timeout = window.setTimeout(function () { controller.abort(); }, 30000);
      try {
        var data = new FormData();
        data.append("file", file, "plan-configuration.png");
        data.append("calculatorId", calculatorId);
        var response = await fetch("https://api.custompricecalculator.com/api/v1/fileupload:storefront", {
          method: "POST",
          body: data,
          signal: controller.signal
        });
        if (!response.ok) throw new Error("private_plan_upload_failed");
        var result = await response.json();
        if (!isValidPrivatePlanUrl(result.fileUrl)) throw new Error("invalid_private_plan_url");
        return result.fileUrl;
      } finally {
        window.clearTimeout(timeout);
      }
    }

    function verifyPrivatePlanImage(url) {
      return new Promise(function (resolve, reject) {
        var preview = new Image();
        var timeout = window.setTimeout(function () {
          preview.onload = preview.onerror = null;
          reject(new Error("private_plan_image_timeout"));
        }, 10000);
        preview.onload = function () {
          window.clearTimeout(timeout);
          if (preview.naturalWidth > 0 && preview.naturalHeight > 0) resolve(url);
          else reject(new Error("private_plan_image_empty"));
        };
        preview.onerror = function () {
          window.clearTimeout(timeout);
          reject(new Error("private_plan_image_unavailable"));
        };
        preview.src = url;
      });
    }

    async function attachPrivatePlanLink(targetForm) {
      if (!targetForm) {
        throw new Error("private_plan_unavailable");
      }
      syncDesignSettings();
      var signature = getPlanSnapshotSignature();
      if (!signature) throw new Error("private_plan_missing_signature");
      var urlInput = getPrivatePlanUrlInput(targetForm);
      urlInput.value = "";
      var renderTimer;
      try {
        var url = privatePlanLinkCache.signature === signature && isValidPrivatePlanUrl(privatePlanLinkCache.url)
          ? privatePlanLinkCache.url : "";
        if (!url) {
          var file = await Promise.race([
            getPlanSnapshotFile(),
            new Promise(function (_, reject) {
              renderTimer = window.setTimeout(function () { reject(new Error("private_plan_render_timeout")); }, 8000);
            })
          ]);
          window.clearTimeout(renderTimer);
          if (!file || file.type !== "image/png" || !file.size) throw new Error("private_plan_render_failed");
          url = await uploadPrivatePlanFile(file);
        }
        await verifyPrivatePlanImage(url);
        if (getPlanSnapshotSignature() !== signature) throw new Error("private_plan_configuration_changed");
        privatePlanLinkCache = { signature: signature, url: url };
        urlInput.value = url;
        return url;
      } catch (error) {
        urlInput.value = "";
        privatePlanLinkCache = { signature: "", url: "" };
        throw error;
      } finally {
        window.clearTimeout(renderTimer);
      }
    }

    async function attachPlanSnapshot(targetForm) {
      if (targetForm === cpcForm && priceConfig.cpcAttachPlanFile !== true) {
        var existingPlanInput = targetForm ? targetForm.querySelector("[data-brut-plan-file]") : null;
        if (existingPlanInput) existingPlanInput.remove();
        return false;
      }

      var file = await getPlanSnapshotFile();
      if (!file || !targetForm || typeof DataTransfer === "undefined") {
        return false;
      }

      var input = targetForm.querySelector("[data-brut-plan-file]");
      if (!input) {
        input = document.createElement("input");
        input.type = "file";
        input.name = "properties[_brut_apercu_2d]";
        input.accept = "image/png";
        input.hidden = true;
        input.dataset.brutPlanFile = "true";
        targetForm.appendChild(input);
      }

      var transfer = new DataTransfer();
      transfer.items.add(file);
      input.files = transfer.files;
      targetForm.enctype = "multipart/form-data";
      return input.files.length === 1;
    }

    function normalizeCartLabel(label) {
      return normalizeValue(label).replace(/^prix /, "").replace(/\s+/g, " ");
    }

    function getCustomerCartRows() {
      var order = [
        "choix du bois",
        "usage planche/panneau",
        "epaisseur planche/panneau",
        "longueur",
        "largeur",
        "bords",
        "types d aretes",
        "choix des aretes cassees",
        "choix des aretes arrondies",
        "coins arrondis",
        "rayon coins",
        "forme des coins",
        "forfait coins arrondis",
        "vernis",
        "decoupe sur mesure",
        "forfait decoupe",
        "raidisseurs",
        "delais estimes de retrait/expedition",
        "poids theorique",
        "poids estime",
        "point de vigilance"
      ];
      var aliases = {
        "bois": "choix du bois",
        "usage": "usage planche/panneau",
        "epaisseur": "epaisseur planche/panneau",
        "aretes": "types d aretes",
        "details aretes cassees": "choix des aretes cassees",
        "details aretes arrondies": "choix des aretes arrondies",
        "rayon coins": "rayon coins arrondis",
        "prix coins": "forfait coins arrondis",
        "delai": "delais estimes de retrait/expedition"
      };
      var rowsByKey = {};
      var rowKeys = [];

      getQuoteRows().forEach(function (row) {
        var key = normalizeCartLabel(row.label);
        key = aliases[key] || key;

        if (key === "quantite" || !row.value || normalizeValue(row.value) === "aucune" || normalizeValue(row.value) === "aucun coin selectionne") {
          return;
        }

        if (!rowsByKey[key]) {
          rowKeys.push(key);
        }
        rowsByKey[key] = {
          label: row.label,
          value: row.value
        };
      });

      if (rowsByKey["choix du bois"]) rowsByKey["choix du bois"].label = "Choix du bois";
      if (rowsByKey["usage planche/panneau"]) rowsByKey["usage planche/panneau"].label = "Usage planche/panneau";
      if (rowsByKey["epaisseur planche/panneau"]) rowsByKey["epaisseur planche/panneau"].label = "Épaisseur planche/panneau";
      if (rowsByKey["longueur"]) {
        rowsByKey["longueur"].label = "Longueur (cm)";
        rowsByKey["longueur"].value = formatDimension(getNumberBySummaryLabel("Longueur"));
      }
      if (rowsByKey["largeur"]) {
        rowsByKey["largeur"].label = "Largeur (cm)";
        rowsByKey["largeur"].value = formatDimension(getNumberBySummaryLabel("Largeur"));
      }
      if (rowsByKey["types d aretes"]) rowsByKey["types d aretes"].label = "Types d’arêtes";
      if (rowsByKey["choix des aretes cassees"]) rowsByKey["choix des aretes cassees"].label = "Choix des arêtes cassées";
      if (rowsByKey["choix des aretes arrondies"]) rowsByKey["choix des aretes arrondies"].label = "Choix des arêtes arrondies";
      if (rowsByKey["raidisseurs"]) rowsByKey["raidisseurs"].label = "Raidisseurs métalliques";
      if (rowsByKey["delais estimes de retrait/expedition"]) rowsByKey["delais estimes de retrait/expedition"].label = "Délais estimés de retrait/expédition";

      if (form.querySelector('[data-brut-price-property="weight"]') && form.querySelector('[data-brut-price-property="weight"]').value) {
        rowsByKey["poids theorique"] = {
          label: "Poids théorique",
          value: form.querySelector('[data-brut-price-property="weight"]').value
        };
      }

      var orderedKeys = [];
      var items = order.reduce(function (result, key) {
        var normalizedKey = aliases[key] || key;
        if (rowsByKey[normalizedKey]) {
          result.push(rowsByKey[normalizedKey]);
          orderedKeys.push(normalizedKey);
        }
        return result;
      }, []);

      rowKeys.forEach(function (key) {
        if (orderedKeys.indexOf(key) === -1 && rowsByKey[key]) {
          items.push(rowsByKey[key]);
        }
      });

      return items;
    }

    function cleanCpcFormDataForSubmission(formData) {
      if (!formData || typeof formData.forEach !== "function" || typeof formData.delete !== "function") {
        return;
      }

      var propertyKeys = [];
      formData.forEach(function (value, key) {
        var isPublicCartProperty = key.indexOf("properties[") === 0 && key.indexOf("properties[_") !== 0 && !isAttachmentPropertyName(key);
        if ((isPublicCartProperty || isConfidentialCartPropertyName(key)) && propertyKeys.indexOf(key) === -1) {
          propertyKeys.push(key);
        }
      });

      propertyKeys.forEach(function (key) {
        formData.delete(key);
      });

      getCustomerCartRows().forEach(function (row) {
        if (!row.label || !row.value) {
          return;
        }

        formData.append("properties[" + row.label + "]", row.value);
      });

      if (lastPriceEstimate && typeof lastPriceEstimate.marginHt === "number") {
        [
          ["properties[_brut_margin_estimate_eur]", "marginHt"],
          ["properties[_brut_margin_plateau_eur]", "marginPlateauHt"],
          ["properties[_brut_margin_vernis_eur]", "marginVarnishHt"],
          ["properties[_brut_margin_raidisseurs_eur]", "marginReinforcementHt"],
          ["properties[_brut_margin_supp_eur]", "marginSupplementHt"]
        ].forEach(function (entry) {
          var value = lastPriceEstimate[entry[1]];
          if (typeof value !== "number" || !Number.isFinite(value)) {
            return;
          }

          formData.delete(entry[0]);
          formData.append(entry[0], value.toFixed(2));
        });
      }
    }

    function getQuoteRows() {
      return Array.prototype.slice.call(summaryList.querySelectorAll(".brut-configurator__summary-row")).map(function (row) {
        var label = row.querySelector("dt");
        var value = row.querySelector("dd");
        return {
          label: label ? label.textContent.trim() : "",
          value: value ? value.textContent.trim() : ""
        };
      }).filter(function (row) {
        return row.label && row.value;
      });
    }

    function syncQuoteMessage() {
      if (!quoteBodyInput) {
        return;
      }

      var file = quoteFileInput && quoteFileInput.files && quoteFileInput.files.length
        ? quoteFileInput.files[0]
        : null;
      var attachmentName = file ? file.name : "Non";
      var attachmentUrl = file ? quoteAttachmentUrl : "";
      var lines = [
        activeQuoteMode === "sample"
          ? "Demande d’échantillon envoyée depuis le configurateur."
          : "Demande atelier envoyée depuis le configurateur."
      ];

      // Le mail Shopify affiche déjà les champs contact dédiés.
      // Garder un seul nom et un seul lien, sans les répéter dans le corps.
      if (quoteAttachmentInput) {
        quoteAttachmentInput.value = attachmentName;
      }
      if (!quoteAttachmentInput || quoteAttachmentInput.disabled) {
        lines.push("Pièce jointe : " + attachmentName);
      }
      if (quoteAttachmentUrlInput) {
        quoteAttachmentUrlInput.value = attachmentUrl;
        quoteAttachmentUrlInput.disabled = !attachmentUrl;
      } else if (attachmentUrl) {
        lines.push("Lien de téléchargement : " + attachmentUrl);
      }
      quoteBodyInput.value = lines.join("\n");
    }

    function populateQuoteModal(mode) {
      var sampleMode = mode === "sample";
      var quoteOnly = mode === "custom" || isQuoteOnlyMode();

      if (!sampleMode && isCustomWoodMode() && customMaterialInput && !customMaterialInput.value.trim()) {
        setFieldState(customMaterialInput, "Précisez l’essence ou le matériau recherché.");
        customMaterialInput.focus({ preventScroll: true });
        customMaterialInput.scrollIntoView({ behavior: getScrollBehavior(), block: "center" });
        return false;
      }

      if (!sampleMode && isCustomFinishMode() && customFinishInput && !customFinishInput.value.trim()) {
        setFieldState(customFinishInput, "Précisez la teinte ou la finition souhaitée.");
        customFinishInput.focus({ preventScroll: true });
        customFinishInput.scrollIntoView({ behavior: getScrollBehavior(), block: "center" });
        return false;
      }

      activeQuoteMode = mode;
      if (mode === "validation") saveConfigurationDraft();

      updateSummary();
      var rows = getQuoteRows();
      var pricingFallbackMessage = getCpcPaidOptionPricingMessage(lastCpcSyncState);
      var price = pricingFallbackMessage && lastPriceEstimate
        ? lastPriceEstimate.formatted
        : lastCpcPrice && lastCpcPrice.formatted
        ? lastCpcPrice.formatted
        : (lastPriceEstimate && lastPriceEstimate.formatted ? lastPriceEstimate.formatted : (selectedPrice ? selectedPrice.textContent.trim() : ""));

      if (quoteTitle) {
        quoteTitle.textContent = sampleMode
          ? "Demande d’échantillon gratuit"
          : (quoteOnly ? "Demande de devis sur mesure" : "Validation de votre projet par l’atelier");
      }

      if (quoteSummary) {
        quoteSummary.replaceChildren();
        rows.forEach(function (row) {
          var wrapper = document.createElement("div");
          var term = document.createElement("dt");
          var description = document.createElement("dd");
          term.textContent = row.label;
          description.textContent = row.value;
          wrapper.appendChild(term);
          wrapper.appendChild(description);
          quoteSummary.appendChild(wrapper);
        });
      }

      if (quoteSummaryDetails) {
        quoteSummaryDetails.open = window.innerWidth >= 750;
      }

      if (quotePrice) {
        quotePrice.hidden = sampleMode || quoteOnly || !price;
        quotePrice.textContent = sampleMode || quoteOnly || !price ? "" : "Prix estimé : " + price + " TTC";
      }

      sampleFields.forEach(function (field) {
        field.hidden = !sampleMode;
        Array.prototype.slice.call(field.querySelectorAll("input, textarea, select")).forEach(function (input) {
          input.disabled = !sampleMode;
        });
      });
      nonSampleFields.forEach(function (field) {
        field.hidden = sampleMode;
        Array.prototype.slice.call(field.querySelectorAll("input, textarea, select")).forEach(function (input) {
          input.disabled = sampleMode;
        });
      });

      if (sampleAddressInput) sampleAddressInput.required = sampleMode;
      if (sampleProjectInput) sampleProjectInput.required = sampleMode;
      if (quoteNameInput) quoteNameInput.required = sampleMode;
      if (quoteNameRequirement) quoteNameRequirement.textContent = sampleMode ? "obligatoire" : "facultatif";
      if (quoteDraftNote) quoteDraftNote.hidden = mode !== "validation";
      if (quoteSendButton) quoteSendButton.textContent = sampleMode ? "Demander mon échantillon gratuit" : "Envoyer ma demande à l’atelier";

      if (quoteModeInput) {
        quoteModeInput.value = sampleMode
          ? "Demande d’échantillon gratuit"
          : (quoteOnly ? "Demande de devis sur mesure" : "Validation atelier avant commande");
      }
      if (quoteConfigurationInput) quoteConfigurationInput.value = rows.map(function (row) { return row.label + " : " + row.value; }).join("\n");
      if (quotePriceInput) quotePriceInput.value = sampleMode ? "Non applicable" : (quoteOnly ? "Prix sur devis" : price);
      if (quotePlanInput) quotePlanInput.value = planSignatureOutput ? planSignatureOutput.value : "";
      if (quoteError) quoteError.textContent = "";
      if (quoteFormFields) quoteFormFields.hidden = false;
      if (quoteConfirmation) quoteConfirmation.hidden = true;
      if (quoteConfirmationTitle) quoteConfirmationTitle.textContent = "Votre demande a bien été transmise à l’atelier.";
      if (quoteConfirmationText) quoteConfirmationText.textContent = "Nous vous répondrons par email dès que possible.";
      syncQuoteMessage();
      return true;
    }

    function openQuoteModal(mode, trigger) {
      if (!quoteModal || !populateQuoteModal(mode)) {
        return;
      }

      quoteOpenTrigger = trigger || null;
      if (typeof quoteModal.showModal === "function") {
        quoteModal.showModal();
      } else {
        quoteModal.setAttribute("open", "");
      }
      var dialogScroller = quoteModal.querySelector(".brut-configurator__quote-dialog");
      if (dialogScroller) dialogScroller.scrollTop = 0;
      document.documentElement.classList.add("brut-quote-modal-open");
      var firstField = quoteForm ? quoteForm.querySelector('input[type="email"]') : null;
      if (firstField && window.innerWidth >= 750) window.setTimeout(function () { firstField.focus(); }, 40);
    }

    function closeQuoteModal() {
      if (!quoteModal) {
        return;
      }

      if (typeof quoteModal.close === "function" && quoteModal.open) {
        quoteModal.close();
      } else {
        quoteModal.removeAttribute("open");
      }
      document.documentElement.classList.remove("brut-quote-modal-open");
      if (quoteOpenTrigger) quoteOpenTrigger.focus({ preventScroll: true });
    }

    function validateQuoteFile() {
      if (!quoteFileInput || !quoteFileInput.files || !quoteFileInput.files.length) {
        quoteAttachmentUrl = "";
        if (quoteAttachmentUrlInput) quoteAttachmentUrlInput.value = "";
        if (quoteFileSelected) quoteFileSelected.hidden = true;
        if (quoteFileName) quoteFileName.textContent = "";
        syncQuoteMessage();
        return true;
      }

      var file = quoteFileInput.files[0];
      var extension = file.name.indexOf(".") === -1 ? "" : file.name.split(".").pop().toLowerCase();
      var allowedExtensions = ["jpg", "jpeg", "png", "pdf", "heic"];
      var maximum = toNumber(quoteModal ? quoteModal.dataset.brutQuoteMaxBytes : 0) || 10485760;
      var message = "";

      if (allowedExtensions.indexOf(extension) === -1) {
        message = "Format non accepté. Utilisez un fichier JPG, JPEG, PNG, PDF ou HEIC.";
      } else if (file.size > maximum) {
        message = "Ce fichier est trop volumineux. La taille maximale est de " + formatDimension(maximum / 1048576) + " Mo.";
      }

      if (message) {
        quoteAttachmentUrl = "";
        if (quoteAttachmentUrlInput) quoteAttachmentUrlInput.value = "";
        quoteFileInput.value = "";
        if (quoteFileSelected) quoteFileSelected.hidden = true;
        if (quoteFileName) quoteFileName.textContent = "";
        if (quoteError) quoteError.textContent = message;
        syncQuoteMessage();
        return false;
      }

      quoteAttachmentUrl = "";
      if (quoteAttachmentUrlInput) quoteAttachmentUrlInput.value = "";
      if (quoteError) quoteError.textContent = "";
      if (quoteFileSelected) quoteFileSelected.hidden = false;
      if (quoteFileName) quoteFileName.textContent = file.name;
      syncQuoteMessage();
      return true;
    }

    function getApippaQuoteUploadFields() {
      var activeCpcForm = cpcForm || document.querySelector(priceConfig.cpcFormSelector || "form.cpc-calculator-form");
      if (!activeCpcForm) {
        return null;
      }

      var uploadInput = Array.prototype.slice.call(activeCpcForm.querySelectorAll('input[type="file"].cpc-file-upload, input[type="file"][name^="cpc_upload_fileupload_"]')).find(function (input) {
        return normalizePropertyName(input.dataset.propertyName || input.dataset.identifier || "") === "piece jointe";
      });
      var urlInput = Array.prototype.slice.call(activeCpcForm.querySelectorAll("input.cpc-file-url-input")).find(function (input) {
        return normalizePropertyName(input.dataset.propertyName || input.name || "") === "piece jointe";
      });

      return uploadInput && urlInput ? { uploadInput: uploadInput, urlInput: urlInput } : null;
    }

    async function uploadQuoteFileThroughApippa(file) {
      var fields = getApippaQuoteUploadFields();
      if (!fields || !file || typeof DataTransfer === "undefined") {
        throw new Error("apippa_upload_unavailable");
      }

      var transfer = new DataTransfer();
      transfer.items.add(file);
      fields.urlInput.value = "";
      fields.uploadInput.value = "";
      fields.uploadInput.files = transfer.files;
      fields.uploadInput.dispatchEvent(new Event("change", { bubbles: true }));

      return new Promise(function (resolve, reject) {
        var startedAt = Date.now();
        var uploadObserved = false;

        function inspectUpload() {
          var uploadedUrl = String(fields.urlInput.value || "").trim();
          var uploading = fields.uploadInput.getAttribute("data-cpc-uploading") === "true";
          var elapsed = Date.now() - startedAt;

          if (uploadedUrl) {
            if (!/^(https?:)?\/\//i.test(uploadedUrl)) {
              reject(new Error("apippa_upload_invalid_url"));
              return;
            }
            resolve(uploadedUrl);
            return;
          }

          if (uploading) uploadObserved = true;
          if ((uploadObserved && !uploading) || (!uploadObserved && elapsed > 2500)) {
            reject(new Error("apippa_upload_failed"));
            return;
          }
          if (elapsed > 60000) {
            reject(new Error("apippa_upload_timeout"));
            return;
          }

          window.setTimeout(inspectUpload, 150);
        }

        inspectUpload();
      });
    }

    function resumeQuoteSubmissionThroughShopify() {
      if (!quoteForm || typeof quoteForm.requestSubmit !== "function") {
        throw new Error("shopify_request_submit_unavailable");
      }

      quoteShopifySubmissionReady = true;
      if (quoteFileInput) quoteFileInput.disabled = true;

      try {
        // requestSubmit() déclenche un vrai événement submit : Shopify peut
        // obtenir et vérifier son jeton hCaptcha avant l'envoi du formulaire.
        quoteForm.requestSubmit();
      } catch (error) {
        quoteShopifySubmissionReady = false;
        if (quoteFileInput) quoteFileInput.disabled = false;
        throw error;
      }
    }

    function showQuoteConfirmation() {
      if (quoteFormFields) quoteFormFields.hidden = true;
      if (quoteConfirmation) quoteConfirmation.hidden = false;
      if (quoteForm) quoteForm.scrollTop = 0;
      if (quoteConfirmation) quoteConfirmation.scrollIntoView({ block: "start" });
      if (quoteTitle) quoteTitle.textContent = activeQuoteMode === "sample" ? "Échantillon demandé" : "Demande transmise";
      if (activeQuoteMode === "sample") {
        if (quoteConfirmationTitle) quoteConfirmationTitle.textContent = "Votre demande d’échantillon a bien été transmise.";
        if (quoteConfirmationText) quoteConfirmationText.textContent = "Nous préparons votre envoi et vous recontactons si une précision est nécessaire.";
      }
    }

    async function submitQuoteToEndpoint(endpoint) {
      var data = new FormData(quoteForm);
      var attachmentFile = quoteFileInput && quoteFileInput.files && quoteFileInput.files.length
        ? quoteFileInput.files[0]
        : null;
      if (attachmentFile) data.set("attachment", attachmentFile, attachmentFile.name);
      if (quoteAttachmentUrl) data.set("attachment_url", quoteAttachmentUrl);
      var previewFile = await getPlanSnapshotFile();
      if (previewFile) data.append("preview_2d", previewFile, previewFile.name);

      if (quoteModal && quoteModal.dataset.brutQuotePreview === "true") {
        await new Promise(function (resolve) { window.setTimeout(resolve, 180); });
        return { ok: true };
      }

      var controller = typeof AbortController !== "undefined" ? new AbortController() : null;
      var timeout = window.setTimeout(function () {
        if (controller) controller.abort();
      }, 20000);

      try {
        return await fetch(endpoint, {
          method: "POST",
          body: data,
          credentials: "same-origin",
          headers: { Accept: "application/json" },
          signal: controller ? controller.signal : undefined
        });
      } finally {
        window.clearTimeout(timeout);
      }
    }

    function setAdvice(element, message, tone) {
      if (!element) {
        return;
      }

      element.hidden = !message;
      var textTarget = element.querySelector("[data-brut-advice-text]") || element;
      textTarget.textContent = message || "";
      element.classList.toggle("is-important", tone === "important");
      element.classList.toggle("is-warning", tone === "warning");

      if (element === reinforcementAdvice && reinforcementAdviceAction) {
        reinforcementAdviceAction.hidden = tone !== "important";
      }

      if (element === edgeVarnishAdvice && edgeVarnishAdviceAction) {
        edgeVarnishAdviceAction.hidden = !message;
      }
    }

    function syncProductAdvice() {
      var edge = normalizeValue(selectedValueBySummaryLabel("Arêtes") || selectedValueBySummaryLabel("Aretes"));
      var varnish = normalizeValue(selectedValueBySummaryLabel("Vernis"));
      var width = getNumberBySummaryLabel("Largeur");
      var reinforcement = normalizeValue(selectedValueBySummaryLabel("Raidisseurs"));
      var hasVarnish = Boolean(varnish) && varnish !== "non" && varnish.indexOf("sans vernis") === -1;
      var hasEdgeMachining = edge.indexOf("cassee") !== -1 || edge.indexOf("arrondie") !== -1;
      var hasReinforcement = Boolean(reinforcement) && reinforcement.indexOf("aucun") === -1 && reinforcement.indexOf("sans raidisseur") === -1;
      var reinforcementOptionCount = Object.keys(priceConfig.reinforcementCountMap).reduce(function (maximum, key) {
        return Math.max(maximum, priceConfig.reinforcementCountMap[key]);
      }, 0);

      if (reinforcementPriceDisplay) {
        var reinforcementOptionPrice = reinforcementOptionCount * width * priceConfig.reinforcementPricePerCm;
        reinforcementPriceDisplay.textContent = width > 0 && reinforcementOptionCount > 0
          ? "Prix pour cette largeur : " + formatMoney(reinforcementOptionPrice) + " TTC."
          : "Le prix dépend de la largeur du plateau.";
      }

      setAdvice(
        edgeVarnishAdvice,
        hasVarnish && !hasEdgeMachining
          ? "Conseil finition : aucun usinage d’arêtes n’est sélectionné. Avec un vernis, prévoyez au minimum des arêtes cassées sur les arêtes visibles. Les arêtes des parties non visibles peuvent rester saillantes."
          : "",
        "warning"
      );

      if (hasReinforcement && width < 70) {
        setAdvice(
          reinforcementAdvice,
          "Conseil raidisseurs : sous 70 cm de large, ils ne sont normalement pas nécessaires. Ils seront posés sur le dessous du plateau. En cas de doute, demandez-nous confirmation avant de valider.",
          "warning"
        );
      } else if (!hasReinforcement && width > 80) {
        setAdvice(
          reinforcementAdvice,
          "Attention : au-delà de 80 cm de large, des raidisseurs sous le plateau sont normalement nécessaires, sauf si le support maintient correctement le bois sur toute sa largeur.",
          "important"
        );
      } else {
        setAdvice(reinforcementAdvice, "", "");
      }
    }

    function syncLivePreview() {
      if (!liveBoard) {
        return;
      }

      var length = getNumberBySummaryLabel("Longueur") || 120;
      var width = getNumberBySummaryLabel("Largeur") || 60;
      var thickness = selectedValueBySummaryLabel("Épaisseur") || selectedValueBySummaryLabel("Epaisseur");
      var thicknessCm = toNumber(thickness) || 1;
      var border = selectedValueBySummaryLabel("Bords");
      var edge = selectedValueBySummaryLabel("Arêtes") || selectedValueBySummaryLabel("Aretes");
      var reinforcements = selectedValueBySummaryLabel("Raidisseurs");
      var ratio = Math.max(0.25, Math.min(5, length / Math.max(width, 1)));
      var maxWidth = 268;
      var maxHeight = 152;
      var boardWidth = ratio >= maxWidth / maxHeight ? maxWidth : maxHeight * ratio;
      var boardHeight = ratio >= maxWidth / maxHeight ? maxWidth / ratio : maxHeight;

      boardWidth = Math.max(112, boardWidth);
      boardHeight = Math.max(74, boardHeight);

      liveBoard.style.setProperty("--brut-live-width", boardWidth + "px");
      liveBoard.style.setProperty("--brut-live-height", boardHeight + "px");
      liveBoard.style.setProperty("--brut-live-thickness", Math.max(8, Math.min(26, thicknessCm * 4.2)) + "px");

      var normalizedBorder = normalizeValue(border);
      var normalizedEdge = normalizeValue(edge);
      var normalizedReinforcements = normalizeValue(reinforcements);

      liveBoard.classList.toggle("is-border-one", normalizedBorder.indexOf("1 bord irregulier") !== -1);
      liveBoard.classList.toggle("is-border-two", normalizedBorder.indexOf("2 bords irreguliers") !== -1);
      liveBoard.classList.toggle("is-edge-broken", normalizedEdge.indexOf("cassee") !== -1);
      liveBoard.classList.toggle("is-edge-rounded", normalizedEdge.indexOf("arrondie") !== -1);
      liveBoard.classList.toggle("has-reinforcements", normalizedReinforcements.indexOf("2 raidisseurs") !== -1);

      if (liveSize) {
        liveSize.textContent = formatBoardSize(length, width, thickness);
      }

      if (liveLengthLabel) {
        liveLengthLabel.textContent = "L " + formatDimension(length) + " cm";
      }

      if (liveWidthLabel) {
        liveWidthLabel.textContent = "l " + formatDimension(width) + " cm";
      }

      if (liveThicknessLabel) {
        liveThicknessLabel.textContent = "ép. " + (thickness || formatDimension(thicknessCm) + " cm");
      }

      if (liveDetails) {
        var details = [];

        if (thickness) {
          details.push("ép. " + thickness);
        }

        if (border) {
          details.push(border);
        }

        if (edge) {
          details.push(edge);
        }

        liveDetails.textContent = details.join(" · ");
      }

    }

    function syncPriceEstimate() {
      if (!priceConfig.enabled) {
        lastPriceEstimate = null;
        syncDisplayedTotal(toNumber(selectedPrice ? selectedPrice.textContent : 0));
        return null;
      }

      var length = getNumberBySummaryLabel("Longueur");
      var width = getNumberBySummaryLabel("Largeur");
      var surface = length > 0 && width > 0 ? (length * width) / 10000 : 0;
      var thickness = selectedValueBySummaryLabel("Épaisseur") || selectedValueBySummaryLabel("Epaisseur");
      var thicknessCm = toNumber(thickness);

      if (!(length > 0 && width > 0 && thicknessCm > 0)) {
        lastPriceEstimate = null;
        if (selectedPrice) selectedPrice.textContent = "À calculer";
        syncDisplayedTotal(0);
        if (priceBreakdown) priceBreakdown.textContent = "Renseignez des dimensions valides pour calculer le prix.";
        if (usesCpcEngine()) cpcPricePending = true;
        updateCpcSubmitState();
        return null;
      }

      var wood = selectedValueBySummaryLabel("Bois");
      var finish = selectedValueBySummaryLabel("Vernis") || "Non";
      var border = selectedValueBySummaryLabel("Bords");
      var delay = selectedValueBySummaryLabel("Délai") || selectedValueBySummaryLabel("Delai");
      var reinforcements = selectedValueBySummaryLabel("Raidisseurs");
      var materialPrice = lookupRate(priceConfig.materialPriceMap, wood, priceConfig.fallbackMaterialPrice);
      var thicknessCoefficient = lookupRate(priceConfig.thicknessCoefficientMap, thickness, thicknessCm);
      var marginPercent = lookupPairRate(priceConfig.finishMarginMap, finish, thickness, priceConfig.defaultMargin);
      var borderMultiplier = lookupRate(priceConfig.borderMultiplierMap, border, 1);
      var delayAdjustment = lookupRate(priceConfig.delayAdjustmentMap, delay, 0);
      var normalizedDelay = normalizeValue(delay);

      if (normalizedDelay.indexOf("delais habituels") !== -1) {
        delayAdjustment = priceConfig.normalDelayAdjustmentPercent / 100;
      }

      var delayMultiplier = 1 + delayAdjustment;
      var reinforcementCount = lookupRate(priceConfig.reinforcementCountMap, reinforcements, 0);
      var lengthOversizePercent = 0;
      var widthOversizePercent = 0;
      var oversizePercent = 0;
      var extraFixed = 0;
      var extraPercent = 0;
      var cutoutStates = getCutoutStates(getPlanGeometry());
      var cutoutFeeHt = cutoutStates.reduce(function (total, state) {
        return total + getCutoutFeeHt(state);
      }, 0);
      var cornerFeeHt = getCornerFeeHt();
      var selectedGroups = {
        "bords": selectedValueBySummaryLabel("Bords"),
        "aretes": selectedValueBySummaryLabel("Arêtes") || selectedValueBySummaryLabel("Aretes"),
        "vernis": selectedValueBySummaryLabel("Vernis"),
        "raidisseurs": reinforcements,
        "delai": delay,
        "coins arrondis": cornerOutput ? cornerOutput.value : "",
        "rayon coins": cornerRadiusOutput ? cornerRadiusOutput.value : "",
        "forme des coins": cornerModeOutput ? cornerModeOutput.value : "",
        "decoupe": cutoutOutput ? cutoutOutput.value : ""
      };

      priceConfig.extraRuleList.forEach(function (rule) {
        var selected = selectedGroups[rule.group];

        if (!selected || normalizeValue(selected) !== rule.value) {
          return;
        }

        if (rule.percent) {
          extraPercent += rule.amount;
        } else {
          extraFixed += rule.amount;
        }
      });

      if (priceConfig.lengthSurchargeThreshold && length > priceConfig.lengthSurchargeThreshold) {
        lengthOversizePercent += priceConfig.oversizeSurchargePercent;
      }

      if (priceConfig.lengthSurchargeExtraThreshold && length > priceConfig.lengthSurchargeExtraThreshold) {
        lengthOversizePercent += priceConfig.lengthSurchargeExtraPercent || priceConfig.oversizeSurchargePercent;
      }

      if (priceConfig.widthSurchargeThreshold && width > priceConfig.widthSurchargeThreshold) {
        widthOversizePercent += priceConfig.oversizeSurchargePercent;
      }

      oversizePercent = lengthOversizePercent + widthOversizePercent;
      if (oversizePercentOutput) {
        oversizePercentOutput.value = oversizePercent.toFixed(2);
      }

      var materialCost = 0;

      if (length > 0 && width > 0 && thicknessCoefficient > 0 && materialPrice > 0) {
        materialCost = (((length + priceConfig.lengthAllowance) * width * priceConfig.widthMultiplier * thicknessCoefficient) / 1000000) * materialPrice;
        materialCost *= 1 + priceConfig.wasteRate;
      }

      var marginDivider = Math.max(0.01, 1 - marginPercent / 100);
      var nonVarnishMarginPercent = lookupPairRate(priceConfig.finishMarginMap, "Non", thickness, priceConfig.defaultMargin);
      var nonVarnishMarginDivider = Math.max(0.01, 1 - nonVarnishMarginPercent / 100);
      var productBaseHt = (materialCost / marginDivider) * borderMultiplier * delayMultiplier;
      var nonVarnishBaseHt = (materialCost / nonVarnishMarginDivider) * borderMultiplier * delayMultiplier;
      var lengthOversizeFeeHt = productBaseHt * lengthOversizePercent / 100;
      var widthOversizeFeeHt = productBaseHt * widthOversizePercent / 100;
      var productHtRaw = productBaseHt + lengthOversizeFeeHt + widthOversizeFeeHt;
      var extraPercentFeeHt = productHtRaw * extraPercent / 100;
      var extraFixedHt = extraFixed / priceConfig.taxMultiplier;
      productHtRaw += extraPercentFeeHt;
      productHtRaw += extraFixedHt;
      productHtRaw += cornerFeeHt;
      productHtRaw += cutoutFeeHt;

      var productHt = priceConfig.roundProduct ? roundUp(productHtRaw, 1) : productHtRaw;
      productHt = Math.max(productHt, priceConfig.minimum || 0);

      var reinforcementTtc = reinforcementCount * width * priceConfig.reinforcementPricePerCm;
      var reinforcementHt = reinforcementTtc / priceConfig.taxMultiplier;
      var totalHt = productHt + reinforcementHt;
      var totalTtc = (productHt * priceConfig.taxMultiplier) + reinforcementTtc;
      var validMarginInputs = length > 0 && width > 0 && materialCost > 0;
      var normalizedFinish = normalizeValue(finish);
      var hasVarnish = Boolean(normalizedFinish) && normalizedFinish !== "non" && normalizedFinish.indexOf("sans vernis") === -1;
      var varnishMaterialCostHt = hasVarnish ? surface * priceConfig.varnishMaterialCostPerM2Ht : 0;
      var roundingOrMinimumMarginHt = Math.max(0, productHt - productHtRaw);
      var plateauMarginUnitHt = validMarginInputs ? Math.max(0, nonVarnishBaseHt - materialCost) : 0;
      var varnishMarginUnitHt = validMarginInputs && hasVarnish ? (productBaseHt - nonVarnishBaseHt - varnishMaterialCostHt) : 0;
      var reinforcementMarginUnitHt = reinforcementHt * priceConfig.reinforcementMarginPercent / 100;
      var supplementMarginUnitHt = validMarginInputs ? Math.max(0, widthOversizeFeeHt + extraPercentFeeHt + extraFixedHt + cornerFeeHt + cutoutFeeHt + roundingOrMinimumMarginHt) : 0;
      var marginUnitHt = plateauMarginUnitHt + varnishMarginUnitHt + reinforcementMarginUnitHt + supplementMarginUnitHt;
      var marginTotalHt = marginUnitHt * getQuantity();
      var marginPlateauTotalHt = plateauMarginUnitHt * getQuantity();
      var marginVarnishTotalHt = varnishMarginUnitHt * getQuantity();
      var marginReinforcementTotalHt = reinforcementMarginUnitHt * getQuantity();
      var marginSupplementTotalHt = supplementMarginUnitHt * getQuantity();
      var netBoardAreaCm2 = getNetBoardAreaCm2(length, width, cutoutStates);
      var weight = netBoardAreaCm2 > 0 && thicknessCm > 0
        ? roundUp((netBoardAreaCm2 * thicknessCm / 1000000) * 800, 0.1)
        : 0;
      var cents = Math.round(totalTtc * 100);
      var formatted = formatMoney(cents / 100);
      lastPriceEstimate = {
        amount: cents / 100,
        cents: cents,
        formatted: formatted,
        marginHt: marginTotalHt,
        marginPlateauHt: marginPlateauTotalHt,
        marginVarnishHt: marginVarnishTotalHt,
        marginReinforcementHt: marginReinforcementTotalHt,
        marginSupplementHt: marginSupplementTotalHt
      };
      if (usesCpcEngine()) cpcPricePending = true;
      updateCpcSubmitState();
      var areaProperty = form.querySelector('[data-brut-price-property="area"]');
      var priceProperty = form.querySelector('[data-brut-price-property="price"]');
      var priceHtProperty = form.querySelector('[data-brut-price-property="price_ht"]');
      var marginProperty = form.querySelector('[data-brut-price-property="margin_eur"]');
      var marginPlateauProperty = form.querySelector('[data-brut-price-property="margin_plateau_eur"]');
      var marginVarnishProperty = form.querySelector('[data-brut-price-property="margin_vernis_eur"]');
      var marginReinforcementProperty = form.querySelector('[data-brut-price-property="margin_raidisseurs_eur"]');
      var marginSupplementProperty = form.querySelector('[data-brut-price-property="margin_supp_eur"]');
      var centsProperty = form.querySelector('[data-brut-price-property="price_cents"]');
      var weightProperty = form.querySelector('[data-brut-price-property="weight"]');

      if (areaProperty) {
        areaProperty.value = surface ? surface.toFixed(3).replace(".", ",") + " m²" : "";
      }

      if (priceProperty) {
        priceProperty.value = formatted;
      }

      if (priceHtProperty) {
        priceHtProperty.value = formatMoney(totalHt);
      }

      if (marginProperty) {
        marginProperty.value = validMarginInputs && marginTotalHt > 0 ? marginTotalHt.toFixed(2) : "";
      }

      if (marginPlateauProperty) {
        marginPlateauProperty.value = validMarginInputs ? marginPlateauTotalHt.toFixed(2) : "";
      }

      if (marginVarnishProperty) {
        marginVarnishProperty.value = validMarginInputs ? marginVarnishTotalHt.toFixed(2) : "";
      }

      if (marginReinforcementProperty) {
        marginReinforcementProperty.value = validMarginInputs ? marginReinforcementTotalHt.toFixed(2) : "";
      }

      if (marginSupplementProperty) {
        marginSupplementProperty.value = validMarginInputs ? marginSupplementTotalHt.toFixed(2) : "";
      }

      if (centsProperty) {
        centsProperty.value = String(cents);
      }

      if (weightProperty) {
        weightProperty.value = weight ? formatWeight(weight) : "";
      }

      if (selectedPrice) {
        selectedPrice.textContent = formatted;
      }
      syncDisplayedTotal(cents / 100);

      if (priceBreakdown) {
        var parts = [];

        if (oversizePercent > 0) {
          parts.push("Majoration grand format incluse (+" + Math.round(oversizePercent) + " %)");
        }

        if (reinforcementTtc) {
          parts.push("Raidisseurs inclus");
        }

        if (cutoutFeeHt) {
          parts.push("Découpe sur mesure incluse");
        }

        if (cornerFeeHt) {
          parts.push("Coins sur mesure inclus");
        }

        priceBreakdown.textContent = parts.length ? parts.join(" · ") : "Prix calculé selon vos dimensions et finitions.";
      }

      return {
        surface: surface,
        total: totalTtc,
        totalHt: totalHt,
        marginHt: marginTotalHt,
        marginPlateauHt: marginPlateauTotalHt,
        marginVarnishHt: marginVarnishTotalHt,
        marginReinforcementHt: marginReinforcementTotalHt,
        marginSupplementHt: marginSupplementTotalHt,
        cents: cents,
        formatted: formatted,
        weight: weight
      };
    }

    function getFieldLabel(input) {
      return input.dataset.summaryLabel || input.getAttribute("aria-label") || input.name || "Champ";
    }

    function getNumericMessage(input, value) {
      var label = getFieldLabel(input);
      var min = input.getAttribute("min");
      var max = input.getAttribute("max");
      var step = input.getAttribute("step");

      if (input.required && input.value.trim() === "") {
        return label + " est obligatoire.";
      }

      if (!Number.isFinite(value)) {
        return label + " doit être un nombre valide.";
      }

      if (min !== "" && min !== null && value < Number(min)) {
        return label + " doit être supérieur ou égal à " + min + ".";
      }

      if (max !== "" && max !== null && value > Number(max) && !isOversizeQuoteFieldValue(input, value)) {
        return label + " doit être inférieur ou égal à " + max + ".";
      }

      if (step && step !== "any") {
        var stepNumber = Number(step);
        var base = min !== "" && min !== null ? Number(min) : 0;
        var ratio = (value - base) / stepNumber;
        var isOnStep = Math.abs(ratio - Math.round(ratio)) < 0.000001;

        if (stepNumber > 0 && !isOnStep) {
          return label + " doit respecter un pas de " + step + ".";
        }
      }

      return "";
    }

    function setFieldState(input, message) {
      var field = input.closest(".brut-configurator__field");
      var error = field ? field.querySelector("[data-error-for]") : null;

      input.setAttribute("aria-invalid", message ? "true" : "false");

      if (field) {
        field.classList.toggle("is-invalid", Boolean(message));
      }

      if (error) {
        if (!error.id) error.id = input.id ? input.id + "-error" : (root.id || "BrutConfigurator") + "-field-error";
        appendAriaReference(input, "aria-describedby", error.id);
        error.textContent = message;
      }
    }

    function validateNumberInput(input) {
      var value = parseUserNumber(input.value);
      var message = getNumericMessage(input, value);
      setFieldState(input, message);
      return message === "";
    }

    function validateForm() {
      var valid = true;
      var firstInvalid = null;
      var numberInputs = form.querySelectorAll("[data-brut-number]");

      numberInputs.forEach(function (input) {
        if (isUnavailable(input) || input.offsetParent === null) {
          return;
        }

        var inputValid = validateNumberInput(input);
        if (!inputValid && !firstInvalid) {
          firstInvalid = input;
        }

        valid = valid && inputValid;
      });

      var cornerMessage = getCornerValidationMessage();
      var cutoutStates = getCutoutStates(getPlanGeometry());
      var invalidCutout = cutoutStates.find(function (state) {
        return Boolean(getCutoutValidationMessage(state));
      });
      var cutoutMessage = invalidCutout ? getCutoutValidationMessage(invalidCutout) : "";

      if (cornerMessage) {
        valid = false;
        firstInvalid = firstInvalid || cornerMode;
      }

      if (cutoutMessage) {
        valid = false;
        firstInvalid = firstInvalid || invalidCutout.item.opening || invalidCutout.item.type;
      }

      if (cutoutConfirmation && !cutoutConfirmation.disabled && !cutoutConfirmation.checked) {
        valid = false;
        cutoutConfirmation.setAttribute("aria-invalid", "true");
        firstInvalid = firstInvalid || cutoutConfirmation;
      } else if (cutoutConfirmation) {
        cutoutConfirmation.setAttribute("aria-invalid", "false");
      }

      if (!valid && firstInvalid) {
        var advanced = firstInvalid.closest("details");
        if (advanced) {
          advanced.open = true;
        }
        firstInvalid.focus({ preventScroll: true });
        firstInvalid.scrollIntoView({ behavior: getScrollBehavior(), block: "center" });
      }

      return valid;
    }

    function fieldValue(input) {
      if (input.tagName === "SELECT") {
        var option = input.options[input.selectedIndex];
        return option ? option.textContent.trim().replace(/\s+/g, " ") : "";
      }

      if (input.type === "checkbox") {
        return input.checked ? input.dataset.summaryValue || input.value || "Oui" : "";
      }

      if (input.type === "radio") {
        return input.checked ? input.value : "";
      }

      if (input.tagName === "TEXTAREA") {
        return input.value.trim();
      }

      if (input.value === "") {
        return "";
      }

      return input.value + (input.dataset.summarySuffix || "");
    }

    function getWidthPrecisionWarning() {
      var width = getNumberBySummaryLabel("Largeur");
      var millimeters = Math.round(width * 10);

      if (!millimeters || millimeters % 5 === 0) {
        return "";
      }

      return "Les dimensions indiquées correspondent aux dimensions lors de la coupe à l’atelier. Le bois massif peut légèrement se dilater ou se contracter selon les saisons et les conditions ambiantes. Si votre projet demande une cote très précise, prévoyez une marge adaptée ou contactez-nous avant commande.";
    }

    function getFlexWarning() {
      var length = getNumberBySummaryLabel("Longueur");
      var width = getNumberBySummaryLabel("Largeur");
      var thickness = toNumber(selectedValueBySummaryLabel("Épaisseur") || selectedValueBySummaryLabel("Epaisseur"));
      var message = "À cette épaisseur et pour ces dimensions, le plateau peut présenter de la souplesse. Prévoyez un bon maintien, des appuis suffisamment rapprochés et une fixation adaptée. En cas de doute, contactez-nous avant commande.";

      if (thickness === 1 && (length > 150 || width > 50)) return message;
      if (thickness === 2 && (length > 200 || width > 70)) return message;
      if (thickness === 2.5 && length > 225) return message;
      if (thickness === 3 && length > 250) return message;
      if (thickness === 3.5 && length > 275) return message;
      if (thickness === 4 && length > 300) return message;

      return "";
    }

    function getOversizeQuoteWarning() {
      return isOversizeQuoteMode()
        ? "Les dimensions sélectionnées nécessitent une validation préalable de l’atelier. Les très grands formats demandent une étude spécifique concernant le choix du bois, le transport, la manutention, la stabilité et les fixations. Nous vous invitons à nous transmettre votre demande afin de vous proposer une solution adaptée."
        : "";
    }

    function syncDimensionWarnings() {
      var widthWarning = getWidthPrecisionWarning();
      var flexWarning = getFlexWarning();
      var oversizeWarning = getOversizeQuoteWarning();

      if (widthPrecisionAdvice) {
        widthPrecisionAdvice.hidden = !widthWarning;
      }

      setAdvice(flexAdvice, flexWarning, "warning");
      setAdvice(oversizeQuoteAdvice, oversizeWarning, "important");
    }

    function updateSummary() {
      var fields = form.querySelectorAll("[data-summary-label]");
      var rows = [];
      var seenRadioGroups = {};

      fields.forEach(function (input) {
        var includeHiddenSummary = input.type === "hidden" && input.dataset.summaryLabel;
        var belongsToEditorPanel = Boolean(input.closest("[data-brut-editor-panel]"));

        if (!includeHiddenSummary && (isUnavailable(input) || (input.offsetParent === null && !belongsToEditorPanel))) {
          return;
        }

        if (input.type === "radio") {
          if (seenRadioGroups[input.name]) {
            return;
          }

          seenRadioGroups[input.name] = true;
          var checked = form.querySelector('input[type="radio"][name="' + input.name.replace(/"/g, '\\"') + '"]:checked');
          if (!checked) {
            return;
          }

          rows.push({
            label: checked.dataset.summaryLabel || input.dataset.summaryLabel,
            value: checked.value
          });
          return;
        }

        var value = fieldValue(input);
        if (!value) {
          return;
        }

        rows.push({
          label: input.dataset.summaryLabel,
          value: value
        });
      });

      var pointWarnings = [getWidthPrecisionWarning(), getFlexWarning(), getOversizeQuoteWarning()].filter(Boolean);

      if (pointWarnings.length) {
        rows.push({
          label: "Point de vigilance",
          value: pointWarnings.filter(function (message, index, list) {
            return list.indexOf(message) === index;
          }).join(" ")
        });
      }

      var weightProperty = form.querySelector('[data-brut-price-property="weight"]');
      if (weightProperty && weightProperty.value) {
        rows.push({
          label: "Poids théorique",
          value: formatWeightSummary(weightProperty.value)
        });
      }

      if (rows.length === 0) {
        var empty = document.createElement("div");
        empty.className = "brut-configurator__summary-empty";
        empty.textContent = emptySummary;
        summaryList.replaceChildren(empty);
        return;
      }

      var fragment = document.createDocumentFragment();
      rows.forEach(function (row) {
        var wrapper = document.createElement("div");
        var term = document.createElement("dt");
        var description = document.createElement("dd");

        wrapper.className = "brut-configurator__summary-row";
        term.textContent = row.label;
        description.textContent = row.value;

        wrapper.appendChild(term);
        wrapper.appendChild(description);
        fragment.appendChild(wrapper);
      });
      summaryList.replaceChildren(fragment);
    }

    function runDynamicRefresh() {
      refreshFrame = null;
      updateConditionalFields();
      syncDynamicNames();
      syncPurchasePath();
      syncVariantPrice();
      syncDesignSettings();
      syncLivePreview();
      syncPriceEstimate();
      scheduleCpcSync();
      updateSummary();
    }

    function scheduleDynamicRefresh() {
      if (refreshFrame !== null) {
        return;
      }
      refreshFrame = window.requestAnimationFrame(runDynamicRefresh);
    }

    form.addEventListener("input", function (event) {
      clearFormMessage();

      if (usesCpcEngine()) {
        cpcPricePending = true;
        updateCpcSubmitState();
      }

      if (event.target.matches("[data-brut-number]")) {
        validateNumberInput(event.target);
      }

      if (event.target === customMaterialInput && customMaterialInput.value.trim()) {
        setFieldState(customMaterialInput, "");
      }

      if (event.target === customFinishInput && customFinishInput.value.trim()) {
        setFieldState(customFinishInput, "");
      }

      scheduleDynamicRefresh();
      scheduleDraftSave();
    });

    form.addEventListener("change", function () {
      clearFormMessage();
      if (usesCpcEngine()) {
        cpcPricePending = true;
        updateCpcSubmitState();
      }
      scheduleDynamicRefresh();
      scheduleDraftSave();
    });

    cornerButtons.forEach(function (button) {
      button.addEventListener("click", function () {
        if (button.disabled) {
          return;
        }

        var mode = getCornerMode();
        var key = button.dataset.brutCorner;
        var nextPressed = button.getAttribute("aria-pressed") !== "true";

        if (mode === "none") {
          guideToCornerModeSelect();
          return;
        }

        if (mode === "half") {
          getEndKeys(getCornerEnd(key)).forEach(function (endKey) {
            setCornerPressed(endKey, nextPressed);
          });
        } else if (mode === "round") {
          getEndKeys(getCornerEnd(key)).forEach(function (endKey) {
            setCornerPressed(endKey, endKey === key ? nextPressed : false);
          });
        } else if (mode === "oval") {
          cornerButtons.forEach(function (candidate) {
            candidate.setAttribute("aria-pressed", nextPressed ? "true" : "false");
          });
        } else {
          setCornerPressed(key, nextPressed);
        }

        clearFormMessage();
        syncDesignSettings();
        syncLivePreview();
        syncPriceEstimate();
        scheduleCpcSync();
        updateSummary();
      });
    });

    function activateEditorPanel(target) {
      editorTabs.forEach(function (candidate) {
        var selected = candidate.dataset.brutEditorTab === target;
        candidate.setAttribute("aria-selected", selected ? "true" : "false");
        candidate.tabIndex = selected ? 0 : -1;
      });

      editorPanels.forEach(function (panel) {
        panel.hidden = panel.dataset.brutEditorPanel !== target;
      });
    }

    function guideToCornerModeSelect() {
      if (advancedSettings) {
        advancedSettings.open = true;
      }

      activateEditorPanel("corners");
      window.requestAnimationFrame(function () {
        var field = cornerMode ? cornerMode.closest(".brut-configurator__field") : null;
        var target = field || cornerMode || advancedSettings;

        if (target) {
          target.scrollIntoView({ behavior: getScrollBehavior(), block: "center" });
        }

        if (cornerMode) {
          cornerMode.focus({ preventScroll: true });
        }

        pulseField(field);
      });
    }

    function pulseChoice(choice) {
      if (!choice) {
        return;
      }

      choice.classList.remove("is-guidance-pulse");
      void choice.offsetWidth;
      choice.classList.add("is-guidance-pulse");
      window.setTimeout(function () {
        choice.classList.remove("is-guidance-pulse");
      }, 1700);
    }

    function pulseField(field) {
      if (!field) {
        return;
      }

      field.classList.remove("is-guidance-pulse");
      void field.offsetWidth;
      field.classList.add("is-guidance-pulse");
      window.setTimeout(function () {
        field.classList.remove("is-guidance-pulse");
      }, 1700);
    }

    function pulseButton(button) {
      if (!button) {
        return;
      }

      button.classList.remove("is-guidance-pulse");
      void button.offsetWidth;
      button.classList.add("is-guidance-pulse");
      window.setTimeout(function () {
        button.classList.remove("is-guidance-pulse");
      }, 2200);
    }

    function focusCutoutControl(item, control) {
      if (!item || !control) {
        return;
      }

      if (advancedSettings) {
        advancedSettings.open = true;
      }

      activateEditorPanel("cutout");

      window.requestAnimationFrame(function () {
        var field = control.closest(".brut-configurator__field") || item.container;
        field.scrollIntoView({ behavior: getScrollBehavior(), block: "center" });
        control.focus({ preventScroll: true });
        if (typeof control.select === "function") {
          control.select();
        }
      });
    }

    editorTabs.forEach(function (tab) {
      tab.addEventListener("click", function () {
        activateEditorPanel(tab.dataset.brutEditorTab);
      });
      tab.addEventListener("keydown", function (event) {
        var currentIndex = editorTabs.indexOf(tab);
        var nextIndex = currentIndex;

        if (event.key === "ArrowRight") nextIndex = (currentIndex + 1) % editorTabs.length;
        else if (event.key === "ArrowLeft") nextIndex = (currentIndex - 1 + editorTabs.length) % editorTabs.length;
        else if (event.key === "Home") nextIndex = 0;
        else if (event.key === "End") nextIndex = editorTabs.length - 1;
        else return;

        event.preventDefault();
        var nextTab = editorTabs[nextIndex];
        activateEditorPanel(nextTab.dataset.brutEditorTab);
        nextTab.focus();
      });
    });

    cutoutItems.forEach(function (item) {
      [
        { key: "x", button: item.buttonX, control: item.x },
        { key: "y", button: item.buttonY, control: item.y },
        { key: "opening", button: item.buttonOpening, control: item.opening },
        { key: "depth", button: item.buttonDepth, control: item.depth }
      ].forEach(function (binding) {
        if (!binding.control) {
          return;
        }

        [binding.button, item.legendButtons[binding.key]].forEach(function (target) {
          if (!target) return;
          target.addEventListener("click", function () {
            focusCutoutControl(item, binding.control);
          });
        });
        var hit = item.measureHits[binding.key];
        if (hit) {
          hit.addEventListener("keydown", function (event) {
            if (event.key === "Enter" || event.key === " ") {
              event.preventDefault();
              focusCutoutControl(item, binding.control);
            }
          });
        }
      });
    });

    if (planSvg) {
      planSvg.addEventListener("click", function (event) {
        var nearest = null;
        var distance = 24;

        cutoutItems.forEach(function (item) {
          if (!item.guides || item.guides.hasAttribute("hidden")) return;
          [
            { key: "x", control: item.x },
            { key: "y", control: item.y },
            { key: "opening", control: item.opening },
            { key: "depth", control: item.depth }
          ].forEach(function (binding) {
            var path = item.measureHits[binding.key];
            if (!path || !path.getAttribute("d") || !binding.control) return;
            var box = path.getBoundingClientRect();
            var dx = Math.max(box.left - event.clientX, 0, event.clientX - box.right);
            var dy = Math.max(box.top - event.clientY, 0, event.clientY - box.bottom);
            var candidateDistance = Math.hypot(dx, dy);
            if (candidateDistance < distance) {
              nearest = { item: item, control: binding.control };
              distance = candidateDistance;
            }
          });
        });

        if (nearest) focusCutoutControl(nearest.item, nearest.control);
      });
    }

    if (reinforcementAdviceAction) {
      reinforcementAdviceAction.addEventListener("click", function () {
        if (advancedSettings) {
          advancedSettings.open = true;
        }
        activateEditorPanel("reinforcements");
        window.requestAnimationFrame(function () {
          var panel = root.querySelector('[data-brut-editor-panel="reinforcements"]');
          if (panel) {
            panel.scrollIntoView({ behavior: getScrollBehavior(), block: "center" });
            var recommendedChoice = Array.prototype.slice.call(panel.querySelectorAll('input[type="radio"]')).find(function (input) {
              var value = normalizeValue(input.value);
              return value && value.indexOf("aucun") === -1 && value.indexOf("sans raidisseur") === -1;
            });
            if (recommendedChoice) {
              recommendedChoice.focus({ preventScroll: true });
              pulseChoice(recommendedChoice.closest(".brut-configurator__choice"));
            }
          }
        });
      });
    }

    if (edgeVarnishAdviceAction) {
      edgeVarnishAdviceAction.addEventListener("click", function () {
        var brokenEdgeChoice = Array.prototype.slice.call(form.querySelectorAll('input[type="radio"][data-summary-label]')).find(function (input) {
          return normalizeValue(input.dataset.summaryLabel).indexOf("aretes") !== -1 && normalizeValue(input.value).indexOf("cassees") !== -1;
        });

        if (!brokenEdgeChoice) {
          return;
        }

        var choice = brokenEdgeChoice.closest(".brut-configurator__choice");
        if (choice) choice.scrollIntoView({ behavior: getScrollBehavior(), block: "center" });
        brokenEdgeChoice.focus({ preventScroll: true });
        pulseChoice(choice);
      });
    }

    function getPrimaryQuoteActionButton() {
      if (customQuoteButton && !customQuoteButton.hidden) {
        return customQuoteButton;
      }

      if (validationQuoteButton && !validationQuoteButton.hidden) {
        return validationQuoteButton;
      }

      return customQuoteButton || validationQuoteButton;
    }

    function scrollToQuoteAction() {
      var target = getPrimaryQuoteActionButton();

      if (!target) {
        return;
      }

      target.scrollIntoView({ behavior: getScrollBehavior(), block: "center" });
      window.setTimeout(function () {
        target.focus({ preventScroll: true });
        pulseButton(target);
      }, 420);
    }

    quoteShortcutButtons.forEach(function (button) {
      button.addEventListener("click", scrollToQuoteAction);
    });

    if (summaryQuoteButton) {
      summaryQuoteButton.addEventListener("click", function () {
        var mode = isQuoteOnlyMode() ? "custom" : "validation";
        openQuoteModal(mode, summaryQuoteButton);
      });
    }

    if (summaryPriceProblemButton) {
      summaryPriceProblemButton.addEventListener("click", function () {
        openQuoteModal("validation", summaryPriceProblemButton);
      });
    }

    if (shareButton) {
      shareButton.addEventListener("click", shareCurrentConfiguration);
    }

    if (resetButton) {
      resetButton.addEventListener("click", resetCurrentConfiguration);
    }

    if (shareLinkInput) {
      shareLinkInput.addEventListener("focus", function () {
        shareLinkInput.select();
      });
    }

    [customQuoteButton, validationQuoteButton].concat(sampleQuoteButtons).forEach(function (button) {
      if (!button) return;
      button.addEventListener("click", function () {
        openQuoteModal(button.dataset.brutOpenQuote, button);
      });
    });

    root.querySelectorAll("[data-brut-close-quote]").forEach(function (button) {
      button.addEventListener("click", closeQuoteModal);
    });

    if (quoteModal) {
      quoteModal.addEventListener("cancel", function () {
        document.documentElement.classList.remove("brut-quote-modal-open");
      });
      quoteModal.addEventListener("click", function (event) {
        if (event.target === quoteModal) closeQuoteModal();
      });
    }

    if (quoteFileInput) {
      quoteFileInput.addEventListener("change", function () {
        quoteShopifySubmissionReady = false;
        quoteFileInput.disabled = false;
        quoteAttachmentUrl = "";
        if (quoteAttachmentUrlInput) quoteAttachmentUrlInput.value = "";
        validateQuoteFile();
      });
    }

    if (quoteRemoveFile) {
      quoteRemoveFile.addEventListener("click", function () {
        quoteShopifySubmissionReady = false;
        quoteAttachmentUrl = "";
        if (quoteAttachmentUrlInput) quoteAttachmentUrlInput.value = "";
        if (quoteFileInput) {
          quoteFileInput.disabled = false;
          quoteFileInput.value = "";
        }
        if (quoteFileSelected) quoteFileSelected.hidden = true;
        if (quoteFileName) quoteFileName.textContent = "";
        if (quoteError) quoteError.textContent = "";
        syncQuoteMessage();
      });
    }

    [quoteExtraComment, sampleAddressInput, sampleProjectInput].forEach(function (input) {
      if (input) input.addEventListener("input", syncQuoteMessage);
    });

    if (quoteForm) {
      quoteForm.addEventListener("submit", async function (event) {
        if (quoteShopifySubmissionReady && quoteAttachmentUrl) {
          // Deuxième passage : le fichier est déjà hébergé par Apippa.
          // Shopify et hCaptcha doivent maintenant traiter la soumission.
          return;
        }

        syncQuoteMessage();
        if (!validateQuoteFile()) {
          event.preventDefault();
          event.stopImmediatePropagation();
          return;
        }

        var endpoint = quoteModal ? String(quoteModal.dataset.brutQuoteEndpoint || "").trim() : "";
        var hasAttachment = Boolean(quoteFileInput && quoteFileInput.files && quoteFileInput.files.length);

        if (!endpoint) {
          if (!hasAttachment) {
            return;
          }

          event.preventDefault();
          // Shopify hCaptcha écoute aussi submit sans tenir compte de
          // defaultPrevented. Bloquer ce premier passage avant l'upload évite
          // qu'il envoie le formulaire sans l'URL produite par Apippa.
          event.stopImmediatePropagation();
          if (quoteSendButton) quoteSendButton.disabled = true;
          if (quoteError) quoteError.textContent = "";
          var stopApippaUploadLoading = startLoadingMessage("quote");
          var nativeSubmissionStarted = false;

          try {
            quoteAttachmentUrl = await uploadQuoteFileThroughApippa(quoteFileInput.files[0]);
            syncQuoteMessage();
            resumeQuoteSubmissionThroughShopify();
            nativeSubmissionStarted = true;
            window.setTimeout(function () {
              if (quoteShopifySubmissionReady && quoteSendButton) quoteSendButton.disabled = false;
            }, 8000);
          } catch (error) {
            quoteShopifySubmissionReady = false;
            quoteAttachmentUrl = "";
            if (quoteAttachmentUrlInput) quoteAttachmentUrlInput.value = "";
            if (quoteFileInput) quoteFileInput.disabled = false;
            syncQuoteMessage();
            if (quoteError) {
              quoteError.textContent = error && error.message === "apippa_upload_timeout"
                ? "L’envoi du fichier a dépassé une minute. Vérifiez votre connexion puis réessayez."
                : error && error.message === "shopify_request_submit_unavailable"
                  ? "La validation anti-spam Shopify n’a pas pu démarrer. Actualisez la page puis réessayez."
                  : "La pièce jointe n’a pas pu être chargée par Apippa. Réessayez dans quelques instants ou retirez le fichier pour envoyer la demande sans pièce jointe.";
            }
          } finally {
            stopApippaUploadLoading();
            if (!nativeSubmissionStarted && quoteFileInput) quoteFileInput.disabled = false;
            if (!nativeSubmissionStarted && quoteSendButton) quoteSendButton.disabled = false;
          }
          return;
        }

        event.preventDefault();
        // Un endpoint multipart remplace l'envoi Shopify natif : hCaptcha ne
        // doit donc pas relancer le formulaire pendant la requête asynchrone.
        event.stopImmediatePropagation();
        if (quoteSendButton) quoteSendButton.disabled = true;
        if (quoteError) quoteError.textContent = "";
        var stopLoading = startLoadingMessage("quote");

        try {
          var response = await submitQuoteToEndpoint(endpoint);
          if (!response.ok) throw new Error("quote_endpoint_failed");
          showQuoteConfirmation();
        } catch (error) {
          if (quoteError) quoteError.textContent = error && error.name === "AbortError"
            ? "L’envoi a dépassé 20 secondes. Vérifiez votre connexion puis réessayez."
            : "La demande n’a pas pu être envoyée. Vérifiez votre connexion ou réessayez dans quelques instants.";
        } finally {
          stopLoading();
          if (quoteSendButton) quoteSendButton.disabled = false;
        }
      }, true);
    }

    form.addEventListener("submit", function (event) {
      if (refreshFrame !== null) {
        window.cancelAnimationFrame(refreshFrame);
        refreshFrame = null;
      }
      updateConditionalFields();
      syncDynamicNames();
      syncDesignSettings();
      syncLivePreview();
      syncPriceEstimate();
      updateSummary();

      if (isQuoteOnlyMode()) {
        event.preventDefault();
        if (formMessage) {
          formMessage.textContent = getOversizeQuoteWarning() || "Cette configuration nécessite une demande de devis et ne peut pas être ajoutée au panier.";
        }
      } else if (!validateForm()) {
        event.preventDefault();

        if (formMessage) {
          formMessage.textContent = "Vérifiez les champs indiqués avant d'ajouter au panier.";
        }
      } else if (usesCpcEngine()) {
        event.preventDefault();
        submitThroughCpc();
      }
    });

    var restoredFromShare = restoreSharedConfiguration();
    if (!restoredFromShare) {
      restoreConfigurationDraft();
    }
    syncVariantPrice();
    syncStickyOffset();
    window.addEventListener("resize", syncStickyOffset, { passive: true });
    updateConditionalFields();
    syncDynamicNames();
    syncPurchasePath();
    syncDesignSettings();
    syncLivePreview();
    syncPriceEstimate();
    updateSummary();
    if (restoredFromShare) {
      setShareStatus("Configuration partagée chargée. Vous pouvez encore la modifier avant de commander.", false, true);
    }
    connectCpcEngine();

    root.brutConfiguratorCleanup = function () {
      window.removeEventListener("resize", syncStickyOffset);
      if (cpcPriceObserver) cpcPriceObserver.disconnect();
      window.clearTimeout(cpcSyncTimer);
      window.clearTimeout(cpcPriceTimer);
      window.clearTimeout(cpcSubmissionTimeout);
      window.clearTimeout(draftSaveTimer);
      window.clearTimeout(shareStatusTimer);
      window.clearTimeout(loadingTimer);
      window.clearInterval(loadingInterval);
      if (document.body) document.body.classList.remove("brut-cart-pending");
      if (refreshFrame !== null) window.cancelAnimationFrame(refreshFrame);
      root.dataset.brutReady = "false";
    };

    if (quoteModal && quoteConfirmation && !quoteConfirmation.hidden) {
      if (typeof quoteModal.showModal === "function") quoteModal.showModal();
      else quoteModal.setAttribute("open", "");
      document.documentElement.classList.add("brut-quote-modal-open");
    }
  }

  function initAll(context) {
    var scope = context || document;
    scope.querySelectorAll(ROOT_SELECTOR).forEach(function (root) {
      try {
        initConfigurator(root);
      } catch (error) {
        var button = root.querySelector("[data-brut-submit]");
        var message = root.querySelector("[data-brut-form-message]");

        root.dataset.brutReady = "error";

        if (button) {
          button.disabled = true;
          button.setAttribute("aria-disabled", "true");
        }

        if (message) {
          message.textContent = "Le configurateur n’a pas pu être initialisé. Aucun ajout au panier n’est autorisé.";
        }

        if (window.console && typeof window.console.error === "function") {
          window.console.error("Brut configurator initialization failed", error);
        }
      }
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", function () {
      initAll(document);
    });
  } else {
    initAll(document);
  }

  document.addEventListener("shopify:section:load", function (event) {
    initAll(event.target);
  });

  document.addEventListener("shopify:section:unload", function (event) {
    event.target.querySelectorAll(ROOT_SELECTOR).forEach(function (root) {
      if (typeof root.brutConfiguratorCleanup === "function") root.brutConfiguratorCleanup();
    });
  });
})();
